(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("fs-extra"), require("try-require"), require("chalk"), require("webpack"), require("copy-webpack-plugin"), require("inquirer"), require("cli-spinner"), require("chokidar"), require("on-build-webpack"), require("regenerator-runtime"), require("glob"), require("resolve-global"), require("ps-tree"), require("beepbeep"), require("get-cursor-position"), require("filesize"), require("my-ip"), require("depcheck"), require("package-json"), require("semver"), require("node-fetch"), require("node-pty"), require("clean-webpack-plugin"), require("colors"), require("copy-paste"), require("webpack-merge"));
	else if(typeof define === 'function' && define.amd)
		define(["fs-extra", "try-require", "chalk", "webpack", "copy-webpack-plugin", "inquirer", "cli-spinner", "chokidar", "on-build-webpack", "regenerator-runtime", "glob", "resolve-global", "ps-tree", "beepbeep", "get-cursor-position", "filesize", "my-ip", "depcheck", "package-json", "semver", "node-fetch", "node-pty", "clean-webpack-plugin", "colors", "copy-paste", "webpack-merge"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("fs-extra"), require("try-require"), require("chalk"), require("webpack"), require("copy-webpack-plugin"), require("inquirer"), require("cli-spinner"), require("chokidar"), require("on-build-webpack"), require("regenerator-runtime"), require("glob"), require("resolve-global"), require("ps-tree"), require("beepbeep"), require("get-cursor-position"), require("filesize"), require("my-ip"), require("depcheck"), require("package-json"), require("semver"), require("node-fetch"), require("node-pty"), require("clean-webpack-plugin"), require("colors"), require("copy-paste"), require("webpack-merge")) : factory(root["fs-extra"], root["try-require"], root["chalk"], root["webpack"], root["copy-webpack-plugin"], root["inquirer"], root["cli-spinner"], root["chokidar"], root["on-build-webpack"], root["regenerator-runtime"], root["glob"], root["resolve-global"], root["ps-tree"], root["beepbeep"], root["get-cursor-position"], root["filesize"], root["my-ip"], root["depcheck"], root["package-json"], root["semver"], root["node-fetch"], root["node-pty"], root["clean-webpack-plugin"], root["colors"], root["copy-paste"], root["webpack-merge"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_21__, __WEBPACK_EXTERNAL_MODULE_58__, __WEBPACK_EXTERNAL_MODULE_61__, __WEBPACK_EXTERNAL_MODULE_80__, __WEBPACK_EXTERNAL_MODULE_83__, __WEBPACK_EXTERNAL_MODULE_87__, __WEBPACK_EXTERNAL_MODULE_88__, __WEBPACK_EXTERNAL_MODULE_131__, __WEBPACK_EXTERNAL_MODULE_136__, __WEBPACK_EXTERNAL_MODULE_137__, __WEBPACK_EXTERNAL_MODULE_138__, __WEBPACK_EXTERNAL_MODULE_147__, __WEBPACK_EXTERNAL_MODULE_149__, __WEBPACK_EXTERNAL_MODULE_151__, __WEBPACK_EXTERNAL_MODULE_152__, __WEBPACK_EXTERNAL_MODULE_154__, __WEBPACK_EXTERNAL_MODULE_155__, __WEBPACK_EXTERNAL_MODULE_156__, __WEBPACK_EXTERNAL_MODULE_158__, __WEBPACK_EXTERNAL_MODULE_162__, __WEBPACK_EXTERNAL_MODULE_164__, __WEBPACK_EXTERNAL_MODULE_169__, __WEBPACK_EXTERNAL_MODULE_170__, __WEBPACK_EXTERNAL_MODULE_172__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 98);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("path");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(1);
var ctx = __webpack_require__(13);
var hide = __webpack_require__(16);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(105), __esModule: true };

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(46)('wks');
var uid = __webpack_require__(34);
var Symbol = __webpack_require__(3).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(131);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(4);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_8__;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(11);
var IE8_DOM_DEFINE = __webpack_require__(64);
var toPrimitive = __webpack_require__(41);
var dP = Object.defineProperty;

exports.f = __webpack_require__(14) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(23);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(19)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(18), __webpack_require__(21), __webpack_require__(147), __webpack_require__(59), __webpack_require__(148), __webpack_require__(149), __webpack_require__(150)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('babel-runtime/core-js/object/assign'), require('chalk'), require('beepbeep'), require('child_process'), require('readline'), require('get-cursor-position'), require('stream'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.assign, global.chalk, global.beepbeep, global.child_process, global.readline, global.getCursorPosition, global.stream);
        global.terminalUtils = mod.exports;
    }
})(this, function (exports, _assign, _chalk, _beepbeep, _child_process, _readline, _getCursorPosition2, _require) {
    'use strict';

    exports.__esModule = true;
    exports.symbols = exports.beep = exports.resetEffects = undefined;
    exports.getLineSize = getLineSize;
    exports.getLineTop = getLineTop;
    exports.getLine = getLine;
    exports.getLineBottom = getLineBottom;
    exports.getFilledLine = getFilledLine;
    exports.statusLine = statusLine;
    exports.listItem = listItem;
    exports.item = item;
    exports.title = title;
    exports.join = join;
    exports.list = list;
    exports.logMessage = logMessage;
    exports.infoMessage = infoMessage;
    exports.getCursorPosition = getCursorPosition;
    exports.moveTo = moveTo;
    exports.moveFor = moveFor;
    exports.clearLine = clearLine;
    exports.warnMessage = warnMessage;
    exports.errorMessage = errorMessage;
    exports.reportMessage = reportMessage;
    exports.timingReport = timingReport;
    exports.cleanColorCodes = cleanColorCodes;
    exports.clearTerminal = clearTerminal;
    exports.headerMessage = headerMessage;

    var _assign2 = _interopRequireDefault(_assign);

    var _chalk2 = _interopRequireDefault(_chalk);

    var _beepbeep2 = _interopRequireDefault(_beepbeep);

    var _readline2 = _interopRequireDefault(_readline);

    var _getCursorPosition3 = _interopRequireDefault(_getCursorPosition2);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var Writable = _require.Writable;


    var resetEffects = '\x1B[0m';
    var symbols = {
        error: '[✖] ',
        warn: '[!] ',
        info: '[i] ',
        elypsis: '…',
        clock: '[◷] ',
        report: '[Ξ] '
    };

    exports.resetEffects = resetEffects;
    exports.beep = _beepbeep2.default;
    exports.symbols = symbols;
    function getLineSize() {
        return process.stdout.columns - 2;
    }

    function getLineTop() {
        return '\u203E' + ''.padEnd(getLineSize(), '‾') + '\u203E';
    }

    function getLine() {
        return '_' + ''.padEnd(getLineSize(), '_') + '_';
    }

    function getLineBottom() {
        return '_' + ''.padEnd(getLineSize(), '_') + '_\n';
    }

    function getFilledLine(content) {
        var ret = '';
        var lineSize = getLineSize();
        content = content = content.match(new RegExp('(\n)|(.{0,' + lineSize + '})', 'g')).filter(function (item) {
            return item !== '\n' && item.length > 0;
        });
        content.forEach(function (line) {
            ret += ' ' + line.padEnd(lineSize, ' ') + ' \n';
        });
        return '\n' + ret;
    }

    function statusLine(status, content) {
        var effect = status === 1 || status === 'ok' ? _chalk2.default.bgGreen.bold.white : status === 2 || status === 'warning' ? _chalk2.default.bgYellow.bold.black : _chalk2.default.bgRed.bold.white;

        content = getFilledLine(content);

        return '' + resetEffects + effect('' + ''.padEnd(getLineSize() + 2) + ('' + content) + ('' + ''.padEnd(getLineSize() + 2)));
    }

    function listItem(item) {
        var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

        return '    ' + sep + ' ' + item + '\n';
    }

    function item(itemLeft) {
        var itemRight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        var defaultOpts = {
            itemRightSize: 15,
            separator: '.',
            showEnd: true
        };
        opts = (0, _assign2.default)({}, defaultOpts, opts);
        // we show only the endinf part of the string
        var leftItemLimit = getLineSize() - opts.itemRightSize;
        itemLeft = itemLeft.toString();
        if (opts.showEnd) {
            if (itemLeft.length > leftItemLimit) {
                itemLeft = symbols.elypsis + itemLeft.toString().substr(itemLeft.length - leftItemLimit - 1);
            }
        } else {
            // we show the first part of the string
            if (itemLeft.length > leftItemLimit) {
                itemLeft = itemLeft.toString().substr(0, leftItemLimit - 1) + symbols.elypsis;
            }
        }
        itemRight = itemRight.toString().substr(0, opts.itemRightSize);
        var dots = ''.padEnd(getLineSize() - itemRight.length - itemLeft.length, opts.separator);
        dots = _chalk2.default.gray(dots);

        var line = ' ' + itemLeft + dots + itemRight + '\n';
        return line;
    }

    function title(title) {
        return _chalk2.default.bold('\n\n' + title + '\n');
    }

    function join(list, extraLine) {
        extraLine = extraLine ? '\n' : '';
        return '\n' + list.join('\n' + extraLine) + extraLine;
    }

    function list(list) {
        var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

        list = Array.isArray(list) ? list : [list];
        return '\n    ' + sep + ' ' + list.join('\n    ' + sep + ' ');
    }

    function logMessage(msg) {
        return '\n' + _chalk2.default.bold(symbols.report) + msg;
    }

    function infoMessage(msg) {
        var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        counter = counter > 0 ? ' ' + counter + ') ' : '';
        return '\n' + _chalk2.default.bold.blue(symbols.info + counter) + msg;
    }

    function getCursorPosition() {
        return _getCursorPosition3.default.sync();
    }

    function moveTo(where, data) {
        switch (where) {
            case 'lineStart':
                _readline2.default.cursorTo(process.stdout, 0);
                break;
            case 'lineEnd':
                _readline2.default.cursorTo(process.stdout, getLineSize());
                break;
            case 'position':
                // readline.cursorTo(process.stdout, getLineSize())
                process.stdout.write('\x1b[' + data.row + ';' + data.col + 'H');
                break;
            default:
                break;
        }
    }

    function moveFor(row, col) {
        if (row) {
            process.stdout.write('\x1b[' + Math.abs(row) + row > 0 ? 'B' : 'A');
        }
        if (col) {
            process.stdout.write('\x1b[' + Math.abs(col) + col > 0 ? 'C' : 'D');
        }
    }

    function clearLine() {
        var whole = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if (whole) {
            moveTo('lineStart');
        }
        process.stdout.write('\x1b[K');
    }

    function warnMessage(msg) {
        var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        counter = counter > 0 ? ' ' + counter + ') ' : '';
        return '\n' + _chalk2.default.bold.yellow(symbols.warn + counter) + msg;
    }

    function errorMessage(msg) {
        var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        counter = counter > 0 ? ' ' + counter + ') ' : '';
        return '\n' + _chalk2.default.bold.red(symbols.error + counter) + msg;
    }

    function reportMessage(msg) {
        return _chalk2.default.magenta.bold(symbols.report) + msg;
    }

    function timingReport(msg) {
        return _chalk2.default.magenta.bold(symbols.clock) + msg;
    }

    function cleanColorCodes(msg) {
        return msg.replace(/\[e?\d+m/g, '');
    }

    function clearTerminal() {
        // process.stdout.clearScreenDown()
        process.stdout.write('\x1B[2J\x1B[0f\x1B[0;0H');
    }

    function headerMessage(msgs) {
        // msgs must be an array
        msgs = Array.isArray(msgs) ? msgs : [msgs];

        var info = _chalk2.default.bgBlue.white;
        var finalMsg = info(getLineTop());

        msgs.forEach(function (msg) {
            // removing color codes
            var rawMsg = cleanColorCodes(msg);
            var spacer = getLineSize() + 3 - rawMsg.length;
            // filling the line
            msg = ' ' + msg + ''.padEnd(spacer, ' ').substr(0, getLineSize()) + '';
            finalMsg += info(msg);
        });

        finalMsg += info(getLineBottom());
        return '\n\n' + finalMsg;
    }
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(10);
var createDesc = __webpack_require__(24);
module.exports = __webpack_require__(14) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__dirname) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6), __webpack_require__(79), __webpack_require__(4), __webpack_require__(32), __webpack_require__(7), __webpack_require__(136), __webpack_require__(0), __webpack_require__(8), __webpack_require__(137), __webpack_require__(138)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/core-js/array/from'), require('babel-runtime/core-js/promise'), require('babel-runtime/core-js/set'), require('babel-runtime/helpers/asyncToGenerator'), require('glob'), require('path'), require('fs-extra'), require('resolve-global'), require('ps-tree'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.from, global.promise, global.set, global.asyncToGenerator, global.glob, global.path, global.fsExtra, global.resolveGlobal, global.psTree);
    global.utils = mod.exports;
  }
})(this, function (exports, _regenerator, _from, _promise, _set, _asyncToGenerator2, _glob, _path, _fsExtra, _resolveGlobal, psTree) {
  'use strict';

  exports.__esModule = true;
  exports.FURTHER_REF = exports.FURTHER_PATH = exports.DEFAULT_DEV_SERVER_PORT = exports.ensureExists = exports.copyFiles = exports.getEntries = exports.fileExists = exports.readFile = exports.thereIsAnyFileMatching = undefined;
  exports.killProcessTree = killProcessTree;

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _from2 = _interopRequireDefault(_from);

  var _promise2 = _interopRequireDefault(_promise);

  var _set2 = _interopRequireDefault(_set);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _glob2 = _interopRequireDefault(_glob);

  var _path2 = _interopRequireDefault(_path);

  var _fsExtra2 = _interopRequireDefault(_fsExtra);

  var _resolveGlobal2 = _interopRequireDefault(_resolveGlobal);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var DEFAULT_DEV_SERVER_PORT = 9091;
  /* the string bellow will be replaced during build */
  // const FURTHER_PATH = "furtherInstallationPath";

  var FURTHER_PATH = _resolveGlobal2.default.silent('@nasc/furtherjs') || _resolveGlobal2.default.silent('furtherjs');

  if (!FURTHER_PATH) {
    exports.FURTHER_PATH = FURTHER_PATH = process.cwd();
  }

  // let FURTHER_PATH = resolveGlobal.silent('furtherjs') || process.cwd();
  exports.FURTHER_PATH = FURTHER_PATH = FURTHER_PATH.replace('dist/index.js', '');
  var FURTHER_REF = _path2.default.resolve(FURTHER_PATH, 'node_modules') + '/';

  var thereIsAnyFileMatching = exports.thereIsAnyFileMatching = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(pwd) {
      var extensions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var patterns, sPatterns, foundPatterns;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // enforces the argument is an array
              // and adds the list to a Set object
              patterns = Array.isArray(extensions) ? extensions : [extensions];
              sPatterns = new _set2.default(patterns);
              foundPatterns = new _set2.default();
              return _context.abrupt('return', new _promise2.default(function (resolve, reject) {
                var Glob = _glob2.default.Glob;
                options.silent = options.silent || true;
                options.nonull = options.nonull || true;
                options.nosort = options.nosort || true;
                options.cwd = pwd;
                options.path = options.path || '';

                var pattern = '{' + options.path + '**/*' + patterns.join(',' + options.path + '**/*') + '}';

                delete options.path;
                var g = new Glob(pattern, options);

                g.on('match', function (path) {
                  var ext = (path.match(/\.[^\.]+$/) || [])[0];
                  foundPatterns.add(ext);

                  if (foundPatterns.size === sPatterns.size) {
                    // all patterns have been found at least once
                    // therefore, we can stop looking for them
                    g.abort();
                    resolve((0, _from2.default)(foundPatterns));
                  }
                });
                g.on('end', function () {
                  // if reached the end, resolve with the list of the found ones
                  resolve((0, _from2.default)(foundPatterns));
                });
                g.on('error', function (err) {
                  reject(err);
                });
              }));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function thereIsAnyFileMatching(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var readFile = exports.readFile = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(file) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'utf8';
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new _promise2.default(function (resolve, reject) {
                _fsExtra2.default.readFile(file, type, function (err, data) {
                  if (err) {
                    reject(err);
                  } else {
                    resolve(data);
                  }
                });
              }));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function readFile(_x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  var fileExists = exports.fileExists = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(file) {
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', new _promise2.default(function (resolve) {
                _fsExtra2.default.open(file, 'r', function (err, fd) {
                  if (err) {
                    if (err.code === 'ENOENT') {
                      resolve(false);
                    } else {
                      resolve(false);
                    }
                  }
                  resolve(fd);
                });
              }));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    return function fileExists(_x6) {
      return _ref3.apply(this, arguments);
    };
  }();

  function copyFiles(files, from, to, transform) {
    var _this = this;

    var promisesList = files.map(function (file) {
      var fromFile = _path2.default.resolve(from, file);
      var toFile = _path2.default.resolve(to, file);
      if (transform) {
        return new _promise2.default(function () {
          var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(resolve, reject) {
            var content;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _fsExtra2.default.readFile(fromFile, 'utf8');

                  case 2:
                    content = _context4.sent;
                    _context4.prev = 3;

                    content = transform(content);
                    _context4.next = 7;
                    return _fsExtra2.default.writeFile(toFile, content);

                  case 7:
                    _context4.next = 12;
                    break;

                  case 9:
                    _context4.prev = 9;
                    _context4.t0 = _context4['catch'](3);

                    reject('Failed copying:\nFrom: "' + fromFile + '"\nTo: ' + toFile + '\n' + _context4.t0);

                  case 12:
                    resolve();

                  case 13:
                  case 'end':
                    return _context4.stop();
                }
              }
            }, _callee4, _this, [[3, 9]]);
          }));

          return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
          };
        }());
      } else {
        // plain copy
        return _fsExtra2.default.copyFile(fromFile, toFile);
      }
    });
    return _promise2.default.all(promisesList);
  }

  function getEntries(SRC_PATH, pattern) {
    var entries = {};
    var rx = new RegExp('(' + SRC_PATH + '/client/|.[a-z0-9]+$)', 'g');

    _glob2.default.sync(pattern).forEach(function (file) {
      entries[file.replace(rx, '')] = _path2.default.join(__dirname, file);
    });

    return entries;
  }

  function ensureExists(path) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var sync = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var now = Date.now() / 1000;
    var then = now - delay;

    if (sync) {
      _fsExtra2.default.ensureFileSync(path);
      _fsExtra2.default.utimesSync(path, then, then);
    } else {
      return new _promise2.default(function (resolve) {
        _fsExtra2.default.ensureFile(path).then(function (_) {
          _fsExtra2.default.utimesSync(path, then, then);
          resolve();
        });
      });
    }
  }

  function killProcessTree(pid, signal) {
    signal = signal || 'SIGKILL';

    return new _promise2.default(function (resolve, reject) {
      psTree(pid, function (err, children) {
        [pid].concat(children.map(function (p) {
          return p.PID;
        })).forEach(function (tpid) {
          try {
            process.kill(tpid, signal);
          } catch (ex) {
            reject(ex);
          }
        });
        resolve();
      });
    });
    // var killTree = true;
    // if(killTree) {

    // } else {
    //     try { process.kill(pid, signal) }
    //     catch (ex) { }
    //     callback()
    // }
  }

  exports.getEntries = getEntries;
  exports.copyFiles = copyFiles;
  exports.ensureExists = ensureExists;
  exports.DEFAULT_DEV_SERVER_PORT = DEFAULT_DEV_SERVER_PORT;
  exports.FURTHER_PATH = FURTHER_PATH;
  exports.FURTHER_REF = FURTHER_REF;
});
/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(100), __esModule: true };

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_21__;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(42);
var defined = __webpack_require__(43);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(65);
var enumBugKeys = __webpack_require__(47);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(43);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(106)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(50)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(10).f;
var has = __webpack_require__(20);
var TAG = __webpack_require__(5)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(13);
var call = __webpack_require__(69);
var isArrayIter = __webpack_require__(70);
var anObject = __webpack_require__(11);
var toLength = __webpack_require__(33);
var getIterFn = __webpack_require__(53);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(117), __esModule: true };

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(44);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(11);
var dPs = __webpack_require__(108);
var enumBugKeys = __webpack_require__(47);
var IE_PROTO = __webpack_require__(45)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(40)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(67).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(110);
var global = __webpack_require__(3);
var hide = __webpack_require__(16);
var Iterators = __webpack_require__(29);
var TO_STRING_TAG = __webpack_require__(5)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(140), __esModule: true };

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
var document = __webpack_require__(3).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(9);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(26);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(46)('keys');
var uid = __webpack_require__(34);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 48 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 49 */
/***/ (function(module, exports) {



/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(36);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(66);
var hide = __webpack_require__(16);
var has = __webpack_require__(20);
var Iterators = __webpack_require__(29);
var $iterCreate = __webpack_require__(107);
var setToStringTag = __webpack_require__(30);
var getPrototypeOf = __webpack_require__(109);
var ITERATOR = __webpack_require__(5)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(26);
var TAG = __webpack_require__(5)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(51);
var ITERATOR = __webpack_require__(5)('iterator');
var Iterators = __webpack_require__(29);
module.exports = __webpack_require__(1).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(23);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(16);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(34)('meta');
var isObject = __webpack_require__(9);
var has = __webpack_require__(20);
var setDesc = __webpack_require__(10).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(19)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_58__;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = require("child_process");

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(18), __webpack_require__(6), __webpack_require__(39), __webpack_require__(32), __webpack_require__(4), __webpack_require__(7), __webpack_require__(161), __webpack_require__(15), __webpack_require__(83), __webpack_require__(0), __webpack_require__(21), __webpack_require__(8), __webpack_require__(17), __webpack_require__(85), __webpack_require__(86)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/regenerator'), require('babel-runtime/core-js/object/keys'), require('babel-runtime/core-js/set'), require('babel-runtime/core-js/promise'), require('babel-runtime/helpers/asyncToGenerator'), require('./installer'), require('./terminal-utils'), require('cli-spinner'), require('path'), require('chalk'), require('fs-extra'), require('./utils'), require('os'), require('./technologies/deps.js'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.assign, global.regenerator, global.keys, global.set, global.promise, global.asyncToGenerator, global.installer, global.terminalUtils, global.cliSpinner, global.path, global.chalk, global.fsExtra, global.utils, global.os, global.deps);
        global.npmDynDependencies = mod.exports;
    }
})(this, function (exports, _assign, _regenerator, _keys, _set, _promise, _asyncToGenerator2, _installer, _terminalUtils, _cliSpinner, _path, _chalk, _fsExtra, _utils, _os, DEPS) {
    'use strict';

    exports.__esModule = true;
    exports.ensureInstallation = undefined;
    exports.getDepsList = getDepsList;

    var _assign2 = _interopRequireDefault(_assign);

    var _regenerator2 = _interopRequireDefault(_regenerator);

    var _keys2 = _interopRequireDefault(_keys);

    var _set2 = _interopRequireDefault(_set);

    var _promise2 = _interopRequireDefault(_promise);

    var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

    var _installer2 = _interopRequireDefault(_installer);

    var tu = _interopRequireWildcard(_terminalUtils);

    var _path2 = _interopRequireDefault(_path);

    var _chalk2 = _interopRequireDefault(_chalk);

    var _fsExtra2 = _interopRequireDefault(_fsExtra);

    var _os2 = _interopRequireDefault(_os);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var spinner = new _cliSpinner.Spinner('%s Starting up...');
    spinner.setSpinnerString('⠉⠑⠡⢁⡁⡈⠌⠊'); // '◷◶◵◴'

    var lastCursorPosition = { row: 0, col: 0 };
    var numCPUs = _os2.default.cpus().length;
    numCPUs = Math.ceil(numCPUs / 2);
    // numCPUs = numCPUs > 1 ? numCPUs - 1 : numCPUs

    var ensureInstallation = exports.ensureInstallation = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(depGroup) {
            var _this = this;

            var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var depsList, dep;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            depsList = [];


                            if (deps) {
                                deps = Array.isArray(deps) ? deps : [deps];
                            }

                            if (opts.installing && opts.installing.threads) {
                                numCPUs = opts.installing.threads;
                            }

                            if (opts.installing && opts.installing.threads) {
                                numCPUs = opts.installing.threads;
                            }

                            if (DEPS[depGroup]) {
                                for (dep in DEPS[depGroup]) {
                                    if (deps) {
                                        deps = Array.isArray(deps) ? deps : [deps];
                                        // install only the given dependencies
                                        if (deps.indexOf(dep) >= 0) {
                                            depsList.push(dep + '@' + (DEPS[depGroup][dep] || '*'));
                                        }
                                    } else {
                                        // install the whole group
                                        depsList.push(dep + '@' + (DEPS[depGroup][dep] || '*'));
                                    }
                                }
                            }

                            _context2.next = 7;
                            return new _promise2.default(function () {
                                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(resolve, reject) {
                                    var installData, resolver, defaultNModules, pkgJson, deps, hasToInstall, listToInstall, installableCounter, tmpChunk, i, l, _dep, installed, lineSize, updateInstalationBar, _i, _l;

                                    return _regenerator2.default.wrap(function _callee$(_context) {
                                        while (1) {
                                            switch (_context.prev = _context.next) {
                                                case 0:
                                                    updateInstalationBar = function updateInstalationBar() {
                                                        var percInstalled = installed * 100 / installableCounter;
                                                        percInstalled = lineSize * percInstalled / 100;
                                                        var statusStr = _chalk2.default.bgBlueBright(''.padEnd(percInstalled, ' ')) + ''.padEnd(lineSize - percInstalled, '-');
                                                        tu.moveTo('position', {
                                                            row: lastCursorPosition.row - 1,
                                                            col: lastCursorPosition.col
                                                        });
                                                        process.stdout.write(_chalk2.default.blueBright(statusStr));
                                                    };

                                                    installData = {
                                                        dependencies: depsList
                                                    };

                                                    resolver = function resolver(result) {
                                                        global.isInstalling = false;
                                                        resolve(result);
                                                    };

                                                    defaultNModules = _utils.FURTHER_PATH;

                                                    opts.node_modules = opts.node_modules || defaultNModules;

                                                    if (opts.verbose) {
                                                        installData.stdio = 'inherit';
                                                    }
                                                    if (opts.node_modules) {
                                                        installData.cwd = opts.node_modules; // + '../'
                                                    }

                                                    // getting the list of all currently installed modules
                                                    pkgJson = {};
                                                    deps = new _set2.default();


                                                    try {
                                                        pkgJson = _fsExtra2.default.readFileSync(_path2.default.resolve(installData.cwd, 'package.json'), 'utf8');
                                                        pkgJson = JSON.parse(pkgJson);
                                                        deps = new _set2.default((0, _keys2.default)(pkgJson.dependencies).concat((0, _keys2.default)(pkgJson.devDependencies)));
                                                    } catch (e) {}

                                                    hasToInstall = false;
                                                    listToInstall = [];
                                                    installableCounter = 0;
                                                    tmpChunk = [];


                                                    for (i = 0, l = depsList.length; i < l; i++) {
                                                        _dep = depsList[i].split('@');

                                                        if (!deps.has(_dep[0])) {
                                                            // if there is at least one dependency missing, we try and install it
                                                            hasToInstall = true;
                                                            installableCounter++;
                                                            if (_dep[1]) {
                                                                // we will install a given version (or in a range)
                                                                tmpChunk.push(depsList[i]);
                                                            } else {
                                                                // no version was specified
                                                                tmpChunk.push(_dep[0]);
                                                            }
                                                            // we will use half the cores from the CPUs to
                                                            // paralelize the installations
                                                            if (tmpChunk.length >= numCPUs) {
                                                                listToInstall.push(tmpChunk);
                                                                tmpChunk = [];
                                                            }
                                                        }
                                                    }
                                                    if (tmpChunk.length) {
                                                        listToInstall.push(tmpChunk);
                                                    }

                                                    // this will update the general status bar (for all the modules supposed
                                                    // to install for the current enabled technology) (the statusbar)
                                                    installed = 0;
                                                    lineSize = tu.getLineSize();

                                                    if (hasToInstall) {
                                                        _context.next = 22;
                                                        break;
                                                    }

                                                    resolver();
                                                    _context.next = 35;
                                                    break;

                                                case 22:

                                                    tu.clearTerminal();
                                                    console.log( // '\n\n' +
                                                    _chalk2.default.bold.blue('[i] ') + '> To enable ' + _chalk2.default.bold(depGroup + ' technologies, ') + 'we need to install some extra dependencies.\n' + 'Please wait while we install them for you.' + '\n');

                                                    global.isInstalling = true;
                                                    lastCursorPosition = tu.getCursorPosition();
                                                    updateInstalationBar();

                                                    _i = 0, _l = listToInstall.length;

                                                case 28:
                                                    if (!(_i < _l)) {
                                                        _context.next = 34;
                                                        break;
                                                    }

                                                    _context.next = 31;
                                                    return installGroup(listToInstall[_i], installData, function (_) {
                                                        installed++;
                                                        updateInstalationBar();
                                                    });

                                                case 31:
                                                    _i++;
                                                    _context.next = 28;
                                                    break;

                                                case 34:
                                                    resolver(true);

                                                case 35:
                                                case 'end':
                                                    return _context.stop();
                                            }
                                        }
                                    }, _callee, _this);
                                }));

                                return function (_x4, _x5) {
                                    return _ref2.apply(this, arguments);
                                };
                            }());

                        case 7:
                            return _context2.abrupt('return', _context2.sent);

                        case 8:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        return function ensureInstallation(_x) {
            return _ref.apply(this, arguments);
        };
    }();

    var installGroup = function () {
        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(group, installData, cb) {
            var instalationPath;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            instalationPath = installData.cwd;
                            return _context3.abrupt('return', _promise2.default.all(group.map(function (dep, i) {
                                return new _installer2.default({
                                    cwd: instalationPath,
                                    dep: dep,
                                    concurrently: numCPUs,
                                    startingRow: lastCursorPosition.row,
                                    pos: {
                                        row: lastCursorPosition.row + i * 2,
                                        col: lastCursorPosition.col
                                    }
                                }, cb);
                            })).then(function (results) {
                                var pkgDeps = {};
                                var pkgLockDeps = {};

                                results.forEach(function (instld) {
                                    // installed.installData.dependencies has the list of
                                    // the sub-dependencies that were also installed
                                    // lets store all the sub-dependencies into an object
                                    pkgLockDeps = (0, _assign2.default)({}, pkgLockDeps, instld.installData.dependencies);
                                    // and store the current dependency into another object
                                    pkgDeps[instld.name] = instld.version;
                                });

                                // update the further's package-lock and package with
                                // the installed dependencies
                                // this needs to be sync to avoid any locked file error.
                                // Firstly, we resolve their paths and read the current json
                                var pkgJsonPath = _path2.default.resolve(instalationPath, 'package.json');
                                var pkgLockJsonPath = _path2.default.resolve(instalationPath, 'package-lock.json');

                                // update the further's package-lock with the depnames
                                try {
                                    var pkgLockJson = _fsExtra2.default.readJsonSync(pkgLockJsonPath);
                                    pkgLockJson.dependencies = (0, _assign2.default)({}, pkgLockJson.dependencies, pkgLockDeps);
                                    _fsExtra2.default.writeJsonSync(pkgLockJsonPath, pkgJson, { spaces: 2 });
                                } catch (err) {}
                                // probably there wasn't a package-lock.json


                                // update the further's package with the depnames
                                var pkgJson = _fsExtra2.default.readJsonSync(pkgJsonPath);
                                pkgJson.dependencies = (0, _assign2.default)({}, pkgJson.dependencies, pkgDeps);
                                _fsExtra2.default.writeJsonSync(pkgJsonPath, pkgJson, { spaces: 2 });

                                // when a group is done, we clean all of its lines
                                for (var i = lastCursorPosition.row - 1, l = lastCursorPosition.row + numCPUs * 2 + 2; i < l; i++) {
                                    tu.moveTo('position', {
                                        row: i,
                                        col: 0
                                    });
                                    tu.clearLine();
                                }
                                tu.moveTo('position', {
                                    row: lastCursorPosition.row + 1,
                                    col: lastCursorPosition.col
                                });
                            }));

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        return function installGroup(_x6, _x7, _x8) {
            return _ref3.apply(this, arguments);
        };
    }();

    // retrieves the list of dependencies (all of them
    // or the dependencies within a group) from ./deps.js
    function getDepsList(group) {
        if (group) {
            return (0, _keys2.default)(DEPS[group] || {});
        } else {
            var finalList = [];
            (0, _keys2.default)(DEPS || {}).forEach(function (group) {
                finalList = finalList.concat((0, _keys2.default)(group || {}));
            });
            return finalList;
        }
    }
});

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_61__;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(5);


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var core = __webpack_require__(1);
var LIBRARY = __webpack_require__(36);
var wksExt = __webpack_require__(62);
var defineProperty = __webpack_require__(10).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(14) && !__webpack_require__(19)(function () {
  return Object.defineProperty(__webpack_require__(40)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(20);
var toIObject = __webpack_require__(22);
var arrayIndexOf = __webpack_require__(103)(false);
var IE_PROTO = __webpack_require__(45)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(16);


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(3).document;
module.exports = document && document.documentElement;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(11);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(29);
var ITERATOR = __webpack_require__(5)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(11);
var aFunction = __webpack_require__(23);
var SPECIES = __webpack_require__(5)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(13);
var invoke = __webpack_require__(113);
var html = __webpack_require__(67);
var cel = __webpack_require__(40);
var global = __webpack_require__(3);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(26)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(11);
var isObject = __webpack_require__(9);
var newPromiseCapability = __webpack_require__(54);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var core = __webpack_require__(1);
var dP = __webpack_require__(10);
var DESCRIPTORS = __webpack_require__(14);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(5)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(26);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(133), __esModule: true };

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_80__;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = require("fs");

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6), __webpack_require__(4), __webpack_require__(7), __webpack_require__(8), __webpack_require__(17), __webpack_require__(157), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/core-js/promise'), require('babel-runtime/helpers/asyncToGenerator'), require('fs-extra'), require('./utils'), require('./license-manager'), require('path'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.regenerator, global.promise, global.asyncToGenerator, global.fsExtra, global.utils, global.licenseManager, global.path);
        global.metaManager = mod.exports;
    }
})(this, function (exports, _regenerator, _promise, _asyncToGenerator2, _fsExtra, _utils, _licenseManager, _path) {
    'use strict';

    exports.__esModule = true;
    exports.ensureLicense = exports.ensureCOC = exports.ensureContributeFile = exports.ensureEditorConfig = exports.setupFurtherDir = undefined;

    var _regenerator2 = _interopRequireDefault(_regenerator);

    var _promise2 = _interopRequireDefault(_promise);

    var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

    var _fsExtra2 = _interopRequireDefault(_fsExtra);

    var _licenseManager2 = _interopRequireDefault(_licenseManager);

    var _path2 = _interopRequireDefault(_path);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var IGNORE_STR = '.further\nnode_modules\n.DS_Store\n.DS_Store?\n._*\n.Spotlight-V100\n.Trashes\nehthumbs.db\nThumbs.db\n**/*.log\n*.log\n';

    var ensureGitIgnore = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(path) {
            var _this = this;

            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            return _context3.abrupt('return', new _promise2.default(function () {
                                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(resolve) {
                                    var gitIgnoreFile;
                                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                                        while (1) {
                                            switch (_context2.prev = _context2.next) {
                                                case 0:
                                                    gitIgnoreFile = path + '/.gitignore';

                                                    _fsExtra2.default.readFile(gitIgnoreFile, 'utf8').then(function () {
                                                        var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(data) {
                                                            return _regenerator2.default.wrap(function _callee$(_context) {
                                                                while (1) {
                                                                    switch (_context.prev = _context.next) {
                                                                        case 0:
                                                                            if (!(data.indexOf('.further') < 0)) {
                                                                                _context.next = 3;
                                                                                break;
                                                                            }

                                                                            _context.next = 3;
                                                                            return _fsExtra2.default.appendFile(gitIgnoreFile, '.further');

                                                                        case 3:
                                                                            resolve();

                                                                        case 4:
                                                                        case 'end':
                                                                            return _context.stop();
                                                                    }
                                                                }
                                                            }, _callee, _this);
                                                        }));

                                                        return function (_x3) {
                                                            return _ref3.apply(this, arguments);
                                                        };
                                                    }()).catch(function (_) {
                                                        // .gitignore didn't exist...let's create it
                                                        // and add .further (plus some other basic paths) to it
                                                        _fsExtra2.default.appendFile(gitIgnoreFile, IGNORE_STR);
                                                        resolve();
                                                    });

                                                case 2:
                                                case 'end':
                                                    return _context2.stop();
                                            }
                                        }
                                    }, _callee2, _this);
                                }));

                                return function (_x2) {
                                    return _ref2.apply(this, arguments);
                                };
                            }()));

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        return function ensureGitIgnore(_x) {
            return _ref.apply(this, arguments);
        };
    }();

    var ensureMetaDirs = function () {
        var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(path) {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            return _context4.abrupt('return', _promise2.default.all([_fsExtra2.default.ensureDir(path + '/.further/reports'), _fsExtra2.default.ensureDir(path + '/.further/logs')]));

                        case 1:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        return function ensureMetaDirs(_x4) {
            return _ref4.apply(this, arguments);
        };
    }();

    var copyMetaFiles = function () {
        var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(paths) {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            return _context5.abrupt('return', (0, _utils.copyFiles)(['.eslintrc.json', '.stylelintrc.json'], paths.further + '/dist/.meta', paths.project + '/.further/'));

                        case 1:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        return function copyMetaFiles(_x5) {
            return _ref5.apply(this, arguments);
        };
    }();

    var setupFurtherDir = function () {
        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(paths) {
            var _this2 = this;

            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            return _context7.abrupt('return', new _promise2.default(function () {
                                var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(resolve) {
                                    return _regenerator2.default.wrap(function _callee6$(_context6) {
                                        while (1) {
                                            switch (_context6.prev = _context6.next) {
                                                case 0:
                                                    _context6.next = 2;
                                                    return (0, _utils.fileExists)(_path2.default.resolve(paths.project, '.further'));

                                                case 2:
                                                    if (_context6.sent) {
                                                        _context6.next = 7;
                                                        break;
                                                    }

                                                    _context6.next = 5;
                                                    return ensureMetaDirs(paths.project);

                                                case 5:
                                                    _context6.next = 7;
                                                    return copyMetaFiles(paths);

                                                case 7:
                                                    _context6.next = 9;
                                                    return ensureGitIgnore(paths.project);

                                                case 9:
                                                    resolve();

                                                case 10:
                                                case 'end':
                                                    return _context6.stop();
                                            }
                                        }
                                    }, _callee6, _this2);
                                }));

                                return function (_x7) {
                                    return _ref7.apply(this, arguments);
                                };
                            }()));

                        case 1:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        return function setupFurtherDir(_x6) {
            return _ref6.apply(this, arguments);
        };
    }();

    var ensureEditorConfig = function () {
        var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(paths) {
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            _context8.next = 2;
                            return (0, _utils.fileExists)(_path2.default.resolve(paths.project, '.editorconfig'));

                        case 2:
                            if (_context8.sent) {
                                _context8.next = 4;
                                break;
                            }

                            return _context8.abrupt('return', (0, _utils.copyFiles)(['.editorconfig'], paths.further + '/dist/.meta/', paths.project + '/'));

                        case 4:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        return function ensureEditorConfig(_x8) {
            return _ref8.apply(this, arguments);
        };
    }();

    var ensureCOC = function () {
        var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(paths, pkg) {
            var fileName;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            fileName = 'CODE_OF_CONDUCT.md';
                            _context9.next = 3;
                            return (0, _utils.fileExists)(_path2.default.resolve(paths.project, fileName));

                        case 3:
                            if (_context9.sent) {
                                _context9.next = 5;
                                break;
                            }

                            return _context9.abrupt('return', (0, _utils.copyFiles)([fileName], paths.further + '/dist/tpls/', paths.project + '/'));

                        case 5:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, this);
        }));

        return function ensureCOC(_x9, _x10) {
            return _ref9.apply(this, arguments);
        };
    }();

    var ensureContributeFile = function () {
        var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(paths, pkg) {
            var fileName;
            return _regenerator2.default.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            fileName = 'CONTRIBUTE.md';
                            _context10.next = 3;
                            return (0, _utils.fileExists)(_path2.default.resolve(paths.project, fileName));

                        case 3:
                            if (_context10.sent) {
                                _context10.next = 5;
                                break;
                            }

                            return _context10.abrupt('return', (0, _utils.copyFiles)([fileName], paths.further + '/dist/tpls/', paths.project + '/', function (content) {
                                // transformation function
                                content = content.replace('[year]', new Date().getFullYear());
                                content = content.replace('[projectname]', pkg.name);
                                content = content.replace('[author]', pkg.author);
                                content = content.replace('[fullname]', pkg.author);
                                if (pkg.bugs) {
                                    content = content.replace('[issuespath]', '[issues](' + (pkg.bugs.url || pkg.bugs) + ')');
                                } else {
                                    content = content.replace('[issuespath]', '');
                                }
                                return content;
                            }));

                        case 5:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, this);
        }));

        return function ensureContributeFile(_x11, _x12) {
            return _ref10.apply(this, arguments);
        };
    }();

    exports.setupFurtherDir = setupFurtherDir;
    exports.ensureEditorConfig = ensureEditorConfig;
    exports.ensureContributeFile = ensureContributeFile;
    exports.ensureCOC = ensureCOC;
    exports.ensureLicense = _licenseManager2.default;
});

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_83__;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = require("inspector");

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = require("os");

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod);
        global.deps = mod.exports;
    }
})(this, function (module) {
    "use strict";

    var exportable = {
        babel: {
            // "babel": "^6.23.0",
            // "babel-cli": "^6.26.0",
            // "babel-core": "^6.26.0",
            // "babel-eslint": "^8.0.2",

            "babel-plugin-add-module-exports": "^0.2.1",
            "babel-plugin-react-css-modules": "^3.3.2",
            "babel-plugin-syntax-dynamic-import": "^6.18.0",
            "babel-plugin-transform-async-to-generator": "^6.24.1",
            "babel-plugin-transform-decorators-legacy": "^1.3.4",

            "babel-plugin-transform-regenerator": "^6.26.0",
            "babel-plugin-transform-runtime": "^6.23.0",
            "babel-plugin-transform-es2015-classes": "^6.24.1",
            "babel-plugin-transform-es2015-modules-umd": "^6.24.1",

            "babel-preset-env": "^1.6.1",
            "babel-preset-es2015": "^6.24.1",
            "babel-preset-es2015-webpack": "^6.4.3",
            "babel-preset-preact": "^1.1.0",
            "babel-preset-react": "^6.24.1"
        },
        client: {
            "postcss": "^6.0.13",
            "postcss-cssnext": "^3.0.2",
            "postcss-loader": "^2.0.8",
            "critical": "^1.0.0",
            "css-loader": "^0.28.7",

            "babel-plugin-transform-react-jsx": "^6.24.1",

            "style-loader": "^0.19.0",
            "stylelint": "^8.4.0",
            "stylelint-webpack-plugin": "^0.9.0",
            "extract-loader": "^1.0.1",
            "extract-text-webpack-plugin": "^3.0.1",
            "html-loader": "^0.5.1",
            "html-webpack-exclude-assets-plugin": "0.0.5",
            // "html-webpack-harddisk-plugin": "^0.1.0",
            "html-webpack-include-assets-plugin": "^1.0.2",
            "html-webpack-plugin": "^2.30.1",
            "resolve-url-loader": "^2.2.1",
            // "url-loader": "^0.6.2",
            "webpack-hot-middleware": "^2.20.0",
            "htmllint-loader": "^2.1.4",
            "reset-css": "^2.2.1",
            "favicons-webpack-plugin": "0.0.7",
            // "webpack-plugin-critical": "^1.0.0",
            "webpack-spritesmith": "^0.3.3",
            "wrapper-webpack-plugin": "^1.0.0"
        },
        server: {
            "express": "^4.16.2",
            "concurrently": "^3.5.0",
            "http-server": "^0.10.0",
            "dev-server": "0.0.2",
            "html-webpack-harddisk-plugin": "^0.1.0",
            "webpack-dev-middleware": "^1.12.0",
            "webpack-hot-middleware": "^2.20.0"
        },
        developer: {
            "parker": "^0.0.10",
            "nsp": "^3.1.0"
        },
        imageOptimization: {
            "imagemin-mozjpeg": "^6.0.0",
            "imagemin-pngcrush": "^5.1.0",
            "imagemin-webp": "^4.0.0",
            "imagemin-webpack-plugin": "^1.5.2"
        },
        react: {
            "react": "^16.0.0",
            "react-addons-css-transition-group": "^15.6.2",
            "react-dom": "^16.0.0",
            "react-loader": "^2.4.2",
            "reload-html-webpack-plugin": "^0.1.2",
            "preact": "^8.2.5",
            "preact-compat": "^3.17.0",
            "preact-render-to-string": "^3.7.0",
            "preact-router": "^2.5.7"
        },
        coffee: {
            "coffee-loader": "^0.8.0",
            "coffeescript": "^2.0.2"
        },
        typescript: {
            "typescript": "^2.5.3",
            "ts-loader": "^3.1.1"
        },
        vue: {
            "vue": "^2.5.2",
            "vue-html-loader": "^1.2.4",
            "vue-loader": "^13.5.0",
            "vue-style-loader": "^3.0.3",
            "vue-template-compiler": "^2.5.2"
        },
        stylus: {
            "stylus": "^0.54.5",
            "stylus-loader": "^3.0.1"
        },
        sass: {
            "node-sass": "^4.5.3",
            "sass-loader": "^6.0.6"
        },
        less: {
            "less": "^3.0.0-alpha.3",
            "less-loader": "^4.0.5"
        },
        ejs: {
            "ejs-loader": "^0.3.0"
        },
        json: {
            "json5-loader": "^1.0.1"
        }
    };

    Object.defineProperty(exportable, 'dependencyExts', {
        value: {
            '.styl': 'stylus',
            '.scss': 'sass',
            '.sass': 'sass',
            '.less': 'less',
            '.json': 'json',
            '.vue': 'vue',
            '.ts': 'typescript',
            '.tsx': 'typescript',
            '.coffee': 'coffee',
            '.jsx': 'react',
            '.png': 'imageOptimization',
            '.jpg': 'imageOptimization',
            '.jpeg': 'imageOptimization',
            '.gif': 'imageOptimization',
            '.webp': 'imageOptimization'
        },
        writable: false,
        enumerable: false
    });

    module.exports = exportable;
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_87__;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_88__;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(18), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require("babel-runtime/core-js/object/assign"), require('path'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.assign, global.path);
        global.eslint = mod.exports;
    }
})(this, function (module, _assign, path) {
    "use strict";

    var _assign2 = _interopRequireDefault(_assign);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    module.exports = function (state, opts) {
        var _ref;

        return {
            enforce: "pre",
            test: /\.js$/,
            exclude: /node_modules|dist|vendors/,
            loader: state.FURTHER_REF + "eslint-loader",
            options: {
                configFile: path.resolve(state.PROJECT_PATH, './.further/.eslintrc.json'),
                rules: (0, _assign2.default)({}, {
                    "no-debugger": state.IS_DEV ? 1 : 2,
                    "no-console": 0,
                    "no-dynamic-import": 0,
                    "no-empty": 1,
                    "no-unused-vars": [1, (_ref = { "args": "all", "argsIgnorePattern": "^_" }, _ref["args"] = "after-used", _ref)],
                    "no-unused-args": 0,
                    "no-unreachable": state.IS_DEV ? 1 : 2
                }, (opts.custom.esLint ? opts.custom.esLint.rules : {}) || {})
            }
        };
    };
});

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod);
        global.js = mod.exports;
    }
})(this, function (module) {
    "use strict";

    module.exports = function (paths) {
        var FURTHER_REF = paths.FURTHER_REF;
        return {
            test: /\.(m)?js$/,
            exclude: /node_modules/,
            loader: FURTHER_REF + 'babel-loader',
            options: {
                plugins: [
                // FURTHER_REF + "babel-plugin-transform-async-to-generator",
                FURTHER_REF + "babel-plugin-transform-decorators-legacy", FURTHER_REF + "babel-plugin-transform-react-jsx", FURTHER_REF + 'babel-plugin-transform-es2015-classes', FURTHER_REF + 'babel-plugin-add-module-exports', FURTHER_REF + 'babel-plugin-transform-es2015-modules-umd', FURTHER_REF + 'babel-plugin-transform-runtime', FURTHER_REF + 'babel-plugin-syntax-dynamic-import'],
                presets: [FURTHER_REF + "babel-preset-preact", [
                // this preset makes our bundler a little smaller
                FURTHER_REF + "babel-preset-env", {
                    "targets": {
                        "browsers": ["last 2 versions" /*, "safari >= 7" */]
                    },
                    useBuiltIns: true,
                    modules: false
                    // loose: true
                }]]
                // presets: [
                //   [
                //     FURTHER_REF + 'babel-preset-es2015',
                //     { modules: false, loose: true, }
                //   ]
                // ]
            }
        };
    };
});

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod);
        global.perf = mod.exports;
    }
})(this, function (module) {
    'use strict';

    module.exports = {
        hints: "warning", // enum
        maxAssetSize: 200000, // int (in bytes),
        maxEntrypointSize: 400000, // int (in bytes)
        assetFilter: function assetFilter(assetFilename) {
            // Function predicate that provides asset filenames
            if (assetFilename.endsWith('webpack-hot-middleware/client.js')) {
                return false;
            }
            return assetFilename.endsWith('.css') || assetFilename.endsWith('.js');
        }
    };
});

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod);
        global.coffeeScript = mod.exports;
    }
})(this, function (module) {
    'use strict';

    module.exports = function (paths) {
        var FURTHER_REF = paths.FURTHER_REF;
        return {
            test: /\.coffee$/,
            // loader: require('coffee-loader?sourceMap=true') // coffeeLoader('!sourceMap=true')
            use: [{
                loader: FURTHER_REF + 'coffee-loader',
                options: { sourceMap: true }
            }],
            exclude: /node_modules/
        };
    };
});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(166), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('babel-runtime/core-js/json/stringify'), require('path'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.stringify, global.path);
        global.typeScript = mod.exports;
    }
})(this, function (module, _stringify, path) {
    'use strict';

    var _stringify2 = _interopRequireDefault(_stringify);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    module.exports = function (paths) {
        var FURTHER_REF = paths.FURTHER_REF;

        return {
            test: /\.ts(x?)$/,
            loader: FURTHER_REF + 'babel-loader?presets[]=' + FURTHER_REF + 'babel-preset-es2015!' + FURTHER_REF + 'ts-loader?' + (0, _stringify2.default)({
                configFile: path.resolve(FURTHER_REF, '../', '.meta/tsconfig.json')
            }),
            exclude: /node_modules/
        };
    };
});

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod);
        global.json = mod.exports;
    }
})(this, function (module) {
    'use strict';

    module.exports = function (paths) {
        var FURTHER_REF = paths.FURTHER_REF;
        return {
            test: /\.(json5|json)$/,
            loader: FURTHER_REF + 'json5-loader',
            exclude: /node_modules/
        };
    };
});

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(194);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(196);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(65);
var hiddenKeys = __webpack_require__(47).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(35);
var createDesc = __webpack_require__(24);
var toIObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(41);
var has = __webpack_require__(20);
var IE8_DOM_DEFINE = __webpack_require__(64);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(14) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(99), __webpack_require__(192)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./app.class.js'), require('./partial.class.js'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.appClass, global.partialClass);
    global.index = mod.exports;
  }
})(this, function (exports, _appClass, _partialClass) {
  'use strict';

  exports.__esModule = true;
  exports.Partial = exports.App = undefined;

  var _appClass2 = _interopRequireDefault(_appClass);

  var _partialClass2 = _interopRequireDefault(_partialClass);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.App = _appClass2.default;
  exports.Partial = _partialClass2.default;
});

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(18), __webpack_require__(4), __webpack_require__(32), __webpack_require__(6), __webpack_require__(7), __webpack_require__(57), __webpack_require__(58), __webpack_require__(0), __webpack_require__(132), __webpack_require__(17), __webpack_require__(163), __webpack_require__(139), __webpack_require__(83), __webpack_require__(159), __webpack_require__(8), __webpack_require__(15), __webpack_require__(84), __webpack_require__(60), __webpack_require__(86), __webpack_require__(87), __webpack_require__(87)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-runtime/core-js/object/assign"), require("babel-runtime/core-js/promise"), require("babel-runtime/core-js/set"), require("babel-runtime/regenerator"), require("babel-runtime/helpers/asyncToGenerator"), require("babel-runtime/helpers/classCallCheck"), require("webpack"), require("path"), require("./security"), require("./utils"), require("./app.wp-config"), require("./build-runner.js"), require("cli-spinner"), require("./http-server"), require("fs-extra"), require("./terminal-utils"), require("inspector"), require("./npm-dyn-dependencies"), require('./technologies/deps'), require('chokidar'), require('chokidar'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.assign, global.promise, global.set, global.regenerator, global.asyncToGenerator, global.classCallCheck, global.webpack, global.path, global.security, global.utils, global.app, global.buildRunner, global.cliSpinner, global.httpServer, global.fsExtra, global.terminalUtils, global.inspector, global.npmDynDependencies, global.deps, global.chokidar, global.chokidar);
        global.appClass = mod.exports;
    }
})(this, function (exports, _assign, _promise, _set, _regenerator, _asyncToGenerator2, _classCallCheck2, _webpack, _path, _security, _utils, _app, _buildRunner, _cliSpinner, _httpServer, _fsExtra, _terminalUtils, _inspector, _npmDynDependencies, _DEPS, configChokidar, chokidar) {
    "use strict";

    exports.__esModule = true;

    var _assign2 = _interopRequireDefault(_assign);

    var _promise2 = _interopRequireDefault(_promise);

    var _set2 = _interopRequireDefault(_set);

    var _regenerator2 = _interopRequireDefault(_regenerator);

    var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

    var _webpack2 = _interopRequireDefault(_webpack);

    var _path2 = _interopRequireDefault(_path);

    var _security2 = _interopRequireDefault(_security);

    var _app2 = _interopRequireDefault(_app);

    var _buildRunner2 = _interopRequireDefault(_buildRunner);

    var _httpServer2 = _interopRequireDefault(_httpServer);

    var _fsExtra2 = _interopRequireDefault(_fsExtra);

    var _inspector2 = _interopRequireDefault(_inspector);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var DEFAULT_REPORTS = {
        verbosity: 0,
        unusedDeps: true,
        outdatedDeps: true,
        security: {}
    };
    var DEFAULT_OPTIONS = {
        installing: {},
        development: {
            autoCreateFiles: 'interactive'
        },
        production: {}
    };

    var DEFAULT_DIST_PATH = 'dist';
    var DEFAULT_SRC_PATH = 'src';
    var spinner = new _cliSpinner.Spinner('%s Starting up...');
    spinner.setSpinnerString('⠉⠑⠡⢁⡁⡈⠌⠊'); // '◷◶◵◴'

    function watchForConfigChanges(that) {
        if (configChokidar.watch) {
            configChokidar = configChokidar.watch(_path2.default.resolve(that.paths.src, '../index.js'));

            configChokidar.on('change', function (_) {
                console.log((0, _terminalUtils.statusLine)('important', 'Detected change in configuration.\n' + 'Requires a restart to load the new settings.\n' + 'Exiting build process with code 999'));

                process.exit(999);
            });
        }
    }

    var App = function () {
        function App() {
            (0, _classCallCheck3.default)(this, App);

            this.hasEnsuredBasicDeps = false;
        }

        App.prototype.ensureDeps = function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return (0, _npmDynDependencies.ensureInstallation)('babel', null, {
                                    verbose: true,
                                    node_modules: _utils.FURTHER_PATH,
                                    installing: this.opts.installing
                                });

                            case 2:
                                this.hasEnsuredBasicDeps = true;

                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function ensureDeps() {
                return _ref.apply(this, arguments);
            }

            return ensureDeps;
        }();

        App.prototype.config = function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_config) {
                var _this = this;

                var PROJECT_PATH, OUTPUT_PATH, SRC_PATH;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (this.hasEnsuredBasicDeps) {
                                    _context3.next = 3;
                                    break;
                                }

                                _context3.next = 3;
                                return this.ensureDeps();

                            case 3:
                                PROJECT_PATH = _path2.default.resolve(_path2.default.dirname(process.argv[1]));
                                OUTPUT_PATH = _path2.default.resolve(PROJECT_PATH, _config.outputPath || DEFAULT_DIST_PATH);
                                SRC_PATH = _path2.default.resolve(PROJECT_PATH, _config.src || DEFAULT_SRC_PATH);
                                // const FURTHER_PATH = furtherInstallationPath || process.cwd()

                                _context3.t0 = PROJECT_PATH;
                                _context3.t1 = OUTPUT_PATH;
                                _context3.t2 = SRC_PATH;
                                _context3.t3 = _utils.FURTHER_PATH;
                                _context3.t4 = _utils.FURTHER_REF;
                                _context3.t5 = _set2.default;
                                _context3.next = 14;
                                return (0, _utils.thereIsAnyFileMatching)(SRC_PATH, ['.js', '.css', '.jsx', '.vue', '.ts', '.tsx', '.scss', '.less', '.styl', '.coffee']);

                            case 14:
                                _context3.t6 = _context3.sent;
                                _context3.t7 = new _context3.t5(_context3.t6);
                                this.paths = {
                                    project: _context3.t0,
                                    dist: _context3.t1,
                                    src: _context3.t2,
                                    further: _context3.t3,
                                    furtherRef: _context3.t4,
                                    usedExtensions: _context3.t7
                                };
                                _context3.t8 = JSON;
                                _context3.next = 20;
                                return _fsExtra2.default.readFile(_path2.default.resolve(this.paths.project, 'package.json'));

                            case 20:
                                _context3.t9 = _context3.sent;
                                this.pkg = _context3.t8.parse.call(_context3.t8, _context3.t9);


                                // we should give the exit signals a better treatment
                                process.on('SIGINT', function (event) {
                                    process.exit(0);
                                });
                                process.on('SIGTERM', function (event) {
                                    process.exit(0);
                                });
                                process.on('SIGUSR1', function (event) {
                                    process.exit(0);
                                });
                                process.on('SIGUSR2', function (event) {
                                    process.exit(0);
                                });
                                process.on('beforeExit', function () {
                                    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(event) {
                                        return _regenerator2.default.wrap(function _callee2$(_context2) {
                                            while (1) {
                                                switch (_context2.prev = _context2.next) {
                                                    case 0:
                                                    case "end":
                                                        return _context2.stop();
                                                }
                                            }
                                        }, _callee2, _this);
                                    }));

                                    return function (_x2) {
                                        return _ref3.apply(this, arguments);
                                    };
                                }());
                                process.on('exit', function (code) {
                                    _inspector2.default.close();
                                    console.log('\nThanks for using furtherjs.\n' + 'Please report any issue at nasc\'s repository');
                                    process.exit(code);
                                });
                                // process.on('uncaughtException', event => {process.exit(0)})

                                this.settings = this.settings || _config || {};
                                return _context3.abrupt("return", this.reloadWebpackSettings());

                            case 30:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function config(_x) {
                return _ref2.apply(this, arguments);
            }

            return config;
        }();

        App.prototype.reloadWebpackSettings = function reloadWebpackSettings() {
            var _this2 = this;

            var ret = (0, _app2.default)(this.settings, this.paths, this).then(function (wpConfig) {
                _this2.settings.webpackConfig = wpConfig;
            });
            ret.start = this.start;
            return ret;
        };

        App.prototype.onBuildDone = function () {
            var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(buildType) {
                var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var stats = arguments[2];
                var httpPid, opts;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:

                                if (this.settings.mode === 'dev') {
                                    // we will generate the reports, but will
                                    // not wait for them
                                    _security2.default.check(this);
                                }

                                if (buildType === 'client') {}

                                httpPid = 0;

                                if (!(buildType === 'server')) {
                                    _context4.next = 17;
                                    break;
                                }

                                opts = this.opts || {};

                                if (!(opts.server !== false)) {
                                    _context4.next = 17;
                                    break;
                                }

                                _context4.prev = 6;
                                _context4.next = 9;
                                return _httpServer2.default.start({
                                    compiler: this.compiler,
                                    opts: this.opts,
                                    config: this.config,
                                    paths: this.paths,
                                    stats: stats
                                });

                            case 9:
                                httpPid = _context4.sent;

                                this.httpPid = httpPid;
                                _context4.next = 17;
                                break;

                            case 13:
                                _context4.prev = 13;
                                _context4.t0 = _context4["catch"](6);

                                if (opts.breakpointOnErrors) {
                                    debugger;
                                }
                                stats.compilation.errors.push({
                                    name: 'Server startup error',
                                    message: "Could not start HTTP Server.\n" + (_context4.t0.message || _context4.t0)
                                });

                            case 17:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[6, 13]]);
            }));

            function onBuildDone(_x3) {
                return _ref4.apply(this, arguments);
            }

            return onBuildDone;
        }();

        App.prototype.startWatcher = function startWatcher() {
            var emptyBuild = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (this.compilerWatcher) {
                // it is already watching
                return;
            }
            watchForConfigChanges(this);
            this.compilerWatcher = this.compiler.watch(this.listForTheCompilerToWatch, _buildRunner2.default.bind(this));

            if (emptyBuild) {
                _buildRunner2.default.call(this, {});
            }
            return this;
        };

        App.prototype.reset = function () {
            var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5() {
                var that;
                return _regenerator2.default.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                that = this;
                                return _context5.abrupt("return", new _promise2.default(function (resolve, reject) {
                                    // stop watching changes
                                    that.compilerWatcher.close();
                                    that.compilerWatcher = false;
                                    // if it was debugging, we set it to false anyway
                                    that.opts.debug = false;
                                    // get the configuration again
                                    // (this time, with the newly installed dependencies)

                                    that.config(that.opts).then(function (_) {
                                        // restart the compiler and watcher

                                        that.compiler = (0, _webpack2.default)(that.settings.webpackConfig);
                                        that.startWatcher();
                                        resolve();
                                    });
                                }));

                            case 2:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function reset() {
                return _ref5.apply(this, arguments);
            }

            return reset;
        }();

        App.prototype.start = function start(opts) {
            var _this3 = this;

            this.opts = opts || this.opts || {};
            this.opts = (0, _assign2.default)({}, DEFAULT_OPTIONS, this.opts);
            this.opts.reports = (0, _assign2.default)({}, this.opts.reports || {}, DEFAULT_REPORTS);
            var that = this;
            this.spinner = spinner;

            this.config(opts).then(function (_) {
                spinner.start();
                var config = _this3.settings;
                spinner.setSpinnerTitle('Instantiating webpack');
                // generate the compiler based on the new settings
                // const compiler = webpack(this.settings.webpackConfig)
                that.compiler = (0, _webpack2.default)(_this3.settings.webpackConfig);
                console.log('\n');

                if (config.mode === 'dev') {
                    // if in devMode, we start watching for changes
                    spinner.setSpinnerTitle('Entering developer mode... ');
                    // move cursor to begining of line in terminal
                    (0, _terminalUtils.moveTo)('lineStart');
                    // we use chokidar to watch for new files in runtime


                    if (opts.server) {
                        _fsExtra2.default.ensureDirSync(_path2.default.join(that.paths.src, 'server/main'));
                        _fsExtra2.default.ensureFileSync(_path2.default.join(that.paths.src, 'server/services/.gitkeep'));
                        _fsExtra2.default.ensureFileSync(_path2.default.join(that.paths.src, 'server/statuses/403.html'));
                        _fsExtra2.default.ensureFileSync(_path2.default.join(that.paths.src, 'server/statuses/404.html'));
                        _fsExtra2.default.ensureFileSync(_path2.default.join(that.paths.src, 'server/statuses/500.html'));
                        (0, _utils.ensureExists)(_path2.default.join(that.paths.src, 'server/main/index.js'), 11);
                    }
                    if (opts.client) {
                        _fsExtra2.default.ensureFileSync(_path2.default.join(that.paths.src, 'client/components/.gitkeep'));
                        (0, _utils.ensureExists)(_path2.default.join(that.paths.src, 'client/main/index.js'), 11);
                        (0, _utils.ensureExists)(_path2.default.join(that.paths.src, 'client/main/templates/index.html'), 11);
                    }
                    if (opts.cli) {
                        _fsExtra2.default.ensureDirSync(_path2.default.join(that.paths.src, 'cli/main'));
                        _fsExtra2.default.ensureFileSync(_path2.default.join(that.paths.src, 'cli/commands/.gitkeep'));
                        (0, _utils.ensureExists)(_path2.default.join(that.paths.src, 'cli/main/index.js'), 11);
                    }
                    _fsExtra2.default.ensureFile(_path2.default.join(that.paths.project, 'PULL_REQUEST_TEMPLATE.md'));
                    _fsExtra2.default.ensureFile(_path2.default.join(that.paths.project, 'ISSUE_TEMPLATE.md'));
                    _fsExtra2.default.ensureFile(_path2.default.join(that.paths.project, 'CODE_OF_CONDUCT.md'));

                    var chokidatWatcher = chokidar.watch(that.paths.src, (0, _assign2.default)({}, config.watchOptions || {}, {
                        ignored: /((^|[\/\\])\..\/)|(node_modules|dist\/)|(\.git)|(.DS_Store)|(\.tmp)|(\.further)|(~.+)|(README)|(readme)/
                    }));

                    var isReady = false;
                    _this3.listForTheCompilerToWatch = [];
                    var nothingToWatchYet = true;

                    chokidatWatcher.on('add', function () {
                        var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(fullPath) {
                            var depsGroup, hadToInstall;
                            return _regenerator2.default.wrap(function _callee6$(_context6) {
                                while (1) {
                                    switch (_context6.prev = _context6.next) {
                                        case 0:
                                            nothingToWatchYet = false;
                                            // any file chokidar adds, will be unwatched by chokidar
                                            // and will begin to be watched by the compiler's watcher
                                            chokidatWatcher.unwatch(fullPath);

                                            if (!isReady) {
                                                _context6.next = 14;
                                                break;
                                            }

                                            if (that.paths.usedExtensions.has(_path2.default.extname(fullPath))) {
                                                _context6.next = 11;
                                                break;
                                            }

                                            // new kind of file (an extension that had not been used yet)
                                            // let's see if we need to install it
                                            depsGroup = _DEPS.dependencyExts[_path2.default.extname(fullPath)];

                                            // try and install it

                                            _context6.next = 7;
                                            return (0, _npmDynDependencies.ensureInstallation)(depsGroup, null, {
                                                verbose: true
                                                //   node_modules: that.paths.further + '/node_modules/furtherjs/node_modules/'
                                            });

                                        case 7:
                                            hadToInstall = _context6.sent;

                                            if (!hadToInstall) {
                                                _context6.next = 11;
                                                break;
                                            }

                                            _context6.next = 11;
                                            return that.reset();

                                        case 11:

                                            // and now, we are ready to run the compiler task
                                            that.compiler.run(function (_) {
                                                _buildRunner2.default.bind(that);
                                            });
                                            _context6.next = 15;
                                            break;

                                        case 14:
                                            // first build in proccess, let's add it to the list
                                            _this3.listForTheCompilerToWatch.push(fullPath);

                                        case 15:
                                        case "end":
                                            return _context6.stop();
                                    }
                                }
                            }, _callee6, _this3);
                        }));

                        return function (_x6) {
                            return _ref6.apply(this, arguments);
                        };
                    }());

                    chokidatWatcher.on('ready', function (_) {
                        // we will use the webpakc compiler's watch to watch the files
                        // after the first build. This way, new builds get a little optimized
                        isReady = true;
                        if (!_this3.listForTheCompilerToWatch.length) {
                            console.log('Nothing to watch. Waiting for new files');
                            spinner.stop();
                        }
                        that.startWatcher();
                    });

                    // if no file has been seen in 1sec, we build it empty
                    setTimeout(function (_) {
                        if (nothingToWatchYet) {
                            that.startWatcher(true);
                        }
                    }, 1000);
                } else {
                    spinner.setSpinnerTitle('Entering production mode... ');
                    // move cursor to begining of line in terminal
                    (0, _terminalUtils.moveTo)('lineStart');
                    // if not in devMode, we simply run/start it
                    that.compiler.run(_buildRunner2.default.bind(that));
                }
            });
        };

        return App;
    }();

    exports.default = App;
});

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(101);
module.exports = __webpack_require__(1).Object.assign;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(102) });


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(25);
var gOPS = __webpack_require__(48);
var pIE = __webpack_require__(35);
var toObject = __webpack_require__(27);
var IObject = __webpack_require__(42);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(19)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(22);
var toLength = __webpack_require__(33);
var toAbsoluteIndex = __webpack_require__(104);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(44);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(49);
__webpack_require__(28);
__webpack_require__(38);
__webpack_require__(112);
__webpack_require__(115);
__webpack_require__(116);
module.exports = __webpack_require__(1).Promise;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(44);
var defined = __webpack_require__(43);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(37);
var descriptor = __webpack_require__(24);
var setToStringTag = __webpack_require__(30);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(16)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(10);
var anObject = __webpack_require__(11);
var getKeys = __webpack_require__(25);

module.exports = __webpack_require__(14) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(20);
var toObject = __webpack_require__(27);
var IE_PROTO = __webpack_require__(45)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(111);
var step = __webpack_require__(68);
var Iterators = __webpack_require__(29);
var toIObject = __webpack_require__(22);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(50)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(36);
var global = __webpack_require__(3);
var ctx = __webpack_require__(13);
var classof = __webpack_require__(51);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(9);
var aFunction = __webpack_require__(23);
var anInstance = __webpack_require__(52);
var forOf = __webpack_require__(31);
var speciesConstructor = __webpack_require__(71);
var task = __webpack_require__(72).set;
var microtask = __webpack_require__(114)();
var newPromiseCapabilityModule = __webpack_require__(54);
var perform = __webpack_require__(73);
var promiseResolve = __webpack_require__(74);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(5)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(55)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(30)($Promise, PROMISE);
__webpack_require__(75)(PROMISE);
Wrapper = __webpack_require__(1)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(76)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 113 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(3);
var macrotask = __webpack_require__(72).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(26)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(2);
var core = __webpack_require__(1);
var global = __webpack_require__(3);
var speciesConstructor = __webpack_require__(71);
var promiseResolve = __webpack_require__(74);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(2);
var newPromiseCapability = __webpack_require__(54);
var perform = __webpack_require__(73);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(49);
__webpack_require__(28);
__webpack_require__(38);
__webpack_require__(118);
__webpack_require__(124);
__webpack_require__(127);
__webpack_require__(129);
module.exports = __webpack_require__(1).Set;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(119);
var validate = __webpack_require__(77);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(120)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(10).f;
var create = __webpack_require__(37);
var redefineAll = __webpack_require__(55);
var ctx = __webpack_require__(13);
var anInstance = __webpack_require__(52);
var forOf = __webpack_require__(31);
var $iterDefine = __webpack_require__(50);
var step = __webpack_require__(68);
var setSpecies = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(14);
var fastKey = __webpack_require__(56).fastKey;
var validate = __webpack_require__(77);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(3);
var $export = __webpack_require__(2);
var meta = __webpack_require__(56);
var fails = __webpack_require__(19);
var hide = __webpack_require__(16);
var redefineAll = __webpack_require__(55);
var forOf = __webpack_require__(31);
var anInstance = __webpack_require__(52);
var isObject = __webpack_require__(9);
var setToStringTag = __webpack_require__(30);
var dP = __webpack_require__(10).f;
var each = __webpack_require__(121)(0);
var DESCRIPTORS = __webpack_require__(14);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(13);
var IObject = __webpack_require__(42);
var toObject = __webpack_require__(27);
var toLength = __webpack_require__(33);
var asc = __webpack_require__(122);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(123);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);
var isArray = __webpack_require__(78);
var SPECIES = __webpack_require__(5)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(2);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(125)('Set') });


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(51);
var from = __webpack_require__(126);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(31);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(128)('Set');


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(2);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(130)('Set');


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(23);
var ctx = __webpack_require__(13);
var forOf = __webpack_require__(31);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_131__;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6), __webpack_require__(7), __webpack_require__(59), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-runtime/regenerator"), require("babel-runtime/helpers/asyncToGenerator"), require("child_process"), require("path"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.regenerator, global.asyncToGenerator, global.child_process, global.path);
        global.security = mod.exports;
    }
})(this, function (exports, _regenerator, _asyncToGenerator2, _child_process, _path) {
    "use strict";

    exports.__esModule = true;

    var _regenerator2 = _interopRequireDefault(_regenerator);

    var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

    var _path2 = _interopRequireDefault(_path);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var DEFAULT_SECURITY_CHECK_INTERVAL = 10;

    function getDateFileName() {
        var d = new Date();
        return d.getDate() + "-" + d.getMonth() + "-" + d.getFullYear();
    }

    var security = {
        nextSecurityCheck: 0,
        isChecking: false,
        nspCheck: function nspCheck(app) {
            (0, _child_process.exec)("node " + _path2.default.resolve(app.paths.furtherRef, 'node_modules', 'nsp', 'bin', 'nsp') + ' check --reporter table' + ' > ' + _path2.default.resolve(app.paths.project, '.further', 'reports', 'nsp'), function (result) {});
        },
        check: function check(app) {
            var _this = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
                var interval, now;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.isChecking) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt("return");

                            case 2:
                                _this.isChecking = true;
                                if (!app.opts.security) {
                                    app.opts.security = {
                                        interval: DEFAULT_SECURITY_CHECK_INTERVAL
                                    };
                                }
                                interval = app.opts.security.interval * 60 * 1000;
                                now = new Date().getTime();

                                if (!(!_this.nextSecurityCheck || _this.nextSecurityCheck < now)) {
                                    _context.next = 10;
                                    break;
                                }

                                _this.nextSecurityCheck = now + interval;
                                _context.next = 10;
                                return security.nspCheck(app);

                            case 10:
                                _this.isChecking = false;

                            case 11:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    };

    exports.default = security;
});

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28);
__webpack_require__(134);
module.exports = __webpack_require__(1).Array.from;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(13);
var $export = __webpack_require__(2);
var toObject = __webpack_require__(27);
var call = __webpack_require__(69);
var isArrayIter = __webpack_require__(70);
var toLength = __webpack_require__(33);
var createProperty = __webpack_require__(135);
var getIterFn = __webpack_require__(53);

$export($export.S + $export.F * !__webpack_require__(76)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(10);
var createDesc = __webpack_require__(24);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 136 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_136__;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_137__;

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_138__;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6), __webpack_require__(39), __webpack_require__(7), __webpack_require__(21), __webpack_require__(143), __webpack_require__(151), __webpack_require__(82), __webpack_require__(152), __webpack_require__(0), __webpack_require__(153), __webpack_require__(17), __webpack_require__(8), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/core-js/object/keys'), require('babel-runtime/helpers/asyncToGenerator'), require('chalk'), require('./handlers'), require('filesize'), require('./meta-manager'), require('my-ip'), require('path'), require('./module-verifier'), require('./utils'), require('fs-extra'), require('./terminal-utils'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.regenerator, global.keys, global.asyncToGenerator, global.chalk, global.handlers, global.filesize, global.metaManager, global.myIp, global.path, global.moduleVerifier, global.utils, global.fsExtra, global.terminalUtils);
        global.buildRunner = mod.exports;
    }
})(this, function (exports, _regenerator, _keys, _asyncToGenerator2, _chalk, _handlers, _filesize, _metaManager, _myIp, _path, _moduleVerifier, _utils, _fsExtra, _terminalUtils) {
    'use strict';

    exports.__esModule = true;

    var _regenerator2 = _interopRequireDefault(_regenerator);

    var _keys2 = _interopRequireDefault(_keys);

    var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

    var _chalk2 = _interopRequireDefault(_chalk);

    var _filesize2 = _interopRequireDefault(_filesize);

    var _myIp2 = _interopRequireDefault(_myIp);

    var _path2 = _interopRequireDefault(_path);

    var _fsExtra2 = _interopRequireDefault(_fsExtra);

    var tu = _interopRequireWildcard(_terminalUtils);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    // import httpServer from './http-server'
    // import { readFile } from './utils'

    // import webpackMiddleware from 'webpack-dev-middleware'
    var buildNumber = 0;

    /**
     * Executes the compilation from generated webpack configuration.
     * 
     * It will also start a spinner animation and starts the HTTP Servers
     * and will show the header and status line for each build.
     * 
     * @param {Object} err 
     * @param {Object} stats Webpack stats object
     */

    // import { Spinner } from 'cli-spinner'

    exports.default = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(err, stats) {
            var lineSize, lineTop, lineBottom, spinner, reports, depsReport, outdatedReport, pkg, opts, jsonStats, buildStatus, treatedErrors, treatedErrorMessages, treatedWarns, assets, dt, header, str, upAt, isDebugging, headerLines, hasEmitted, mapFiles, iconFiles, gzFiles, extraFiles, status, messages, errorsLen, statusLeft, statusRight;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!global.isInstalling) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt('return');

                        case 2:
                            lineSize = tu.getLineSize;
                            lineTop = tu.getLineTop;
                            lineBottom = tu.getLineBottom;
                            spinner = this.spinner;
                            reports = [];

                            // treating any error that may have happened before this point

                            if (!err) {
                                _context.next = 13;
                                break;
                            }

                            if (!(0, _keys2.default)(err).length) {
                                _context.next = 13;
                                break;
                            }

                            // if there were errors, we end the program
                            console.log(tu.errorMessage('Startup error:'));
                            console.error(err.error ? err.error.message : err.message);
                            spinner.stop();
                            // process.exit(1)
                            return _context.abrupt('return');

                        case 13:

                            // start a animation in terminal
                            if (!spinner.isSpinning()) {
                                spinner.start();
                            }

                            spinner.setSpinnerTitle('Building... ');
                            // move cursor to begining of line in terminal
                            tu.moveTo('lineStart');

                            // if this is the first build (not in watch)
                            // and the user has these reports enabled

                            if (!(buildNumber === 0 && (this.opts.reports.unusedDeps || this.opts.reports.outdatedDeps))) {
                                _context.next = 28;
                                break;
                            }

                            _context.next = 19;
                            return (0, _moduleVerifier.analyzeDependencies)(this.paths.project, this.settings.webpackConfig);

                        case 19:
                            depsReport = _context.sent;


                            // Detecting unused modules and reporting them
                            if (this.opts.reports.unusedDeps && depsReport.unused.length) {
                                reports.push(tu.reportMessage('The following modules are installed but never used:' + tu.list(depsReport.unused)));
                            }

                            // verifying outdated modules and reporting them

                            if (!this.opts.reports.outdatedDeps) {
                                _context.next = 26;
                                break;
                            }

                            _context.next = 24;
                            return (0, _moduleVerifier.getOutdated)(this.paths.project + '/package.json');

                        case 24:
                            outdatedReport = _context.sent;


                            if (outdatedReport.length) {
                                reports.push(tu.timingReport('You have outdated modules:' + tu.list(outdatedReport)));
                            }

                        case 26:
                            _context.next = 29;
                            break;

                        case 28:
                            reports = [];

                        case 29:

                            if (buildNumber === 0) {
                                pkg = this.pkg;
                                // this is asynchronouse, but we don't have to wait for it

                                (0, _metaManager.ensureLicense)(this.paths, pkg);
                                (0, _metaManager.ensureContributeFile)(this.paths, pkg);
                                (0, _metaManager.ensureCOC)(this.paths, pkg);
                            }

                            // increase the build number
                            buildNumber++;

                            opts = this.opts;
                            // const initReports = this.initReports

                            jsonStats = stats ? stats.toJson() : { hash: '', stats: [], warnings: [], errors: [], children: [] };


                            stats = stats || jsonStats;
                            buildStatus = jsonStats.errors.length ? 'Has errors' : jsonStats.warnings.length ? 'Has warnings' : 'Ok';

                            // treating errors, warnings and info messages

                            _context.next = 37;
                            return (0, _handlers.treatSoftErrors)(stats, this, opts);

                        case 37:
                            treatedErrors = _context.sent;
                            treatedErrorMessages = treatedErrors.messages;
                            treatedWarns = (0, _handlers.treatWarnings)(jsonStats.warnings, this.paths, opts);

                            // the list of assets from this build

                            assets = jsonStats.children.length ? jsonStats.children.reduce(function (prev, cur) {
                                return prev ? prev.assets.concat(cur.assets) : cur.assets;
                            }) : [];


                            assets = assets.assets || [];

                            // used to the timestamp
                            dt = new Date();

                            dt = dt.toTimeString().substr(0, 8) + dt.toTimeString().substr(-6);

                            // used for the terminal decoration and output
                            // let info = colors.bgBlue.white
                            header = '';
                            str = '';
                            upAt = '';
                            isDebugging = opts.mode === 'dev' && opts.debug;

                            // Retrieves the http address for the server
                            // if it is enabled in options
                            // if (opts.server && opts.server.port) {

                            opts.server = opts.server || {};
                            upAt = 'http://' + (0, _myIp2.default)() + ':' + (opts.server.port || _utils.DEFAULT_DEV_SERVER_PORT) + '/';
                            // }

                            // preparing the header to be used in terminal for the build
                            headerLines = [
                            // build number
                            _chalk2.default.bold('Build: ') + ' #' + buildNumber.toString().padEnd(lineSize() - 24, ' ') + ('PID: ' + process.pid.toString().padStart(8, ' ')),
                            // hash and timestamp
                            _chalk2.default.bold('Hash: ') + (stats.hash || 'empty build').padEnd(40, ' ') + dt.padStart(lineSize() - 48, ' ') + ' ',
                            // status and http address
                            (_chalk2.default.bold('Status: ') + buildStatus).padEnd(lineSize() + 7 - upAt.length, ' ') + _chalk2.default.bold.underline(upAt) + '   ',
                            // mode (development or production)
                            (_chalk2.default.bold('Mode: ') + opts.mode + (isDebugging ? ' (debugging)' : '')).padEnd(lineSize() + 9, ' ') + ' '];
                            // adding the timing for each target build into the header

                            if (stats.stats.length) {
                                headerLines.push(_chalk2.default.bold('Times: ').padEnd(40, ' ')); // + ('PID: ' + process.pid).padStart(lineSize() - 35, ' ') + ' ')
                                stats.stats.forEach(function (stat) {
                                    var str = _chalk2.default.bold(stat.compilation.options.target) + ': ' + (stat.endTime - stat.startTime) + 'ms';
                                    headerLines.push('  ' + str);
                                });
                            }

                            // headerLines.push('  ' + stats.httpServerService ? stats.httpServerService.pid : 'XXXXXXX')

                            // Decorate the header
                            header = tu.headerMessage(headerLines);
                            str += header;

                            // time to treat the assets before listing them
                            if (!Array.isArray(assets)) {
                                assets = [assets];
                            }

                            hasEmitted = false;
                            mapFiles = 0;
                            iconFiles = 0;
                            gzFiles = 0;
                            extraFiles = 0;

                            // let's hide some kinds of assets
                            // and highlight the ones with warnings

                            assets.forEach(function (asset, i) {
                                if (asset.emitted) {
                                    if (asset.name.match(/(public|vendors|hot|assets|docs)\//)) {
                                        extraFiles++;
                                        return;
                                    }

                                    hasEmitted = true;
                                    if (i === 0) {
                                        str += '\n';
                                    }
                                    if (asset.name.startsWith('icons/')) {
                                        iconFiles++;
                                    } else if (asset.name.endsWith('.map')) {
                                        mapFiles++;
                                    } else if (asset.name.endsWith('.gz')) {
                                        gzFiles++;
                                    } else {
                                        var tmpStr = tu.item(asset.name, (0, _filesize2.default)(asset.size, { symbols: { B: " B" } }));
                                        if (asset.isOverSizeLimit) {
                                            tmpStr = _chalk2.default.bold.yellow(tmpStr);
                                        }
                                        str += tmpStr;
                                    }
                                }
                            });

                            // we don't show the list of source maps, instead we show its counter
                            if (mapFiles) {
                                str += tu.listItem(mapFiles + ' source maps', '+');
                            }
                            // same thing for the gziped files
                            if (gzFiles) {
                                str += tu.listItem(gzFiles + ' Gziped files', '+');
                            }
                            // and also icons
                            if (iconFiles) {
                                str += tu.listItem(iconFiles + ' Icon files', '+');
                            }
                            // and extra files (like copied vendors/public files or hot/)
                            if (iconFiles) {
                                str += tu.listItem(iconFiles + ' Hiden files', '+');
                            }
                            if (hasEmitted) {
                                if (extraFiles) {
                                    str += tu.listItem(extraFiles + ' Hiden files', '+');
                                }
                                str += lineBottom();
                            }

                            // let's show the notes/errors
                            status = 1;
                            messages = '';
                            errorsLen = jsonStats.errors.length;

                            if (jsonStats.warnings.length) {
                                // separating the warning messages from the info ones
                                status = 2;
                                messages += tu.join(treatedWarns.warns, true);
                                messages += tu.join(treatedWarns.infos, true);
                            }

                            // add a better treatment for the error messages
                            if (treatedErrorMessages.length) {
                                status = 3;
                                if (!treatedErrorMessages.length) {
                                    // something went wrong managing errors!
                                    if (jsonStats.errors.length) {
                                        messages += tu.join(jsonStats.errors, true);
                                    }
                                } else {
                                    if (treatedErrorMessages.length) {
                                        messages += tu.join(treatedErrorMessages, true);
                                    }
                                }
                            }

                            // adding the reports to the list of messages
                            if (reports.length) {
                                messages += tu.join(reports, true);
                            }

                            // and now add the messages to the output
                            str += messages.length ? tu.title('NOTES:') + messages + '\n' + lineBottom() : '';

                            // setting up the status line
                            // as the footer for the building output
                            statusLeft = ('Build #' + buildNumber).padEnd(16, ' ') + ' at ' + dt;
                            statusRight = status === 1 ? '\u2714'.padStart(12, ' ') : treatedWarns.warns.length + ' (!) ' + errorsLen + ' (\u2716)';

                            // add the status line to the output string

                            str += tu.statusLine(status, statusLeft.padEnd(lineSize() - 13, ' ') + statusRight.padStart(13, ' '));

                            if (errorsLen) {
                                // try to produce a sound when there are errors in terminal
                                // some terminals (or global configuration) may not allow
                                // the sound, though
                                tu.beep();
                            }

                            // end of loading
                            spinner.stop(true);
                            console.log(str + '\n' + lineTop());

                        case 79:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function buildRunner(_x, _x2) {
            return _ref.apply(this, arguments);
        }

        return buildRunner;
    }();
});

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(141);
module.exports = __webpack_require__(1).Object.keys;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(27);
var $keys = __webpack_require__(25);

__webpack_require__(142)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(2);
var core = __webpack_require__(1);
var fails = __webpack_require__(19);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(144), __webpack_require__(6), __webpack_require__(4), __webpack_require__(7), __webpack_require__(21), __webpack_require__(80), __webpack_require__(0), __webpack_require__(8), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('babel-runtime/core-js/get-iterator'), require('babel-runtime/regenerator'), require('babel-runtime/core-js/promise'), require('babel-runtime/helpers/asyncToGenerator'), require('chalk'), require('inquirer'), require('path'), require('fs-extra'), require('./terminal-utils'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.getIterator, global.regenerator, global.promise, global.asyncToGenerator, global.chalk, global.inquirer, global.path, global.fsExtra, global.terminalUtils);
        global.handlers = mod.exports;
    }
})(this, function (exports, _getIterator2, _regenerator, _promise, _asyncToGenerator2, _chalk, _inquirer, _path, _fsExtra, _terminalUtils) {
    'use strict';

    exports.__esModule = true;
    exports.treatWarnings = exports.treatSoftErrors = undefined;

    var _getIterator3 = _interopRequireDefault(_getIterator2);

    var _regenerator2 = _interopRequireDefault(_regenerator);

    var _promise2 = _interopRequireDefault(_promise);

    var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

    var _chalk2 = _interopRequireDefault(_chalk);

    var _inquirer2 = _interopRequireDefault(_inquirer);

    var _path2 = _interopRequireDefault(_path);

    var _fsExtra2 = _interopRequireDefault(_fsExtra);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var LINE_COL_RX = createFileLineRX();
    var FILE_RX = /((\.\.\/|\.\/|\/)\S+)/mg;
    var MOD_NOT_FOUND = new RegExp("Can\'t resolve \'([^\' ]+)\'");

    function createFileLineRX() {
        var colorIn = '(\\[\\d+m)?';
        var colorOut = '(\\[)?';
        var parts = ['(' + colorIn + '\\d+[\\, \\:]+\\d+' + colorOut + ')', '(line[ \\:]+(\\d+)[\\n \\t\\/\\|:,.]+col(umn)?[ \\:]+(\\d+))', '(' + colorIn + '(^|[\\n\\t ])' + colorIn + '\\d+[ \\,\\|\\:]+\\d+' + colorOut + '[ \\t\\n]' + colorOut + ')'];
        return new RegExp('' + parts.join('|'), 'igm');
    }

    function reset() {
        return _terminalUtils.resetEffects;
    }

    function treatStack(stack) {
        var traceLine = '';
        var trace = stack.split(/\n\n/).pop();
        trace = trace.replace(/(^|\n)([ \t]+)?at /g, '$1');
        trace = trace.split('\n').map(function (traceLine, i) {
            var tmpTraceLine = traceLine.match(/(^[^ ]+|\(([^)]+)\))/ig);
            if (tmpTraceLine && tmpTraceLine[1]) {
                traceLine = tmpTraceLine;
                traceLine[1] = traceLine[1].substr(1, traceLine[1].length - 2).split(':');
                var func = traceLine[0].padEnd(40, ' ');
                var line = traceLine[1][1];
                var col = traceLine[1][2];
                var file = traceLine[1][0] + ':' + line + ':' + col;
                var output = '  -> ' + func + _chalk2.default.bold('Line:') + ' ' + line + '   ' + _chalk2.default.bold('Col:') + ' ' + col + '\n  ' + file;
                // let's emphasize the last step in the stacktrace
                if (i === 0) {
                    output = _chalk2.default.bold(output);
                }
                return output;
            }
            return traceLine;
        });
    }

    function removeBackTick(str) {
        return str.replace('\'', '');
    }

    var getFileFromErrorObject = function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(err) {
            var removePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var ref = arguments[2];
            var opts = arguments[3];
            var file, colLine, couldntResolveModule, shallCreate, newFile, tmpColLine;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            // let file = err.message.match(FILE_RX)
                            file = void 0;
                            colLine = '';


                            if (err.error && err.error.error) {
                                file = err.error.error.message.match(FILE_RX);
                                colLine = err.error.error.message.match(LINE_COL_RX);
                            }
                            // if file was not found in the error message itself
                            if (!file) {
                                // some errors have a second level or error for children
                                if (err.error) {
                                    file = err.error.message.match(FILE_RX);
                                    colLine = colLine || err.error.message.match(LINE_COL_RX);
                                }

                                // if still don't have the file...
                                if (!file) {
                                    if (err.message) {
                                        file = err.message.match(FILE_RX);
                                        colLine = colLine || err.message.match(LINE_COL_RX);
                                    } else {
                                        file = err.toString().match(FILE_RX);
                                        colLine = colLine || err.toString().match(LINE_COL_RX);
                                    }
                                }
                            }
                            couldntResolveModule = (err.message || err.toString()).match(MOD_NOT_FOUND);

                            if (!(opts.mode === 'dev' && file[1] && (file[0].startsWith('.') || file[0].startsWith('/')) && couldntResolveModule && opts.development.autoCreateFiles !== false)) {
                                _context.next = 20;
                                break;
                            }

                            shallCreate = false;

                            if (opts.development.autoCreateFiles === 'auto') {
                                shallCreate = true;
                            }

                            if (!(opts.development.autoCreateFiles === 'interactive')) {
                                _context.next = 11;
                                break;
                            }

                            _context.next = 11;
                            return new _promise2.default(function (resolve, reject) {
                                ref.spinner.stop();
                                (0, _terminalUtils.clearTerminal)();
                                _inquirer2.default.prompt([{
                                    type: 'list',
                                    name: 'createFile',
                                    message: _chalk2.default.reset('\n' + ('Your file ' + _chalk2.default.greenBright(file[1].replace(removePath, '').replace(/^ +/g, '')) + '\n') + ('is imporing ' + _chalk2.default.redBright(file[0].replace(removePath, '').replace(/^ +/g, '')) + ',\n') + 'But it does not exist!\n') + _chalk2.default.bold('Should we create that for you?'),
                                    choices: ['yes', 'no']
                                }]).then(function (answers) {
                                    if (answers.createFile === 'yes') {
                                        shallCreate = true;
                                    } else {
                                        file = removeBackTick(file[0]);
                                    }
                                    resolve();
                                });
                            });

                        case 11:
                            if (!shallCreate) {
                                _context.next = 18;
                                break;
                            }

                            file[0] = removeBackTick(file[0]);
                            file[1] = removeBackTick(file[1]);

                            newFile = _path2.default.resolve(file[1], file[0]);

                            setTimeout(function (_) {
                                _fsExtra2.default.ensureFile(newFile);
                            }, 1000);
                            file = file[1];

                            return _context.abrupt('return', { newFile: newFile, ignoreError: true, file: file, toString: function toString() {
                                    return this.file;
                                }
                            });

                        case 18:
                            _context.next = 21;
                            break;

                        case 20:
                            file = removeBackTick(file[0]);

                        case 21:
                            // time to check for the collumn and line
                            if (colLine) {
                                colLine = colLine[0];
                                colLine = colLine.replace(/\[\d+m/g, '');
                                tmpColLine = colLine.match(/(\d+)[^\d]+(\d+)/);

                                if (tmpColLine) {
                                    colLine = {
                                        line: tmpColLine[1],
                                        col: tmpColLine[2],
                                        toString: function toString() {
                                            return 'Line: ' + this.line + ' | Col: ' + this.col + '\n';
                                        }
                                    };
                                } else {
                                    colLine += '\n';
                                }
                            } else {
                                colLine = '\n';
                            }
                            return _context.abrupt('return', {
                                file: file ? file.replace(removePath, '').replace(/^ +/g, '') : '',
                                colLine: colLine,
                                toString: function toString() {
                                    if (this.file) {
                                        return 'File: ' + _chalk2.default.italic(this.file) + '    ' + this.colLine + reset();
                                    }
                                    return this.colLine.toString() || '';
                                }
                            });

                        case 23:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        return function getFileFromErrorObject(_x) {
            return _ref.apply(this, arguments);
        };
    }();

    var treatSoftErrors = function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(stats, ref, opts) {
            var _this = this;

            var PATHS, errList, erroredFiles, stat, _loop, _iterator, _isArray, _i, _ref3, _ret, len;

            return _regenerator2.default.wrap(function _callee3$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            PATHS = ref.paths;
                            errList = [];
                            erroredFiles = [];

                            // stats.stats.forEach(async stat => {

                            _context4.t0 = _regenerator2.default.keys(stats.stats);

                        case 4:
                            if ((_context4.t1 = _context4.t0()).done) {
                                _context4.next = 17;
                                break;
                            }

                            stat = _context4.t1.value;

                            stat = stats.stats[stat];
                            // errList = errList.concat(stat.compilation.errors.map(async err => {
                            _loop = /*#__PURE__*/_regenerator2.default.mark(function _loop() {
                                var err, errMessage, fileData, msg, theError, fullMsg, message, name, codeFrame;
                                return _regenerator2.default.wrap(function _loop$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                if (!_isArray) {
                                                    _context3.next = 6;
                                                    break;
                                                }

                                                if (!(_i >= _iterator.length)) {
                                                    _context3.next = 3;
                                                    break;
                                                }

                                                return _context3.abrupt('return', 'break');

                                            case 3:
                                                _ref3 = _iterator[_i++];
                                                _context3.next = 10;
                                                break;

                                            case 6:
                                                _i = _iterator.next();

                                                if (!_i.done) {
                                                    _context3.next = 9;
                                                    break;
                                                }

                                                return _context3.abrupt('return', 'break');

                                            case 9:
                                                _ref3 = _i.value;

                                            case 10:
                                                err = _ref3;
                                                errMessage = '';
                                                fileData = {};

                                                if (!(typeof err === 'string')) {
                                                    _context3.next = 27;
                                                    break;
                                                }

                                                if (!(stat.compilation.errors.length && err.indexOf('Child compilation') < 0)) {
                                                    _context3.next = 24;
                                                    break;
                                                }

                                                _context3.next = 17;
                                                return getFileFromErrorObject(err, PATHS.project, ref, opts);

                                            case 17:
                                                fileData = _context3.sent;
                                                msg = err.message || err.toString();

                                                msg = msg.replace(PATHS.project + (fileData.file || ''), '');
                                                msg = '' + fileData + reset() + msg + (err.codeFrame ? '\n' + err.codeFrame + '\n' : '') + reset();
                                                errMessage = msg;
                                                _context3.next = 25;
                                                break;

                                            case 24:
                                                // is a child's error
                                                errMessage = stat.compilation.children.map(function () {
                                                    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(child) {
                                                        var ret, _iterator2, _isArray2, _i2, _msg;

                                                        return _regenerator2.default.wrap(function _callee2$(_context2) {
                                                            while (1) {
                                                                switch (_context2.prev = _context2.next) {
                                                                    case 0:
                                                                        // return await child.errors.map(async err => {
                                                                        ret = [];
                                                                        _iterator2 = child.errors, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);

                                                                    case 2:
                                                                        if (!_isArray2) {
                                                                            _context2.next = 8;
                                                                            break;
                                                                        }

                                                                        if (!(_i2 >= _iterator2.length)) {
                                                                            _context2.next = 5;
                                                                            break;
                                                                        }

                                                                        return _context2.abrupt('break', 21);

                                                                    case 5:
                                                                        err = _iterator2[_i2++];
                                                                        _context2.next = 12;
                                                                        break;

                                                                    case 8:
                                                                        _i2 = _iterator2.next();

                                                                        if (!_i2.done) {
                                                                            _context2.next = 11;
                                                                            break;
                                                                        }

                                                                        return _context2.abrupt('break', 21);

                                                                    case 11:
                                                                        err = _i2.value;

                                                                    case 12:
                                                                        _context2.next = 14;
                                                                        return getFileFromErrorObject(err, PATHS.project, ref, opts);

                                                                    case 14:
                                                                        fileData = _context2.sent;
                                                                        _msg = err.message || err.toString();

                                                                        _msg = _msg.replace(PATHS.project + (fileData.file || ''), '');
                                                                        _msg = '' + fileData + reset() + _msg + (err.codeFrame ? '\n' + err.codeFrame + '\n' : '') + _chalk2.default.reset();
                                                                        ret.push(_msg);

                                                                    case 19:
                                                                        _context2.next = 2;
                                                                        break;

                                                                    case 21:
                                                                        ret = ret.join('\n');

                                                                    case 22:
                                                                    case 'end':
                                                                        return _context2.stop();
                                                                }
                                                            }
                                                        }, _callee2, _this);
                                                    }));

                                                    return function (_x6) {
                                                        return _ref4.apply(this, arguments);
                                                    };
                                                }()).join('\n').replace(/^\n/, '');

                                            case 25:
                                                _context3.next = 40;
                                                break;

                                            case 27:
                                                // this is a compilation error
                                                theError = err.error;

                                                if (theError) {
                                                    theError = theError.error || theError;
                                                } else {
                                                    theError = err;
                                                }
                                                fullMsg = void 0;
                                                // let theError = err.error.error || err.error

                                                if (err.message.split('\n').length > theError.message.split('\n').length) {
                                                    fullMsg = err.message;
                                                } else {
                                                    fullMsg = theError.message;
                                                }
                                                // clean it up (remove stacktrace in case it was added to the message)
                                                fullMsg = fullMsg.replace(/\n(\t| +)(at|@) [^\n]+/gm, '');

                                                // let fullMsg = theError.message.replace(/^[\t\n\r ]+/g, '')      // Alternative A
                                                // let fullMsg = err.message.replace(/^[\t\n\r ]+/g, '')        // Alternative B
                                                // Alternative C (same as B, but not using the codeframe in the end)
                                                _context3.next = 34;
                                                return getFileFromErrorObject(err, PATHS.project, ref, opts);

                                            case 34:
                                                fileData = _context3.sent;


                                                // let file = fullMsg.substr(0, fullMsg.indexOf(':'))
                                                // file = file || fullMsg.substr(0, fullMsg.indexOf('\n'))
                                                // removing the repetitive portion of the path
                                                // file = file ? file.shift()
                                                // let message = fullMsg.substr(fullMsg.indexOf(' '))
                                                message = fullMsg.replace(PATHS.project + (fileData.file || ''), '');
                                                name = theError.name;
                                                codeFrame = theError.codeFrame;

                                                codeFrame = codeFrame ? '\n\n' + codeFrame : '';

                                                errMessage = _chalk2.default.bold(name) + '\n' + fileData + reset() + message + codeFrame + reset();

                                            case 40:
                                                if (fileData && fileData.file) {
                                                    erroredFiles.push(fileData.file);
                                                }
                                                if (fileData.ignoreError) {
                                                    errList.push('[i] > Module ' + fileData.file + ' not found.\nThis file will be created at ' + fileData.newFile);
                                                } else {
                                                    errList.push(errMessage);
                                                }
                                                // return errMessage

                                            case 42:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _loop, _this);
                            });
                            _iterator = stat.compilation.errors, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);

                        case 9:
                            return _context4.delegateYield(_loop(), 't2', 10);

                        case 10:
                            _ret = _context4.t2;

                            if (!(_ret === 'break')) {
                                _context4.next = 13;
                                break;
                            }

                            return _context4.abrupt('break', 15);

                        case 13:
                            _context4.next = 9;
                            break;

                        case 15:
                            _context4.next = 4;
                            break;

                        case 17:
                            len = errList.length;

                            errList.forEach(function (err, i) {
                                errList[i] = _chalk2.default.bold.red('\n' + _terminalUtils.symbols.error + (len > 1 ? i + 1 + ') ' : '')) + errList[i];
                            });
                            return _context4.abrupt('return', {
                                erroredFiles: erroredFiles,
                                messages: errList
                            });

                        case 20:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee3, this);
        }));

        return function treatSoftErrors(_x3, _x4, _x5) {
            return _ref2.apply(this, arguments);
        };
    }();

    function treatWarnings(warnsList, PATHS, opts) {
        var warns = [];
        var infos = [];

        // we have to treat each warning message
        warnsList.forEach(function (warn, i) {
            // if there is more than one, we add a counter

            // we can clean a little more, the warning messages
            if (warn.replace) {
                warn = warn.replace(/^\(undefined\) /, '');
                // and if it is a recomendation, we change it to type info
                if (warn.match(/webpack [a-z0-9_\-\.]+ recommendations\:/)) {
                    infos.push((0, _terminalUtils.infoMessage)(warn));
                } else {
                    warns.push((0, _terminalUtils.warnMessage)(warn));
                }
            }
        });

        return {
            warns: warns,
            infos: infos
        };
    }

    exports.treatSoftErrors = treatSoftErrors;
    exports.treatWarnings = treatWarnings;
});

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(145), __esModule: true };

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38);
__webpack_require__(28);
module.exports = __webpack_require__(146);


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(11);
var get = __webpack_require__(53);
module.exports = __webpack_require__(1).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_147__;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = require("readline");

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_149__;

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = require("stream");

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_151__;

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_152__;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6), __webpack_require__(18), __webpack_require__(4), __webpack_require__(7), __webpack_require__(0), __webpack_require__(81), __webpack_require__(154), __webpack_require__(155), __webpack_require__(156), __webpack_require__(17), __webpack_require__(21)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/promise'), require('babel-runtime/helpers/asyncToGenerator'), require('path'), require('fs'), require('depcheck'), require('package-json'), require('semver'), require('./utils'), require('chalk'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.assign, global.promise, global.asyncToGenerator, global.path, global.fs, global.depcheck, global.packageJson, global.semver, global.utils, global.chalk);
    global.moduleVerifier = mod.exports;
  }
})(this, function (exports, _regenerator, _assign, _promise, _asyncToGenerator2, _path, _fs, _depcheck, _packageJson, _semver, _utils, _chalk) {
  'use strict';

  exports.__esModule = true;
  exports.getOutdated = exports.analyzeDependencies = undefined;

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _assign2 = _interopRequireDefault(_assign);

  var _promise2 = _interopRequireDefault(_promise);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _path2 = _interopRequireDefault(_path);

  var _fs2 = _interopRequireDefault(_fs);

  var _depcheck2 = _interopRequireDefault(_depcheck);

  var _packageJson2 = _interopRequireDefault(_packageJson);

  var _semver2 = _interopRequireDefault(_semver);

  var _chalk2 = _interopRequireDefault(_chalk);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var getOutdated = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(pkgPath) {
      var _this = this;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt('return', new _promise2.default(function () {
                var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(resolve, reject) {
                  var pkg, deps, list, promiseList, reports, dep, remoteDeps;
                  return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return (0, _utils.readFile)(pkgPath, 'utf-8');

                        case 2:
                          pkg = _context.sent;

                          pkg = JSON.parse(pkg);
                          deps = (0, _assign2.default)({}, pkg.devDependencies, pkg.dependencies);
                          list = [];
                          promiseList = [];
                          reports = [];

                          for (dep in deps) {
                            if (deps[dep].match(/^[\^\~\d]+\.\d+\.\d+/)) {
                              // is a valid version number
                              promiseList.push((0, _packageJson2.default)(dep));
                            }
                          }
                          remoteDeps = void 0;
                          _context.prev = 10;
                          _context.next = 13;
                          return _promise2.default.all(promiseList);

                        case 13:
                          remoteDeps = _context.sent;

                          remoteDeps.forEach(function (dep) {
                            // let's see if the version fits in the range
                            if (_semver2.default.satisfies(dep.version, deps[dep.name]) && _semver2.default.intersects(dep.version, deps[dep.name])) {
                              list.push(_chalk2.default.bold(dep.name) + ': ' + _chalk2.default.red(deps[dep.name]) + ' |-> ' + _chalk2.default.green(dep.version));
                            }
                          });
                          _context.next = 19;
                          break;

                        case 17:
                          _context.prev = 17;
                          _context.t0 = _context['catch'](10);

                        case 19:
                          resolve(list);

                        case 20:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this, [[10, 17]]);
                }));

                return function (_x2, _x3) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function getOutdated(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var analyzeDependencies = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(PROJECT_PATH, configList) {
      var AVAILABLE_ALIASES;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              AVAILABLE_ALIASES = {};

              configList.forEach(function (config) {
                if (config.resolve && config.resolve.alias) {
                  AVAILABLE_ALIASES = (0, _assign2.default)({}, AVAILABLE_ALIASES, config.resolve.alias);
                }
              });

              return _context3.abrupt('return', new _promise2.default(function (resolve, reject) {
                (0, _depcheck2.default)(PROJECT_PATH, {
                  update: true,
                  skipUnused: false,
                  directory: PROJECT_PATH,
                  parsers: {
                    '*.js': _depcheck2.default.parser.es6,
                    '*.mjs': _depcheck2.default.parser.es6,
                    '*.jsx': _depcheck2.default.parser.jsx
                  },
                  ignoreMatches: ['grunt-*', 'webpack-*', 'dist/*', '*-loader', 'eshint', 'eslint', 'babel', 'vue', '*.coffee', '*.vue', '*.ts', '*.tsx', 'preact-compat'],
                  detectors: [_depcheck2.default.detector.requireCallExpression, function (node) {
                    if (node.type === 'ImportDeclaration' && node.source && node.source.value) {
                      for (var key in AVAILABLE_ALIASES) {
                        if (node.source.value.startsWith('.') || node.source.value.startsWith('/')) {
                          return [];
                        }
                        if (node.source.value.startsWith(key + '/') || node.source.value === key) {
                          var res = node.source.value.replace(key, AVAILABLE_ALIASES[key]);
                          return [res];
                        }
                      }
                      return [node.source.value];
                    }
                    return [];
                  }]
                }, function (unused) {
                  var unusedModules = unused.dependencies.concat(unused.devDependencies);
                  resolve({
                    unused: unusedModules
                  });
                });
              }));

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    return function analyzeDependencies(_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();

  exports.analyzeDependencies = analyzeDependencies;
  exports.getOutdated = getOutdated;
});

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_154__;

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_155__;

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_156__;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6), __webpack_require__(7), __webpack_require__(8), __webpack_require__(0), __webpack_require__(158)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/helpers/asyncToGenerator'), require('fs-extra'), require('path'), require('node-fetch'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.asyncToGenerator, global.fsExtra, global.path, global.nodeFetch);
    global.licenseManager = mod.exports;
  }
})(this, function (exports, _regenerator, _asyncToGenerator2, _fsExtra, _path, _nodeFetch) {
  'use strict';

  exports.__esModule = true;

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _fsExtra2 = _interopRequireDefault(_fsExtra);

  var _path2 = _interopRequireDefault(_path);

  var _nodeFetch2 = _interopRequireDefault(_nodeFetch);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _ghLicensesAPI;

  var ISC = 'Copyright (c) [year], [fullname]\n\nPermission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.\n\nTHE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.';

  var APIPath = 'https://api.github.com/licenses/';
  var ghLicensesAPI = (_ghLicensesAPI = {
    "agpl": "agpl-3.0",
    "agpl-3.0": "agpl-3.0",
    "agpl-3": "agpl-3.0",
    "agpl3": "agpl-3.0"
  }, _ghLicensesAPI['agpl'] = "agpl-3.0", _ghLicensesAPI["unlicense"] = "unlicense", _ghLicensesAPI["epl-2.0"] = "epl-2.0", _ghLicensesAPI["epl-2"] = "epl-2.0", _ghLicensesAPI["epl2"] = "epl-2.0", _ghLicensesAPI["epl"] = "epl-2.0", _ghLicensesAPI["mit"] = "mit", _ghLicensesAPI["lgpl-2.1"] = "lgpl-2.1", _ghLicensesAPI["lgpl-2"] = "lgpl-2.1", _ghLicensesAPI["lgpl2"] = "lgpl-2.1", _ghLicensesAPI["lgpl"] = "lgpl-2.1", _ghLicensesAPI["mpl-2.0"] = "mpl-2.0", _ghLicensesAPI["mpl-2"] = "mpl-2.0", _ghLicensesAPI["mpl2"] = "mpl-2.0", _ghLicensesAPI["apache-2.0"] = "apache-2.0", _ghLicensesAPI["apache-2"] = "apache-2.0", _ghLicensesAPI["apache2"] = "apache-2.0", _ghLicensesAPI["apache"] = "apache-2.0", _ghLicensesAPI["gpl-2.0"] = "gpl-2.0", _ghLicensesAPI["gpl-2"] = "gpl-2.0", _ghLicensesAPI["gpl2"] = "gpl-2.0", _ghLicensesAPI["gpl-3.0"] = "gpl-3.0", _ghLicensesAPI["gpl-3"] = "gpl-3.0", _ghLicensesAPI["gpl3"] = "gpl-3.0", _ghLicensesAPI["gpl"] = "gpl-3.0", _ghLicensesAPI["bsd-2-clause"] = "bsd-2-clause", _ghLicensesAPI["bsd-2"] = "bsd-2-clause", _ghLicensesAPI["bsd2"] = "bsd-2-clause", _ghLicensesAPI["bsd-3-clause"] = "bsd-3-clause", _ghLicensesAPI["bsd-3"] = "bsd-3-clause", _ghLicensesAPI["bsd3"] = "bsd-3-clause", _ghLicensesAPI["bsd"] = "bsd-3-clause", _ghLicensesAPI["lgpl-3.0"] = "lgpl-3.0", _ghLicensesAPI["lgpl-3"] = "lgpl-3.0", _ghLicensesAPI["lgpl3"] = "lgpl-3.0", _ghLicensesAPI['lgpl'] = "lgpl-3.0", _ghLicensesAPI);

  var ensureLicense = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(PATHS, pkg) {
      var projectPath, validLicenseFiles, l, theLicense, license;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              projectPath = PATHS.project;
              validLicenseFiles = ['LICENSE', 'LICENSE.txt', 'LICENSE.md'];

              // if there is already a license file, we do nothing

              _context.t0 = _regenerator2.default.keys(validLicenseFiles);

            case 3:
              if ((_context.t1 = _context.t0()).done) {
                _context.next = 11;
                break;
              }

              l = _context.t1.value;
              _context.next = 7;
              return _fsExtra2.default.pathExists(_path2.default.resolve(projectPath, validLicenseFiles[l]));

            case 7:
              if (!_context.sent) {
                _context.next = 9;
                break;
              }

              return _context.abrupt('return');

            case 9:
              _context.next = 3;
              break;

            case 11:
              if (!pkg.license) {
                _context.next = 31;
                break;
              }

              theLicense = pkg.license.toLowerCase();

              if (!(theLicense === 'isc')) {
                _context.next = 17;
                break;
              }

              theLicense = ISC;
              _context.next = 28;
              break;

            case 17:
              if (!ghLicensesAPI[theLicense]) {
                _context.next = 28;
                break;
              }

              _context.next = 20;
              return (0, _nodeFetch2.default)(APIPath + ghLicensesAPI[theLicense]);

            case 20:
              license = _context.sent;
              _context.t2 = JSON;
              _context.next = 24;
              return license.text();

            case 24:
              _context.t3 = _context.sent;
              license = _context.t2.parse.call(_context.t2, _context.t3);

              license = license.body;
              theLicense = license;

            case 28:

              theLicense = theLicense.replace(/\[year\]/i, new Date().getFullYear());
              if (pkg.author) {
                theLicense = theLicense.replace(/\[fullname\]/i, pkg.author);
              }

              _fsExtra2.default.writeFile(_path2.default.resolve(projectPath, validLicenseFiles[0]), theLicense);

            case 31:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function ensureLicense(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  exports.default = ensureLicense;
});

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_158__;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6), __webpack_require__(7), __webpack_require__(4), __webpack_require__(0), __webpack_require__(81), __webpack_require__(21), __webpack_require__(59), __webpack_require__(15), __webpack_require__(17), __webpack_require__(160)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/helpers/asyncToGenerator'), require('babel-runtime/core-js/promise'), require('path'), require('fs'), require('chalk'), require('child_process'), require('./terminal-utils'), require('./utils'), require('net'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.regenerator, global.asyncToGenerator, global.promise, global.path, global.fs, global.chalk, global.child_process, global.terminalUtils, global.utils, global.net);
        global.httpServer = mod.exports;
    }
})(this, function (exports, _regenerator, _asyncToGenerator2, _promise, _path, _fs, _chalk, _child_process, _terminalUtils, _utils, _net) {
    'use strict';

    exports.__esModule = true;

    var _regenerator2 = _interopRequireDefault(_regenerator);

    var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

    var _promise2 = _interopRequireDefault(_promise);

    var _path2 = _interopRequireDefault(_path);

    var _fs2 = _interopRequireDefault(_fs);

    var _chalk2 = _interopRequireDefault(_chalk);

    var _net2 = _interopRequireDefault(_net);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var ENFORCE_PORT_LIMIT = 30;
    // import helmet from 'helmet'
    // const RateLimit = require('express-rate-limit');

    function getAvailablePort(startingAt) {

        function getNextAvailablePort(currentPort, cb) {
            var server = _net2.default.createServer();
            server.listen(currentPort, function (_) {
                server.once('close', function (_) {
                    cb(currentPort);
                });
                server.close();
            });
            server.on('error', function (_) {
                getNextAvailablePort(currentPort + 1, cb);
            });
        }

        return new _promise2.default(function (resolve) {
            getNextAvailablePort(startingAt, resolve);
        });
    }

    var HTTP_SERVER = {
        // status: false,
        src: '',
        service: false,
        enforcePortCounter: 0,
        isPortInUse: function isPortInUse(nodeServicePath, opts) {
            var _this = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                return _context2.abrupt('return', new _promise2.default(function () {
                                    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(resolve, reject) {
                                        var port, extraInfo, pid;
                                        return _regenerator2.default.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        _context.next = 2;
                                                        return getAvailablePort(opts.server.port);

                                                    case 2:
                                                        port = _context.sent;

                                                        if (!(port !== opts.server.port)) {
                                                            _context.next = 27;
                                                            break;
                                                        }

                                                        if (!opts.server.enforcePort) {
                                                            _context.next = 23;
                                                            break;
                                                        }

                                                        // we will find its service
                                                        extraInfo = (0, _child_process.execSync)('lsof -i:' + opts.server.port + ' -Fp'
                                                        // `ps -ax | grep "${nodeServicePath} spawned ${opts.server.port}"`
                                                        ).toString();

                                                        if (!extraInfo) {
                                                            _context.next = 21;
                                                            break;
                                                        }

                                                        pid = extraInfo.split('\n')[0].replace(/\D/g, '');

                                                        // if we tried it many times and still couldn't get the door
                                                        // we give up

                                                        if (!(_this.enforcePortCounter > ENFORCE_PORT_LIMIT)) {
                                                            _context.next = 11;
                                                            break;
                                                        }

                                                        resolve(pid);
                                                        return _context.abrupt('return');

                                                    case 11:
                                                        _context.prev = 11;
                                                        _context.next = 14;
                                                        return (0, _utils.killProcessTree)(pid);

                                                    case 14:
                                                        _this.enforcePortCounter++;

                                                        // execSync(`kill -9 ${pid}`)
                                                        return _context.abrupt('return', _this.isPortInUse(nodeServicePath, opts).then(resolve));

                                                    case 18:
                                                        _context.prev = 18;
                                                        _context.t0 = _context['catch'](11);

                                                        resolve(pid);

                                                    case 21:
                                                        resolve();
                                                        return _context.abrupt('return');

                                                    case 23:
                                                        if (!opts.server.portLookup) {
                                                            _context.next = 27;
                                                            break;
                                                        }

                                                        opts.server.port = port;
                                                        resolve();
                                                        return _context.abrupt('return');

                                                    case 27:
                                                        resolve();

                                                    case 28:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this, [[11, 18]]);
                                    }));

                                    return function (_x, _x2) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()));

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this);
            }))();
        },
        start: function start(data) {
            var _this2 = this;

            return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
                var compiler, opts, config, paths, stats, spawnOpts, nodeServicePath, portInUse;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                compiler = data.compiler, opts = data.opts, config = data.config, paths = data.paths, stats = data.stats;

                                opts.server = opts.server || {};
                                opts.server.port = opts.server.port || _utils.DEFAULT_DEV_SERVER_PORT;

                                // if the server has already started, we stop it
                                if (HTTP_SERVER.service) {
                                    try {
                                        HTTP_SERVER.service.kill();
                                    } catch (e) {}
                                }

                                spawnOpts = {
                                    env: process.env
                                };

                                if (opts.server.verbose) {
                                    spawnOpts.stdio = [0, // Use parent's stdin for child
                                    'pipe'];
                                }

                                nodeServicePath = _path2.default.resolve(paths.dist, 'server');
                                _context3.next = 9;
                                return _this2.isPortInUse(nodeServicePath, opts);

                            case 9:
                                portInUse = _context3.sent;


                                HTTP_SERVER.service = (0, _child_process.spawn)('node', [nodeServicePath, 'spawned', opts.server.port], spawnOpts);

                                global.httpServerProcess = HTTP_SERVER.service;

                                stats.httpServerService = HTTP_SERVER.service;

                                HTTP_SERVER.service.stdout.on('data', function (data) {
                                    if (opts.server.verbose) {
                                        console.log((0, _terminalUtils.logMessage)(data));
                                    }
                                });

                                HTTP_SERVER.service.stderr.on('data', function (data) {
                                    // in case of any error, we deal with it
                                    data = data.message || data;
                                    data = data.toString();

                                    // console.warn is treated as error in node
                                    // let's show it differently
                                    var isWarning = false;
                                    if (data.startsWith('__FURTHER__WARNING__MESSAGE__')) {
                                        data = data.replace('__FURTHER__WARNING__MESSAGE__', '');
                                        isWarning = true;
                                    }

                                    var extraInfo = '';
                                    // if the problem is that the port is in use
                                    if (data.indexOf && data.indexOf('EADDRINUSE') >= 0) {
                                        // we will look for the current PID using it
                                        if (portInUse) {
                                            extraInfo = 'The most likely PID using that port is ' + _chalk2.default.bold.red(portInUse) + '\n' + ('Try killing it with: ' + _chalk2.default.bold.white.bgBlueBright('kill -9 ' + portInUse));
                                        }
                                    }

                                    stats.compilation[isWarning ? 'warnings' : 'errors'].push({
                                        name: 'HTTP Server Startup',
                                        message: (data.message || data) + '\n' + extraInfo
                                    });
                                });

                                HTTP_SERVER.service.on('close', function (code) {
                                    if (opts.server.verbose) {
                                        console.log((0, _terminalUtils.infoMessage)('HTTP Server stoped. Code: ' + code));
                                    }
                                });
                                return _context3.abrupt('return', HTTP_SERVER.service);

                            case 17:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            }))();
        }
    };

    exports.default = HTTP_SERVER;
});

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = require("net");

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6), __webpack_require__(7), __webpack_require__(4), __webpack_require__(57), __webpack_require__(85), __webpack_require__(15), __webpack_require__(21), __webpack_require__(8), __webpack_require__(0), __webpack_require__(162)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/helpers/asyncToGenerator'), require('babel-runtime/core-js/promise'), require('babel-runtime/helpers/classCallCheck'), require('os'), require('./terminal-utils'), require('chalk'), require('fs-extra'), require('path'), require('node-pty'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.regenerator, global.asyncToGenerator, global.promise, global.classCallCheck, global.os, global.terminalUtils, global.chalk, global.fsExtra, global.path, global.nodePty);
        global.installer = mod.exports;
    }
})(this, function (exports, _regenerator, _asyncToGenerator2, _promise, _classCallCheck2, _os, _terminalUtils, _chalk, _fsExtra, _path, pty) {
    'use strict';

    exports.__esModule = true;

    var _regenerator2 = _interopRequireDefault(_regenerator);

    var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

    var _promise2 = _interopRequireDefault(_promise);

    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

    var _os2 = _interopRequireDefault(_os);

    var tu = _interopRequireWildcard(_terminalUtils);

    var _chalk2 = _interopRequireDefault(_chalk);

    var _fsExtra2 = _interopRequireDefault(_fsExtra);

    var _path2 = _interopRequireDefault(_path);

    function _interopRequireWildcard(obj) {
        if (obj && obj.__esModule) {
            return obj;
        } else {
            var newObj = {};

            if (obj != null) {
                for (var key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
                }
            }

            newObj.default = obj;
            return newObj;
        }
    }

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var Installer = function () {
        function Installer(installData, callback) {
            var _this = this;

            (0, _classCallCheck3.default)(this, Installer);

            this.installData = installData;
            this.name = this.installData.dep.split('@')[0];
            this.version = this.installData.dep.split('@')[1];
            if (!this.version.match(/^[\^\~\*]/)) {
                this.version = '^' + this.version;
            }

            return new _promise2.default(function (resolve, reject) {
                var shell = _os2.default.platform() === 'win32' ? 'powershell.exe' : 'bash';
                var ptyProcess = pty.spawn(shell, [], {
                    name: 'xterm-color',
                    TERM: 'xterm-256color',
                    COLORTERM: 'truecolor',
                    cols: 80,
                    rows: 30,
                    cwd: installData.cwd,
                    env: process.env,
                    stdio: ['inherit', 'inherit', 'inherit', 'ipc']
                });

                _this.updateLine(true, null, 'Preparing...');
                ptyProcess.on('data', function (data) {

                    if (_this.exited) {
                        return;
                    }

                    data = data.toString();

                    if (!data || data.startsWith('npm install ') || data == '\n' || data == '\r') {
                        return;
                    }

                    if (!_this.hasErrors && (data.startsWith('npm ERR!') || data.startsWith('ERR'))) {
                        _this.hasErrors = true;
                        console.log('\n' + _chalk2.default.bgRed(_this.installData.dep) + ' > ' + data);
                        return;
                    }

                    // the progress bar looks like this: ⸨  ░░░░░░░░░░░░░░░░⸩
                    if (data.startsWith('⸨')) {
                        var progress = data.match(/(⸨[^⸩]+⸩)(.+)/);
                        if (progress) {
                            _this.updateLine(false, _chalk2.default.greenBright(progress[1].slice(1, -1)) + progress[2].substring(0, 2), progress[2].substring(3));
                        }
                    } else {
                        if (_this.hasErrors) {
                            process.stdout.write(data);
                        }
                    }
                });

                var commands = [
                // installs the dependency in the separate path
                'npm install ' + installData.dep + ' ' + ('--prefix ./.tmp-installing-files/' + _this.name) + ' | grep \'\u2E28\''];
                ptyProcess.write(commands.join(' && ') + '; exit\r');

                // ptyProcess.on('error', data => {
                //     console.log('ERRRRROR', arguments)
                // })

                var instalationNodeModules = _path2.default.resolve(installData.cwd, 'node_modules/');
                var tmpInstalationPath = _path2.default.resolve(installData.cwd, '.tmp-installing-files/');

                ptyProcess.on('exit', function (_) {
                    _this.exited = true;
                    try {
                        ptyProcess.kill();
                    } catch (error) {}
                    if (_this.hasErrors) {
                        // failed
                        _this.updateLine(false, _chalk2.default.bgRedred(''.padStart(18, ' ')), 'Installation failed!');
                        reject(_this);
                    } else {

                        _this.updateLine(false, _chalk2.default.greenBright(''.padStart(18, '█')), 'Moving and updating dependencies...');

                        // read the lock-file
                        _fsExtra2.default.readFile(_path2.default.resolve(tmpInstalationPath, _this.name, 'package-lock.json')).then(function () {
                            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(content) {
                                var dependencies, dep;
                                return _regenerator2.default.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                dependencies = JSON.parse(content).dependencies;

                                                // move each installed dependency into the further's node_module

                                                _context.t0 = _regenerator2.default.keys(dependencies);

                                            case 2:
                                                if ((_context.t1 = _context.t0()).done) {
                                                    _context.next = 15;
                                                    break;
                                                }

                                                dep = _context.t1.value;
                                                _context.prev = 4;
                                                _context.next = 7;
                                                return _fsExtra2.default.move(
                                                // from
                                                _path2.default.resolve(tmpInstalationPath, _this.name, 'node_modules', dep),
                                                // to
                                                _path2.default.resolve(instalationNodeModules, dep
                                                // 'node_modules'
                                                ), {
                                                    overwrite: false
                                                });

                                            case 7:
                                                _context.next = 13;
                                                break;

                                            case 9:
                                                _context.prev = 9;
                                                _context.t2 = _context['catch'](4);

                                                // tu.errorMessage('Failed moving dependencies for ' + dep, err)
                                                reject('Failed moving dependencies for ' + _this.name + '\n' + _context.t2);
                                                return _context.abrupt('return');

                                            case 13:
                                                _context.next = 2;
                                                break;

                                            case 15:

                                                // remove the whole directory from the tmp dir
                                                _fsExtra2.default.remove(_path2.default.resolve(tmpInstalationPath, _this.name));

                                                if (callback) {
                                                    callback(_this);
                                                }

                                                // update the information in the terminal
                                                _this.updateLine(false, _chalk2.default.greenBright(''.padStart(18, '█')), 'Done');

                                                // resolve with the package-lock installed dependencies (within installData)
                                                resolve(_this);

                                            case 19:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this, [[4, 9]]);
                            }));

                            return function (_x) {
                                return _ref.apply(this, arguments);
                            };
                        }()).catch(function (e) {
                            reject('Failed recovering information about the module ' + _this.installed.installData.dep + ' just installed: ' + e);
                        });
                    }
                });
            });
        }

        Installer.prototype.updateLine = function updateLine(full) {
            if (full) {
                tu.moveTo('position', {
                    row: this.installData.pos.row + 1,
                    col: this.installData.pos.col
                });
                var dep = this.installData.dep.split('@');
                // crtical some times takes about a minute to install
                if (dep[0] === 'critical') {
                    dep[0] += ' (may take a minute)';
                }

                process.stdout.write(_chalk2.default.dim(''.padStart(18, '░')) + ' | ' + _chalk2.default.bold('Pkg: ') + _chalk2.default.underline(dep[0].padEnd(40).substring(0, 40)) + _chalk2.default.bold(' Vs: ') + _chalk2.default.underline(dep[1] === '*' ? 'any      ' : dep[1]));
            } else {
                tu.moveTo('position', {
                    row: this.installData.pos.row + 1,
                    col: this.installData.pos.col
                });
            }

            process.stdout.write(((arguments.length <= 1 ? undefined : arguments[1]) || '') + '\n' + _chalk2.default.dim(((arguments.length <= 2 ? undefined : arguments[2]) || '').substring(0, 60)) + '\x1b[K');
            tu.moveTo('position', {
                row: this.installData.startingRow + this.installData.concurrently * 2 + 2,
                col: 0
            });
        };

        return Installer;
    }();

    exports.default = Installer;
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_162__;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(6), __webpack_require__(18), __webpack_require__(7), __webpack_require__(4), __webpack_require__(164), __webpack_require__(171), __webpack_require__(165), __webpack_require__(8), __webpack_require__(168), __webpack_require__(15), __webpack_require__(82)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/core-js/object/assign'), require('babel-runtime/helpers/asyncToGenerator'), require('babel-runtime/core-js/promise'), require('clean-webpack-plugin'), require('./configure-client.js'), require('./configure-server.js'), require('fs-extra'), require('./node-inspector-server'), require('./terminal-utils'), require('./meta-manager'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.assign, global.asyncToGenerator, global.promise, global.cleanWebpackPlugin, global.configureClient, global.configureServer, global.fsExtra, global.nodeInspectorServer, global.terminalUtils, global.metaManager);
    global.appWpConfig = mod.exports;
  }
})(this, function (exports, _regenerator, _assign, _asyncToGenerator2, _promise, _cleanWebpackPlugin, _configureClient, _configureServer, _fsExtra, _nodeInspectorServer, _terminalUtils, _metaManager) {
  'use strict';

  exports.__esModule = true;
  exports.default = getWebpackConfig;

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _assign2 = _interopRequireDefault(_assign);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _promise2 = _interopRequireDefault(_promise);

  var _cleanWebpackPlugin2 = _interopRequireDefault(_cleanWebpackPlugin);

  var _configureClient2 = _interopRequireDefault(_configureClient);

  var _configureServer2 = _interopRequireDefault(_configureServer);

  var _fsExtra2 = _interopRequireDefault(_fsExtra);

  var _nodeInspectorServer2 = _interopRequireDefault(_nodeInspectorServer);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  // import ExtractTextPlugin from "extract-text-webpack-plugin"
  // import postCSSNext from 'postcss-cssnext'
  // import glob from 'glob'
  // import opn from 'opn'
  // import os from 'os'
  function getWebpackConfig() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _this = this;

    var PATHS = arguments[1];
    var appRef = arguments[2];

    // setting some evironment constants based on the settings
    var IS_DEV = opts.mode === 'dev';
    var PROJECT_PATH = PATHS.project; // path.resolve(path.dirname(process.argv[1]))
    var OUTPUT_PATH = PATHS.dist; // path.resolve(PROJECT_PATH, opts.outputPath)
    var SRC_PATH = PATHS.src; // path.resolve(PROJECT_PATH, opts.src)
    var FURTHER_PATH = PATHS.further; // process.cwd()
    var USED_EXTENSIONS = PATHS.usedExtensions;
    var FURTHER_REF = PATHS.furtherRef;
    // const AVAILABLE_ALIASES = [
    //   'react',
    //   'Components',
    //   'Comps',
    //   'Main',
    //   'Utils',
    //   'Templates'
    // ]

    return new _promise2.default(function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(resolve) {
        var configure = function () {
          var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var state, pList;
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    state = {
                      COMMON_CONFIG: COMMON_CONFIG,
                      SRC_PATH: SRC_PATH,
                      OUTPUT_PATH: OUTPUT_PATH,
                      IS_DEV: IS_DEV,
                      PROJECT_PATH: PROJECT_PATH,
                      FURTHER_PATH: FURTHER_PATH,
                      // FURTHER_REF: PATHS.furtherRef,
                      appRef: appRef,
                      USED_EXTENSIONS: USED_EXTENSIONS,
                      FURTHER_REF: FURTHER_REF
                    };
                    _context.next = 3;
                    return (0, _metaManager.setupFurtherDir)(PATHS);

                  case 3:
                    _context.next = 5;
                    return _fsExtra2.default.ensureDir(PATHS.src);

                  case 5:
                    _context.next = 7;
                    return (0, _metaManager.ensureEditorConfig)(PATHS);

                  case 7:
                    pList = [];

                    if (opts.server) {
                      pList.push((0, _configureServer2.default)(opts, state, appRef));
                    }
                    if (opts.client) {
                      pList.push((0, _configureClient2.default)(opts, state, appRef));
                    }
                    if (opts.cli) {
                      pList.push(configureCli(opts, state, appRef));
                    }

                    _promise2.default.all(pList).then(function (result) {
                      resolve(result);
                    }).catch(function (err) {
                      console.error(err);
                    });

                  case 12:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          return function configure() {
            return _ref2.apply(this, arguments);
          };
        }();

        var COMMON_CONFIG, CLI_CONFIG, configureCli;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                configureCli = function configureCli() {
                  CLI_CONFIG.target = 'async-node';
                  return (0, _assign2.default)({}, COMMON_CONFIG, CLI_CONFIG);
                };

                opts.outputPath = opts.outputPath || 'dist';
                opts.src = opts.src || 'src';
                opts.development = opts.development || {};
                opts.production = opts.production || {};

                // function SilentHardSource() {}
                // SilentHardSource.prototype.apply = function(compiler) {
                //   compiler.plugin('hard-source-log', function(message) {
                //     if (message.level === 'error' /* || message.level === 'warning' */) {
                //       console[message.level].call(
                //         console,
                //         'hard-source:' + message.from, message.message
                //       );
                //     }
                //   });
                // }

                COMMON_CONFIG = {
                  context: PROJECT_PATH,
                  plugins: [new _cleanWebpackPlugin2.default([opts.outputPath], {
                    root: PROJECT_PATH,
                    verbose: false,
                    silent: true
                  })],
                  resolve: {
                    extensions: [".webpack.js", ".web.js", ".ts", ".js", ".tsx", ".mjs", ".jsx", ".coffee", ".vue", ".less", ".styl", ".sass"],
                    alias: {}
                  }
                };
                CLI_CONFIG = {};


                (0, _terminalUtils.clearTerminal)();

                // if it is in devMode and debug is true

                if (!(IS_DEV && opts.debug)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 11;
                return (0, _nodeInspectorServer2.default)().then();

              case 11:
                _context2.next = 13;
                return configure();

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x2) {
        return _ref.apply(this, arguments);
      };
    }());
  } // import path from 'path'
  // import HtmlWebpackPlugin from 'html-webpack-plugin'
  // import CopyWebpackPlugin from 'copy-webpack-plugin'
});

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_164__;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(18), __webpack_require__(39), __webpack_require__(6), __webpack_require__(32), __webpack_require__(7), __webpack_require__(0), __webpack_require__(61), __webpack_require__(88), __webpack_require__(60), __webpack_require__(15), __webpack_require__(17), __webpack_require__(89), __webpack_require__(90), __webpack_require__(91), __webpack_require__(92), __webpack_require__(93), __webpack_require__(94)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/assign'), require('babel-runtime/core-js/object/keys'), require('babel-runtime/regenerator'), require('babel-runtime/core-js/set'), require('babel-runtime/helpers/asyncToGenerator'), require('path'), require('copy-webpack-plugin'), require('on-build-webpack'), require('./npm-dyn-dependencies'), require('./terminal-utils'), require('./utils'), require('./technologies/eslint'), require('./technologies/js'), require('./technologies/perf'), require('./technologies/coffee-script'), require('./technologies/type-script'), require('./technologies/json'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assign, global.keys, global.regenerator, global.set, global.asyncToGenerator, global.path, global.copyWebpackPlugin, global.onBuildWebpack, global.npmDynDependencies, global.terminalUtils, global.utils, global.eslint, global.js, global.perf, global.coffeeScript, global.typeScript, global.json);
    global.configureServer = mod.exports;
  }
})(this, function (exports, _assign, _keys, _regenerator, _set, _asyncToGenerator2, _path, _copyWebpackPlugin, _onBuildWebpack, _npmDynDependencies, _terminalUtils, _utils, _eslint, _js, _perf, _coffeeScript, _typeScript, _json) {
  'use strict';

  exports.__esModule = true;

  var _assign2 = _interopRequireDefault(_assign);

  var _keys2 = _interopRequireDefault(_keys);

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _set2 = _interopRequireDefault(_set);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _path2 = _interopRequireDefault(_path);

  var _copyWebpackPlugin2 = _interopRequireDefault(_copyWebpackPlugin);

  var _onBuildWebpack2 = _interopRequireDefault(_onBuildWebpack);

  var _eslint2 = _interopRequireDefault(_eslint);

  var _js2 = _interopRequireDefault(_js);

  var _perf2 = _interopRequireDefault(_perf);

  var _coffeeScript2 = _interopRequireDefault(_coffeeScript);

  var _typeScript2 = _interopRequireDefault(_typeScript);

  var _json2 = _interopRequireDefault(_json);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  // import { copyFiles } from './utils'
  // import httpServer from './http-server'
  var STARTED_SERVER = {};
  // import _MARKUPS from './technologies/markups'
  // import _MARKUDOWNS from './technologies/markdown'

  // import { spawn } from 'child-process-promise'

  // import HardSourceWebpackPlugin from 'hard-source-webpack-plugin'

  exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(opts, state, appRef) {
      var ensureInstall = function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(what) {
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return (0, _npmDynDependencies.ensureInstallation)(what, null, {
                    verbose: true,
                    installing: opts.installing
                  });

                case 2:
                  return _context.abrupt('return', _context.sent);

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function ensureInstall(_x4) {
          return _ref2.apply(this, arguments);
        };
      }();

      // we have to install all the dependencyes for projects
      // that use a server side


      var COMMON_CONFIG, SRC_PATH, OUTPUT_PATH, IS_DEV, PROJECT_PATH, FURTHER_PATH, FURTHER_REF, USED_EXTENSIONS, SERVER_CONFIG;
      return _regenerator2.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              COMMON_CONFIG = state.COMMON_CONFIG, SRC_PATH = state.SRC_PATH, OUTPUT_PATH = state.OUTPUT_PATH, IS_DEV = state.IS_DEV, PROJECT_PATH = state.PROJECT_PATH, FURTHER_PATH = state.FURTHER_PATH, FURTHER_REF = state.FURTHER_REF;
              _context3.t0 = _set2.default;
              _context3.next = 4;
              return (0, _utils.thereIsAnyFileMatching)(SRC_PATH, ['.js', '.ts', '.tsx', '.coffee', '.json', '.htm', '.tpl', '.tpl']);

            case 4:
              _context3.t1 = _context3.sent;
              USED_EXTENSIONS = new _context3.t0(_context3.t1);
              SERVER_CONFIG = {
                module: {
                  rules: []
                }
              };
              _context3.next = 9;
              return ensureInstall('server');

            case 9:

              // let's make it clear that it's in node environment
              SERVER_CONFIG.target = 'node';

              SERVER_CONFIG.entry = {
                // 'webpack-hot-middleware/client': 'webpack-hot-middleware/client',
                'server/main/index': SRC_PATH + '/server/main/index.js'
                // 'vendors/babel-polifills': [
                //   'core-js/es6/function',
                //   'core-js/es6/map',
                //   'core-js/es6/math',
                //   'core-js/es6/number',
                //   'core-js/es6/object',
                //   'core-js/es6/regexp',
                //   'core-js/es6/string',
                //   'core-js/fn/array/includes'
                // ]
              };

              SERVER_CONFIG.module = { rules: [], loaders: [] };
              SERVER_CONFIG.plugins = [];

              // let's enable source maps
              if (IS_DEV) {
                SERVER_CONFIG.devtool = 'inline-source-map';
              } else {
                if (opts.production && opts.production.sourceMaps) {
                  SERVER_CONFIG.devtool = 'source-map';
                }
              }

              // ESLint
              SERVER_CONFIG.module.rules.push((0, _eslint2.default)(state, opts));

              if (!(USED_EXTENSIONS.has('.json') || USED_EXTENSIONS.has('.json5'))) {
                _context3.next = 19;
                break;
              }

              _context3.next = 18;
              return ensureInstall('json');

            case 18:
              SERVER_CONFIG.module.rules.push((0, _json2.default)(state));

            case 19:
              if (!IS_DEV) {
                _context3.next = 23;
                break;
              }

              _context3.next = 22;
              return ensureInstall('developer');

            case 22:
              SERVER_CONFIG.performance = _perf2.default;

            case 23:
              if (!USED_EXTENSIONS.has('.coffee')) {
                _context3.next = 27;
                break;
              }

              _context3.next = 26;
              return ensureInstall('coffee');

            case 26:
              SERVER_CONFIG.module.rules.push((0, _coffeeScript2.default)(state));

            case 27:
              if (!(USED_EXTENSIONS.has('.ts') || USED_EXTENSIONS.has('.tsx'))) {
                _context3.next = 31;
                break;
              }

              _context3.next = 30;
              return ensureInstall('typescript');

            case 30:
              SERVER_CONFIG.module.rules.push((0, _typeScript2.default)(state));

            case 31:

              // rules for javascript (es6+)
              SERVER_CONFIG.module.rules.push({
                // enforce: "pre",
                test: /\.js$/,
                exclude: /node_modules/,
                loader: FURTHER_REF + 'babel-loader',
                options: {
                  plugins: [FURTHER_REF + "babel-plugin-transform-async-to-generator"],
                  presets: [[FURTHER_REF + 'babel-preset-es2015', { modules: false, loose: true }]]
                }
              });

              // if there is any /server/public directory, we will copy it to
              // the dist directory
              _context3.next = 34;
              return (0, _utils.fileExists)(OUTPUT_PATH + '/server/public/');

            case 34:
              _context3.t2 = !_context3.sent;

              if (!_context3.t2) {
                _context3.next = 39;
                break;
              }

              _context3.next = 38;
              return (0, _utils.fileExists)(SRC_PATH + '/server/public/');

            case 38:
              _context3.t2 = _context3.sent;

            case 39:
              if (!_context3.t2) {
                _context3.next = 41;
                break;
              }

              SERVER_CONFIG.plugins.push(new _copyWebpackPlugin2.default([{
                from: SRC_PATH + '/server/public/',
                to: OUTPUT_PATH + '/server/public/',
                ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
              }]));

            case 41:
              _context3.next = 43;
              return (0, _utils.fileExists)(OUTPUT_PATH + '/server/private/');

            case 43:
              _context3.t3 = !_context3.sent;

              if (!_context3.t3) {
                _context3.next = 48;
                break;
              }

              _context3.next = 47;
              return (0, _utils.fileExists)(SRC_PATH + '/server/private/');

            case 47:
              _context3.t3 = _context3.sent;

            case 48:
              if (!_context3.t3) {
                _context3.next = 50;
                break;
              }

              SERVER_CONFIG.plugins.push(new _copyWebpackPlugin2.default([{
                from: SRC_PATH + '/server/private/',
                to: OUTPUT_PATH + '/server/private/',
                ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
              }]));

            case 50:

              // To allow developers to start a server by using `node dist/server`
              // we need to add a starter from a further template into their project's dist
              SERVER_CONFIG.plugins.push(new _copyWebpackPlugin2.default([{
                // copying the SERVER STARTER file
                from: _path2.default.join(FURTHER_REF, '../dist/tpls/server/', 'further-http-server.js'),
                to: _path2.default.join(OUTPUT_PATH, 'server/index.js'),
                ignore: ['**/**/.DS_Store', '**/**/.gitkeep'],
                transform: function transform(content, path) {
                  // replacing some marks/tokens
                  content = content.toString();
                  content = content.replace("${DEV_SERVER_PORT}", opts.server ? opts.server.port || 'null' : 'null');
                  return Buffer.from(content, 'utf8');
                }
              }]));

              // SERVER_CONFIG.plugins = [
              //   // new EventsPlugin(),
              //   new CopyWebpackPlugin([
              //     {
              //       from: `${SRC_PATH}/server/public/`,
              //       to: `${OUTPUT_PATH}/server/public/`,
              //       ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
              //     },
              //     {
              //       from: `${SRC_PATH}/server/private/`,
              //       to: `${OUTPUT_PATH}/server/private/`,
              //       ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
              //     }
              //   ]),
              //   // new webpack.HotModuleReplacementPlugin()
              // ]

              // caching modules to make next builds faster
              // SERVER_CONFIG.plugins.push(new HardSourceWebpackPlugin({
              //   cacheDirectory: path.resolve(PROJECT_PATH, '.further/.cache/hard-source/[confighash]'),
              //   recordsPath: path.resolve(PROJECT_PATH, '.further/.cache/hard-source/[confighash]/records.json')
              // }))

              // resolves
              SERVER_CONFIG.resolve = {
                extensions: [".webpack.js", ".web.js", ".js", ".ts", ".tsx", ".jsx", ".coffee", "jpg", "png", "gif", "webp", "jpeg", "jpg", "svg", ".html", ".tpl", ".css", ".less", ".styl", ".sass"], //, ".mjs", ".coffee", ".vue", ".less", ".styl", ".sass" ],
                alias: {
                  react: 'preact-compat',
                  'react-dom': 'preact-compat',
                  Components: _path2.default.resolve(PROJECT_PATH, 'src/client/components/'),
                  Comps: _path2.default.resolve(PROJECT_PATH, 'src/client/components/'),
                  Templates: _path2.default.resolve(PROJECT_PATH, 'src/templates/'),
                  Services: _path2.default.resolve(PROJECT_PATH, 'src/server/services/'),
                  Servs: _path2.default.resolve(PROJECT_PATH, 'src/server/services/')
                },
                modules: ['furtherjs/node_modules', 'node_modules/furtherjs/node_modules', 'node_modules']

                // the output path
              };SERVER_CONFIG.output = {
                libraryTarget: 'umd',
                path: OUTPUT_PATH,
                filename: '[name].js',
                chunkFilename: '[name]-[id].js',
                hotUpdateChunkFilename: 'hot/[hash].hot.js',
                hotUpdateMainFilename: 'hot/[hash].hot.json'

                // Measuring and validating file sizes
                // SERVER_CONFIG.performance = {
                //     hints: "warning", // enum
                //     maxAssetSize: 350000, // int (in bytes),
                //     maxEntrypointSize: 400000, // int (in bytes)
                //     assetFilter: function(assetFilename) {
                //         // Function predicate that provides asset filenames
                //         return assetFilename.endsWith('.js');
                //     }
                // }
                // SERVER_CONFIG.plugins.push(new WebpackOnBuildPlugin(async function(stats) {
                //   // unless the user has disabled it, we start an HTTP Server
                //   if (appRef.onBuildDone) {
                //     appRef.onBuildDone('server', null, stats)
                //   }
                // }))

                // SERVER_CONFIG.plugins.push(new WebpackOnBuildPlugin(async function (stats) {
                //   return new Promise(async (resolve, reject) => {
                //     await state.appRef.onBuildDone('server', SERVER_CONFIG, stats)

                //     // if server has already started, we kill it
                //     if (STARTED_SERVER.proc && STARTED_SERVER.proc.childProcess) {
                //       STARTED_SERVER.proc.childProcess.kill()
                //     }

                //     // and now we start the server
                //     STARTED_SERVER.proc = spawn(
                //       'node',
                //       [path.resolve(PROJECT_PATH, 'dist/server/index.js')],
                //       { capture: [ 'stdout', 'stderr' ]})
                //         .then(function (result) {
                //           // if (opts.debug) {
                //             console.log('[Server log] ', result.stdout.toString())
                //           // }
                //         })
                //         .catch(function (err) {
                //             console.log(errorMessage('Server execution error: ' + err.stderr))
                //         });

                //     resolve(SERVER_CONFIG)
                //   })
                // }))
              };SERVER_CONFIG.plugins.push(new _onBuildWebpack2.default(function () {
                var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(stats) {
                  return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          // unless the user has disabled it, we start an HTTP Server
                          if (opts.server.http !== false) {
                            try {
                              if (appRef.onBuildDone) {
                                appRef.onBuildDone('server', null, stats);
                              }
                            } catch (e) {
                              if (opts.breakpointOnErrors) {
                                debugger;
                              }
                              stats.compilation.errors.push({
                                name: 'Server startup error',
                                message: 'Could not start HTTP Server.\n' + (e.message || e)
                              });
                            }
                          }

                        case 1:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, this);
                }));

                return function (_x5) {
                  return _ref3.apply(this, arguments);
                };
              }()));

              SERVER_CONFIG.name = 'server-config';

              // we have to remove all the invalid/empty plugins that may
              // have been accidently added
              SERVER_CONFIG.plugins = SERVER_CONFIG.plugins.filter(function (plugin) {
                return plugin && ((0, _keys2.default)(plugin).length || plugin.apply);
              });

              return _context3.abrupt('return', (0, _assign2.default)({}, COMMON_CONFIG, SERVER_CONFIG));

            case 57:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function configureServer(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return configureServer;
  }();
});

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(167), __esModule: true };

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(1);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(4), __webpack_require__(0), __webpack_require__(84), __webpack_require__(169), __webpack_require__(80), __webpack_require__(170), __webpack_require__(15)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/promise'), require('path'), require('inspector'), require('colors'), require('inquirer'), require('copy-paste'), require('./terminal-utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.promise, global.path, global.inspector, global.colors, global.inquirer, global.copyPaste, global.terminalUtils);
    global.nodeInspectorServer = mod.exports;
  }
})(this, function (exports, _promise, _path, _inspector, _colors, _inquirer, _copyPaste, _terminalUtils) {
  'use strict';

  exports.__esModule = true;

  var _promise2 = _interopRequireDefault(_promise);

  var _path2 = _interopRequireDefault(_path);

  var _inspector2 = _interopRequireDefault(_inspector);

  var _colors2 = _interopRequireDefault(_colors);

  var _inquirer2 = _interopRequireDefault(_inquirer);

  var _copyPaste2 = _interopRequireDefault(_copyPaste);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function waitForEnter(then) {
    console.log('Press ' + _colors2.default.bold('[ENTER]') + ' to continue');
    process.stdin.resume();
    process.stdin.once('data', function () {
      then();
    });
  }

  function inspectorServer() {
    return new _promise2.default(function (resolve, reject) {
      var readyToResolve = resolve;

      // we will also start an inspector
      _inspector2.default.open(9229, 'localhost');
      var inspectorURL = 'chrome-devtools://devtools/bundled/inspector.html?experiments=true&v8only=true&ws=';
      inspectorURL += '127.0.0.1:9229/';
      inspectorURL += _path2.default.basename(_inspector2.default.url());
      // these are the current choices for using or storing the debigging URLs
      var choices = [_colors2.default.bold('Do not') + ' copy anything', 'Copy ' + _colors2.default.bold('chrome url') + ' to clipboard', 'Copy ' + _colors2.default.bold('socket url') + ' to clipboard', new _inquirer2.default.Separator(), _colors2.default.bold('Show') + ' chrome url', _colors2.default.bold('Show') + ' socket url', new _inquirer2.default.Separator(), 'Cancel/Abort'];

      (0, _terminalUtils.clearTerminal)();
      // let's see what the user wants
      _inquirer2.default.prompt([{
        type: 'list',
        name: 'copyOrNot',
        pageSize: 20,
        message: '\nStarting in ' + _colors2.default.italic('Developer Mode') + '.\nThe ' + _colors2.default.italic.bold('debugger') + ' is activated and you can debug your node server in an external graphical interface.\n',
        choices: choices
      }]).then(function (answers) {
        var answer = choices.indexOf(answers.copyOrNot);

        // console.log('1', process.cwd())
        // console.log('2', __dirname)
        // console.log('3', require.main.filename)
        // console.log('4', process.argv[0])
        // console.log('5', process.argv[1])

        switch (answer) {
          case 0:
            {
              // do not copy, just go on
              readyToResolve();
              break;
            }
          case 1:
            {
              // copy the chrome inspector url
              _copyPaste2.default.copy(inspectorURL);
              // and wait for the user to open it, and hit enter
              waitForEnter(readyToResolve);
              break;
            }
          case 2:
            {
              // copy the web socket url for the debigging protocol
              _copyPaste2.default.copy(_inspector2.default.url());
              // and wait for the user to open it, and hit enter
              waitForEnter(readyToResolve);
              break;
            }
          case 4:
            {
              // show the chrome inspector url
              console.log('\n The chrome browser url is:\n', inspectorURL, '\n');
              // and wait for the user to open it, and hit enter
              waitForEnter(readyToResolve);
              break;
            }
          case 5:
            {
              // show the web socket url for the debigging protocol
              console.log('\n The web socket url is:\n', _inspector2.default.url(), '\n');
              // and wait for the user to open it, and hit enter
              waitForEnter(readyToResolve);
              break;
            }
          case 7:
            {
              // user gave up! Aborting
              console.log('\nInitialization aborted\n');
              process.exit(0);
              break;
            }
        }
      });
    });
  }

  exports.default = inspectorServer;
});

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_169__;

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_170__;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(39), __webpack_require__(4), __webpack_require__(6), __webpack_require__(79), __webpack_require__(32), __webpack_require__(7), __webpack_require__(60), __webpack_require__(58), __webpack_require__(61), __webpack_require__(172), __webpack_require__(17), __webpack_require__(88), __webpack_require__(8), __webpack_require__(173), __webpack_require__(174), __webpack_require__(175), __webpack_require__(176), __webpack_require__(89), __webpack_require__(191), __webpack_require__(90), __webpack_require__(91), __webpack_require__(177), __webpack_require__(178), __webpack_require__(92), __webpack_require__(93), __webpack_require__(179), __webpack_require__(180), __webpack_require__(181), __webpack_require__(182), __webpack_require__(183), __webpack_require__(94), __webpack_require__(184), __webpack_require__(185), __webpack_require__(186), __webpack_require__(188), __webpack_require__(189), __webpack_require__(190), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/core-js/object/keys'), require('babel-runtime/core-js/promise'), require('babel-runtime/regenerator'), require('babel-runtime/core-js/array/from'), require('babel-runtime/core-js/set'), require('babel-runtime/helpers/asyncToGenerator'), require('./npm-dyn-dependencies'), require('webpack'), require('copy-webpack-plugin'), require('webpack-merge'), require('./utils'), require('on-build-webpack'), require('fs-extra'), require('./technologies/entries'), require('./technologies/resolvers'), require('./technologies/output'), require('./technologies/optimizations'), require('./technologies/eslint'), require('./technologies/style-lint'), require('./technologies/js'), require('./technologies/perf'), require('./technologies/react'), require('./technologies/vue'), require('./technologies/coffee-script'), require('./technologies/type-script'), require('./technologies/markups'), require('./technologies/markdown'), require('./technologies/icons'), require('./technologies/html'), require('./technologies/http'), require('./technologies/json'), require('./technologies/images'), require('./technologies/sprites'), require('./technologies/critical'), require('./technologies/optimize-images'), require('./technologies/include-assets'), require('./technologies/styles'), require('path'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.keys, global.promise, global.regenerator, global.from, global.set, global.asyncToGenerator, global.npmDynDependencies, global.webpack, global.copyWebpackPlugin, global.webpackMerge, global.utils, global.onBuildWebpack, global.fsExtra, global.entries, global.resolvers, global.output, global.optimizations, global.eslint, global.styleLint, global.js, global.perf, global.react, global.vue, global.coffeeScript, global.typeScript, global.markups, global.markdown, global.icons, global.html, global.http, global.json, global.images, global.sprites, global.critical, global.optimizeImages, global.includeAssets, global.styles, global.path);
    global.configureClient = mod.exports;
  }
})(this, function (exports, _keys, _promise, _regenerator, _from, _set, _asyncToGenerator2, _npmDynDependencies, _webpack, _copyWebpackPlugin, _webpackMerge, _utils, _onBuildWebpack, _fsExtra, _entries, _resolvers, _output, _optimizations, _eslint, _styleLint, _js, _perf, _react, _vue, _coffeeScript, _typeScript, _markups, _markdown, _icons, _html, _http, _json, _images, _sprites, _critical, _optimizeImages, _includeAssets, _styles, _path) {
  'use strict';

  exports.__esModule = true;

  var _keys2 = _interopRequireDefault(_keys);

  var _promise2 = _interopRequireDefault(_promise);

  var _regenerator2 = _interopRequireDefault(_regenerator);

  var _from2 = _interopRequireDefault(_from);

  var _set2 = _interopRequireDefault(_set);

  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

  var _webpack2 = _interopRequireDefault(_webpack);

  var _copyWebpackPlugin2 = _interopRequireDefault(_copyWebpackPlugin);

  var _webpackMerge2 = _interopRequireDefault(_webpackMerge);

  var _onBuildWebpack2 = _interopRequireDefault(_onBuildWebpack);

  var _fsExtra2 = _interopRequireDefault(_fsExtra);

  var _entries2 = _interopRequireDefault(_entries);

  var _resolvers2 = _interopRequireDefault(_resolvers);

  var _output2 = _interopRequireDefault(_output);

  var _optimizations2 = _interopRequireDefault(_optimizations);

  var _eslint2 = _interopRequireDefault(_eslint);

  var _styleLint2 = _interopRequireDefault(_styleLint);

  var _js2 = _interopRequireDefault(_js);

  var _perf2 = _interopRequireDefault(_perf);

  var _react2 = _interopRequireDefault(_react);

  var _vue2 = _interopRequireDefault(_vue);

  var _coffeeScript2 = _interopRequireDefault(_coffeeScript);

  var _typeScript2 = _interopRequireDefault(_typeScript);

  var _markups2 = _interopRequireDefault(_markups);

  var _markdown2 = _interopRequireDefault(_markdown);

  var _icons2 = _interopRequireDefault(_icons);

  var _html2 = _interopRequireDefault(_html);

  var _http2 = _interopRequireDefault(_http);

  var _json2 = _interopRequireDefault(_json);

  var _images2 = _interopRequireDefault(_images);

  var _sprites2 = _interopRequireDefault(_sprites);

  var _critical2 = _interopRequireDefault(_critical);

  var _optimizeImages2 = _interopRequireDefault(_optimizeImages);

  var _includeAssets2 = _interopRequireDefault(_includeAssets);

  var _path2 = _interopRequireDefault(_path);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  // import HardSourceWebpackPlugin from 'hard-source-webpack-plugin'
  var deepMerge = _webpackMerge2.default.smart;

  // import ExtractTextPlugin from "extract-text-webpack-plugin"
  // import FaviconsWebpackPlugin from "favicons-webpack-plugin"
  // //////// import postCSSNext from 'postcss-cssnext'
  // //////// import reactCSSModules from 'babel-plugin-react-css-modules'
  // import HtmlWebpackPlugin from 'html-webpack-plugin'
  // //////// import HtmlWebpackHarddiskPlugin from 'html-webpack-harddisk-plugin'
  // //////// import HtmlReloadPlugin from 'reload-html-webpack-plugin'
  // //////// import UglifyJSPlugin from 'uglifyjs-webpack-plugin'
  // import CompressionPlugin from "compression-webpack-plugin"
  // import ImageminPlugin from 'imagemin-webpack-plugin'
  // import imageminPngcrush from 'imagemin-pngcrush'
  // import imageminMozjpeg from 'imagemin-mozjpeg'
  // //////// import imageminWebp from 'imagemin-webp'
  // import ResourceHintWebpackPlugin from 'resource-hints-webpack-plugin'
  // import HtmlWebpackExcludeAssetsPlugin from 'html-webpack-exclude-assets-plugin'
  // import HtmlWebpackIncludeAssetsPlugin from 'html-webpack-include-assets-plugin'
  // //////// import WrapperPlugin from 'wrapper-webpack-plugin'
  // import SpritesmithPlugin from 'webpack-spritesmith'
  // //////// const CriticalPlugin = require('webpack-plugin-critical').CriticalPlugin

  // // // // // // // // import WebpackOnBuildPlugin from 'on-build-webpack'

  // import critical from 'critical'
  // import StyleLintPlugin from 'stylelint-webpack-plugin'

  exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(opts, state, appRef) {
      var _this = this;

      var ensureInstall = function () {
        var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(what) {
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return (0, _npmDynDependencies.ensureInstallation)(what, null, {
                    verbose: true,
                    installing: opts.installing
                    // node_modules: FURTHER_REF
                  });

                case 2:
                  return _context.abrupt('return', _context.sent);

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function ensureInstall(_x4) {
          return _ref2.apply(this, arguments);
        };
      }();

      // we have to install all the dependencyes for projects
      // that use a client side interface


      var COMMON_CONFIG, SRC_PATH, OUTPUT_PATH, IS_DEV, PROJECT_PATH, FURTHER_PATH, FURTHER_REF, USED_EXTENSIONS, USED_EXTENSIONS_LIST, FILES_TO_APPEND;
      return _regenerator2.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              COMMON_CONFIG = state.COMMON_CONFIG, SRC_PATH = state.SRC_PATH, OUTPUT_PATH = state.OUTPUT_PATH, IS_DEV = state.IS_DEV, PROJECT_PATH = state.PROJECT_PATH, FURTHER_PATH = state.FURTHER_PATH, FURTHER_REF = state.FURTHER_REF;
              _context5.t0 = _set2.default;
              _context5.next = 4;
              return (0, _utils.thereIsAnyFileMatching)(SRC_PATH, ['.js', '.css', '.html', '.jsx', '.vue', '.ts', '.tsx', '.coffee', '.scss', '.less', '.styl', '.htm', '.tpl', '.md']);

            case 4:
              _context5.t1 = _context5.sent;
              USED_EXTENSIONS = new _context5.t0(_context5.t1);
              USED_EXTENSIONS_LIST = (0, _from2.default)(USED_EXTENSIONS).join('|');


              opts = opts || {};
              opts.custom = opts.custom || {};

              FILES_TO_APPEND = [];
              _context5.next = 12;
              return ensureInstall('client');

            case 12:
              return _context5.abrupt('return', new _promise2.default(function () {
                var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(resolve, reject) {

                  /**
                   * CopyWebpackPlugin
                   * 
                   * This plugin triggers errors when a file (not a glob)
                   * does not exist. So, we need to treat it.
                   */
                  var copyIfExists = function () {
                    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(src, dest) {
                      var fullSrc;
                      return _regenerator2.default.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              fullSrc = _path2.default.join(SRC_PATH, src);
                              _context2.t0 = src.indexOf('**') < 0;

                              if (!_context2.t0) {
                                _context2.next = 6;
                                break;
                              }

                              _context2.next = 5;
                              return (0, _utils.fileExists)(fullSrc);

                            case 5:
                              _context2.t0 = !_context2.sent;

                            case 6:
                              if (!_context2.t0) {
                                _context2.next = 8;
                                break;
                              }

                              return _context2.abrupt('return');

                            case 8:
                              CLIENT_CONFIG.plugins.push(new _copyWebpackPlugin2.default([{
                                from: fullSrc,
                                to: _path2.default.join(OUTPUT_PATH, dest || src),
                                ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
                              }]));

                            case 9:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, this);
                    }));

                    return function copyIfExists(_x7, _x8) {
                      return _ref4.apply(this, arguments);
                    };
                  }();

                  // let's ensure we will copy any assets


                  var CLIENT_CONFIG;
                  return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          CLIENT_CONFIG = {};

                          // client is a target for web environments

                          CLIENT_CONFIG.target = 'web';

                          // initiating an empty plugins list
                          CLIENT_CONFIG.plugins = [];

                          // we will have a default entry point for the webapp
                          CLIENT_CONFIG.entry = (0, _entries2.default)(state);

                          // also, let's create a bundle for each component (code splitting)
                          // CLIENT_CONFIG.entry = Object.assign({}, CLIENT_CONFIG.entry,
                          // getEntries(SRC_PATH, `${SRC_PATH}/client/components/**/index.*`)
                          // )

                          // we gotta set the output based on the each name
                          CLIENT_CONFIG.output = (0, _output2.default)(state);

                          // let's also accept a source maps
                          if (IS_DEV) {
                            CLIENT_CONFIG.devtool = 'source-map';
                            CLIENT_CONFIG.output.hotUpdateChunkFilename = 'hot/[hash].hot.js';
                            CLIENT_CONFIG.output.hotUpdateMainFilename = 'hot/[hash].hot.json';
                          } else {
                            if (opts.production && opts.production.sourceMaps) {
                              CLIENT_CONFIG.devtool = 'source-map';
                            }
                          }

                          // Measuring and validating file sizes

                          if (!IS_DEV) {
                            _context4.next = 10;
                            break;
                          }

                          _context4.next = 9;
                          return ensureInstall('developer');

                        case 9:
                          CLIENT_CONFIG.performance = _perf2.default;

                        case 10:

                          // preparing the home for rules
                          CLIENT_CONFIG.module = { rules: [], loaders: []

                            /**
                             * Basic files
                             * 
                             * These are basic dependencies and configurations we
                             * know we are going to use for sure.
                             */
                            // ESLint
                          };CLIENT_CONFIG.module.rules.push((0, _eslint2.default)(state, opts));

                          // rules for javascript (es6+, linter, generators, etc)
                          CLIENT_CONFIG.module.rules.push((0, _js2.default)(state));

                          // rules for css (lint, extractors, etc)
                          CLIENT_CONFIG.module.rules.push((0, _styles.CSS)(state, CLIENT_CONFIG));

                          // Here we can also specify some aliases and where
                          // to find some of the modules
                          CLIENT_CONFIG.resolve = (0, _resolvers2.default)(state);

                          /**
                           * Styles applied to client
                           * 
                           * Technologies used to apply styles to pages.
                           */
                          // SASS/SCSS

                          if (!USED_EXTENSIONS.has('.scss')) {
                            _context4.next = 19;
                            break;
                          }

                          _context4.next = 18;
                          return ensureInstall('sass');

                        case 18:
                          CLIENT_CONFIG.module.rules.push((0, _styles.SASS)(state, CLIENT_CONFIG));

                        case 19:
                          if (!USED_EXTENSIONS.has('.less')) {
                            _context4.next = 23;
                            break;
                          }

                          _context4.next = 22;
                          return ensureInstall('less');

                        case 22:
                          CLIENT_CONFIG.module.rules.push((0, _styles.LESS)(state, CLIENT_CONFIG));

                        case 23:
                          if (!USED_EXTENSIONS.has('.styl')) {
                            _context4.next = 27;
                            break;
                          }

                          _context4.next = 26;
                          return ensureInstall('stylus');

                        case 26:
                          CLIENT_CONFIG.module.rules.push((0, _styles.STYLUS)(state, CLIENT_CONFIG));

                        case 27:

                          /**
                           * Possible script technologies
                           * 
                           * These scripts and dependencies will be installed and
                           * loaded only if/when their respective files get used.
                           */
                          // REACT
                          if (USED_EXTENSIONS.has('.jsx')) {
                            CLIENT_CONFIG.module.rules.push((0, _react2.default)(state));
                            new _webpack2.default.ProvidePlugin({
                              h: _path2.default.resolve(FURTHER_REF, '../', '.meta/preact.h.js')
                            });
                          }

                          // VUEJS

                          if (!USED_EXTENSIONS.has('.vue')) {
                            _context4.next = 32;
                            break;
                          }

                          _context4.next = 31;
                          return ensureInstall('vue');

                        case 31:
                          CLIENT_CONFIG.module.rules.push((0, _vue2.default)(state));

                        case 32:
                          if (!USED_EXTENSIONS.has('.coffee')) {
                            _context4.next = 36;
                            break;
                          }

                          _context4.next = 35;
                          return ensureInstall('coffee');

                        case 35:
                          CLIENT_CONFIG.module.rules.push((0, _coffeeScript2.default)(state));

                        case 36:
                          if (!(USED_EXTENSIONS.has('.ts') || USED_EXTENSIONS.has('.tsx'))) {
                            _context4.next = 40;
                            break;
                          }

                          _context4.next = 39;
                          return ensureInstall('typescript');

                        case 39:
                          CLIENT_CONFIG.module.rules.push((0, _typeScript2.default)(state));

                        case 40:

                          // // TODO: Add support for angular

                          /**
                           * Markup files
                           * 
                           * These are dependencies related to markup files such
                           * as html or other template engines.
                           */
                          if (USED_EXTENSIONS_LIST.match(/\.(htm(l)?|xhtm(l)?|hbs|handlebars|ejs|mustache|nunjucks|tpl)/)) {
                            CLIENT_CONFIG.module.rules.push((0, _markups2.default)(state));
                          }

                          /**
                           * JSON and JSON5
                           * 
                           * We will actually always use JSON5 for any JSON file.
                           */

                          if (!(USED_EXTENSIONS.has('.json') || USED_EXTENSIONS.has('.json5'))) {
                            _context4.next = 45;
                            break;
                          }

                          _context4.next = 44;
                          return ensureInstall('json');

                        case 44:
                          CLIENT_CONFIG.module.rules.push((0, _json2.default)(state));

                        case 45:

                          /**
                           * Texts and MarkDowns
                           * 
                           * We will treat all these files as markdown.
                           */
                          if (USED_EXTENSIONS.has('.txt') || USED_EXTENSIONS.has('.md')) {
                            CLIENT_CONFIG.module.rules.push((0, _markdown2.default)(state));
                          }

                          /**
                           * Interpolating the HTMLs
                           * 
                           * Will interpolate html files and apply some attributes
                           * to allow it to lazy load images
                           */
                          _context4.next = 48;
                          return (0, _utils.thereIsAnyFileMatching)(SRC_PATH, ['.html', '.htm', '.tpl']);

                        case 48:
                          if (!_context4.sent) {
                            _context4.next = 50;
                            break;
                          }

                          CLIENT_CONFIG.module.rules.push((0, _html2.default)(state, opts, CLIENT_CONFIG));

                        case 50:
                          if (!USED_EXTENSIONS_LIST.match(/\.(png|jp(e)?g|gif|webp|svg|ttf|woff|woff2)/)) {
                            _context4.next = 56;
                            break;
                          }

                          // there are images to be treated
                          CLIENT_CONFIG.module.rules.push((0, _images2.default)(state, CLIENT_CONFIG));

                          // optimizing images
                          // This is disabled by default during development

                          if (!(!IS_DEV || opts.development.optmizeImages)) {
                            _context4.next = 56;
                            break;
                          }

                          _context4.next = 55;
                          return ensureInstall('imageOptimization');

                        case 55:
                          CLIENT_CONFIG.plugins.push((0, _optimizeImages2.default)(state, opts, CLIENT_CONFIG));

                        case 56:
                          copyIfExists('client/public/');
                          copyIfExists('client/main/assets', 'client/assets');
                          copyIfExists('client/components/**/assets');

                          // copying a basic version for the http-server
                          CLIENT_CONFIG.plugins.push((0, _http2.default)(state, opts, CLIENT_CONFIG));

                          // plugin for hotModuleReplacement
                          CLIENT_CONFIG.plugins.push(new _webpack2.default.HotModuleReplacementPlugin());

                          // ignoring some files
                          CLIENT_CONFIG.plugins.push(new _webpack2.default.IgnorePlugin(/\.DS_Store$/, /node_modules/, /\.log/, /^\~.*/, /\.tmp$/, /\.git/));

                          // // treating icons (it will also remove other unused assets)
                          if (opts.icon) {
                            CLIENT_CONFIG.plugins.push((0, _icons2.default)(state, opts, CLIENT_CONFIG));
                          }

                          // treating sprites
                          _context4.next = 65;
                          return (0, _utils.thereIsAnyFileMatching)(SRC_PATH, ['.png', '.jpg', '.jpeg'], { path: '**/sprites/' });

                        case 65:
                          if (!_context4.sent) {
                            _context4.next = 68;
                            break;
                          }

                          // if there is any directory "sprites" with images in it
                          CLIENT_CONFIG.plugins.push((0, _sprites2.default)(state, opts, CLIENT_CONFIG));
                          FILES_TO_APPEND.push('sprites/sprite.css');

                        case 68:

                          // critical path plugin
                          // will generate index-critical.html with the basic structure and inlined styles and scripts
                          CLIENT_CONFIG.plugins.push((0, _critical2.default)(state, opts, CLIENT_CONFIG));

                          // Appending and prepending files into html
                          if (FILES_TO_APPEND.length) {
                            // TODO: AQUI: prepend reset.css
                            (0, _includeAssets2.default)({ FILES_TO_APPEND: FILES_TO_APPEND }, opts, CLIENT_CONFIG);
                          }

                          // caching modules to make next builds faster
                          // CLIENT_CONFIG.plugins.push(new HardSourceWebpackPlugin({
                          //   cacheDirectory: path.resolve(PROJECT_PATH, '.further/.cache/hard-source/[confighash]'),
                          //   recordsPath: path.resolve(PROJECT_PATH, '.further/.cache/hard-source/[confighash]/records.json')
                          // }))

                          // use es-lint for style files
                          CLIENT_CONFIG.plugins.push((0, _styleLint2.default)(state));

                          /**
                           * Optimizations
                           * 
                           * Let's optimize images, scripts and styles
                           */
                          if (!IS_DEV || opts.development.optimize) {
                            // if in production (or if should optimize
                            // we set some flags
                            CLIENT_CONFIG.plugins.push(new _webpack2.default.DefinePlugin({
                              'process.env': {
                                NODE_ENV: '"production"'
                              }
                            }));
                          }

                          // Extra optmizations
                          if (!IS_DEV || opts.development.optimize) {
                            (0, _optimizations2.default)(state, opts, CLIENT_CONFIG);
                          }

                          CLIENT_CONFIG.plugins.push(new _onBuildWebpack2.default(function () {
                            var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(stats) {
                              return _regenerator2.default.wrap(function _callee3$(_context3) {
                                while (1) {
                                  switch (_context3.prev = _context3.next) {
                                    case 0:
                                      // unless the user has disabled it, we start an HTTP Server
                                      if (appRef.onBuildDone) {
                                        appRef.onBuildDone('client', null, stats);
                                      }

                                    case 1:
                                    case 'end':
                                      return _context3.stop();
                                  }
                                }
                              }, _callee3, this);
                            }));

                            return function (_x9) {
                              return _ref5.apply(this, arguments);
                            };
                          }()));

                          CLIENT_CONFIG.name = 'client-config';

                          // we have to remove all the invalid/empty plugins that may
                          // have been accidently added
                          CLIENT_CONFIG.plugins = CLIENT_CONFIG.plugins.filter(function (plugin) {
                            return plugin && ((0, _keys2.default)(plugin).length || plugin.apply);
                          });

                          // time to resolve with the processed config for the webpack
                          // merged with into the default settings
                          resolve(deepMerge({}, COMMON_CONFIG, CLIENT_CONFIG));

                          //     if (USED_EXTENSIONS.has('.vue')) {
                          //       CLIENT_CONFIG.module.rules.push({
                          //         test: /\.vue$/,
                          //         // use: [
                          //         //   // { loader: FURTHER_REF + 'vue-style-loader' },
                          //         //   // { loader: FURTHER_REF + 'style-loader' },
                          //         //   // { loader: FURTHER_REF + 'css-loader' },
                          //         //   // { loader: FURTHER_REF + 'less-loader' },
                          //         //   // { loader: FURTHER_REF + 'styl-loader' },
                          //         //   // { loader: FURTHER_REF + 'sass-loader' },
                          //         //   // { loader: FURTHER_REF + 'babel-loader' },
                          //         //   { loader: FURTHER_REF + 'vue-html-loader' },
                          //         // ],

                          //         loader: FURTHER_REF + 'vue-loader',
                          //         options: {
                          //           // presets: [
                          //           //   [ FURTHER_REF + 'babel-preset-es2015', { loose: true, modules: false } ],
                          //           //   FURTHER_REF + 'vue-loader'
                          //           // ],
                          //           loaders: {
                          //             js: FURTHER_REF + 'babel-loader',
                          //             css: FURTHER_REF + 'vue-style-loader!'+ FURTHER_REF +'css-loader'
                          //             // css: FURTHER_REF + 'vue-style-loader'
                          //           },
                          //           // extractCSS: true,
                          //           // postcss: [postCSSNext()]
                          //         }
                          //       })
                          //     }

                          //     // rules for react (preact)
                          //     if (USED_EXTENSIONS.has('.jsx')) {
                          //       CLIENT_CONFIG.module.rules.push({
                          //         test: /\.jsx$/,
                          //         // loaders: ['react-hot', 'babel-loader'],
                          //         loader: FURTHER_REF + 'babel-loader',
                          //         // FURTHER_REF + 'babel-loader',
                          //         // loader: `${ FURTHER_REF }react-loader?presets[]=${ FURTHER_REF }react!${ FURTHER_REF }babel-preset-es2015?` + JSON.stringify({),
                          //         exclude: /node_modules/,
                          //         options: {
                          //           plugins: [
                          //             [FURTHER_REF + "babel-plugin-transform-decorators-legacy"],
                          //             [FURTHER_REF + "babel-plugin-transform-react-jsx", { "pragma": "require('preact').h" }]
                          //           ],
                          //           presets: [
                          //             [ FURTHER_REF + "babel-preset-preact" ],
                          //             // [ FURTHER_REF + "babel-reset-preact/lib" ],
                          //             [ FURTHER_REF + 'babel-preset-es2015', { loose: true, modules: false } ]//,
                          //           ]
                          //         }
                          //       })
                          //       new webpack.ProvidePlugin({
                          //         h: path.resolve(FURTHER_REF, '../', '.meta/preact.h.js')
                          //       })
                          //     }

                          //     // rules for coffee script
                          //     if (USED_EXTENSIONS.has('.coffee')) {
                          //       CLIENT_CONFIG.module.rules.push({
                          //         test: /\.coffee$/,
                          //         // loader: require('coffee-loader?sourceMap=true') // coffeeLoader('!sourceMap=true')
                          //         use: [
                          //           {
                          //             loader: FURTHER_REF + 'coffee-loader',
                          //             options: { sourceMap: true }
                          //           }
                          //         ],
                          //         exclude: /node_modules/
                          //       })
                          //     }

                          //     // rules for typescript
                          //     if (USED_EXTENSIONS.has('.ts') || USED_EXTENSIONS.has('.tsx')) {
                          //       CLIENT_CONFIG.module.rules.push({
                          //         test: /\.ts(x?)$/,
                          //         loader: `${ FURTHER_REF }babel-loader?presets[]=${ FURTHER_REF }babel-preset-es2015!${ FURTHER_REF }ts-loader?` + JSON.stringify({
                          //             configFile: path.resolve(FURTHER_REF, '../', '.meta/tsconfig.json')
                          //         }),
                          //         exclude: /node_modules/
                          //       })
                          //     }

                          //     // rules for markups
                          //     CLIENT_CONFIG.module.rules.push({
                          //       test: /\.(htm|html|xhtml|hbs|handlebars|ejs|mustache|nunjucks)$/,      
                          //       loader: FURTHER_REF + 'htmllint-loader',
                          //       query: {
                          //         config: path.resolve(FURTHER_REF, '../', '.htmllintrc'),
                          //         failOnError: true,
                          //         failOnWarning: true
                          //       },
                          //       exclude: /node_modules/
                          //     })

                          //     // JSON/JSON5
                          //     CLIENT_CONFIG.module.rules.push({
                          //       test: /\.(json5|json)$/,
                          //       loader: FURTHER_REF + 'json5-loader',
                          //       exclude: /node_modules/
                          //     })

                          //     // Markdown and Texts
                          //     CLIENT_CONFIG.module.rules.push({
                          //       test: /\.(txt|md)$/,
                          //       loaders: [
                          //         FURTHER_REF + 'raw-loader'
                          //       ],
                          //       exclude: /node_modules/
                          //     })

                          //     CLIENT_CONFIG.module.rules.push({
                          //       test: /\.(html|htm)$/,
                          //       use: {
                          //         loader: FURTHER_REF + 'html-loader?interpolate',
                          //         options: {
                          //           attrs: [':data-src']
                          //         }
                          //       }
                          //     })
                          //     // RULES FOR STYLES
                          //     const CSS_LOADER = {
                          //       loader: FURTHER_REF + 'css-loader',
                          //       options: {
                          //           sourceMap: true,
                          //           minimize: !IS_DEV
                          //           // importLoaders: 1
                          //       }
                          //     }
                          //     const POST_CSS = {
                          //       loader: FURTHER_REF + 'postcss-loader',
                          //       options: {
                          //         sourceMap: true,
                          //         cssnext: true,
                          //         autoprefixer: true,
                          //         cssnano: true,
                          //         config: {
                          //           path: path.resolve(FURTHER_REF, '../', '.meta/postcss.config.js')
                          //         }
                          //       }
                          //     }
                          //     const RESOLVE_URL = {
                          //       loader: FURTHER_REF + 'resolve-url-loader',
                          //       options: {
                          //         limit: 10240
                          //       }
                          //     }
                          //     const STYLE_LOADER = {
                          //       loader: FURTHER_REF + 'style-loader',
                          //       options: {
                          //           sourceMap: true,
                          //           minimize: !IS_DEV,
                          //           importLoaders: 1,
                          //           discardComments: IS_DEV ? false : { removeAll: true },
                          //       }
                          //     }
                          //     // rules for css
                          //     CLIENT_CONFIG.module.rules.push({
                          //       test: /\.css$/,
                          //       // exclude: [/node_modules/],
                          //       use: ExtractTextPlugin.extract({
                          //         fallback: STYLE_LOADER,
                          //         use: [
                          //           CSS_LOADER,
                          //           RESOLVE_URL,
                          //           POST_CSS
                          //         ]
                          //       })
                          //     })

                          //     // rules for sass
                          //     if (USED_EXTENSIONS.has('.scss')) {
                          //       CLIENT_CONFIG.module.rules.push({
                          //         test: /\.(sass|scss)$/,
                          //         exclude: [/node_modules/],
                          //         use: ExtractTextPlugin.extract({
                          //           fallback: STYLE_LOADER,
                          //           use: [
                          //             CSS_LOADER,
                          //             RESOLVE_URL,
                          //             {
                          //               loader: FURTHER_REF + 'sass-loader',
                          //               options: {
                          //                   sourceMap: true
                          //               }
                          //             },
                          //             POST_CSS
                          //           ]
                          //         })
                          //       })
                          //     }
                          //     // rules for less
                          //     if (USED_EXTENSIONS.has('.less')) {
                          //       CLIENT_CONFIG.module.rules.push({
                          //         test: /\.less$/,
                          //         exclude: [/node_modules/],
                          //         use: ExtractTextPlugin.extract({
                          //           fallback: STYLE_LOADER,
                          //           use: [
                          //             CSS_LOADER,
                          //             RESOLVE_URL,
                          //             {
                          //               loader: FURTHER_REF + "less-loader",
                          //               options: {
                          //                   sourceMap: true
                          //               }
                          //             },
                          //             POST_CSS
                          //           ]
                          //         })
                          //       })
                          //     }
                          //     // ryles for stylus
                          //     if (USED_EXTENSIONS.has('.styl')) {
                          //       CLIENT_CONFIG.module.rules.push({
                          //         test: /\.(styl)$/,
                          //         // exclude: [/node_modules/],
                          //         use: ExtractTextPlugin.extract({
                          //           fallback: STYLE_LOADER,
                          //           use: [
                          //             // STYLE_LOADER,
                          //             CSS_LOADER,
                          //             // RESOLVE_URL,
                          //             {
                          //               loader: `${FURTHER_REF}stylus-loader`,
                          //               options: {
                          //                 // paths: `${FURTHER_REF}bootstrap-stylus/stylus/`
                          //                 paths: `${FURTHER_REF}bootstrap-styl`
                          //               }
                          //             }//,
                          //             // POST_CSS
                          //           ]
                          //         })
                          //       })
                          //     }
                          //     // a loader for the images. It will treat the way they are loaded/referenced/embeded in your files
                          //     CLIENT_CONFIG.module.rules.push({
                          //       test: /\.(png|jp(e)?g|gif|webp|svg)$/,
                          //       use: [
                          //         {
                          //           loader: FURTHER_REF + 'file-loader',
                          //           options: {
                          //             name: 'assets/[name]-[hash].[ext]' //,
                          //             // publicPath: 'public'
                          //           }
                          //         }
                          //       ]
                          //     })
                          //     // webpack must know how to resolve these files
                          //     CLIENT_CONFIG.resolve = {
                          //       extensions: [
                          //         ".webpack.js", ".web.js", ".js", ".ts", ".tsx", ".jsx",
                          //         "jpg", "png", "gif", "webp", "jpeg", "jpg", "svg",
                          //         ".html", ".tpl",
                          //         ".css", ".less", ".styl", ".sass", ".vue"
                          //       ], //, ".mjs", ".coffee", ".less", ".styl", ".sass" ],
                          //       alias: {
                          //         react: 'preact-compat',
                          //         'react-dom': 'preact-compat',
                          //         'react-addons-css-transition-group': 'react-addons-css-transition-group',
                          //         vue: 'vue',
                          //         Components: path.resolve(PROJECT_PATH, 'src/client/components/'),
                          //         Comps: path.resolve(PROJECT_PATH, 'src/client/components/'),
                          //         // Sprites: path.resolve(PROJECT_PATH, 'dist/sprites/sprite.css'),
                          //         Main: path.resolve(PROJECT_PATH, 'src/client/main/'),
                          //         Utils: path.resolve(PROJECT_PATH, 'src/isomorphic/'),
                          //         Templates: path.resolve(PROJECT_PATH, 'src/templates/')
                          //       },
                          //       modules: [
                          //         'furtherjs/node_modules',
                          //         'node_modules/furtherjs/node_modules',
                          //         'node_modules',
                          //         'spritesmith-generated'
                          //       ]
                          //     }
                          //     // const EventsPlugin = function() {};
                          //     // EventsPlugin.prototype.apply = function(compiler) {
                          //     //     compiler.plugin('after-plugins', function(watching) {
                          //     //         console.log('>>>>> PLUGIN RODOU');
                          //     //         // cb();
                          //     //     });
                          //     // };

                          // the plugins

                          //     // CLIENT_CONFIG.plugins.push(new EventsPlugin())

                          // if (!await fileExists(`${OUTPUT_PATH}/client/public/`)
                          //   && await fileExists(`${SRC_PATH}/client/public/`)) {
                          //     CLIENT_CONFIG.plugins.push(
                          //       new CopyWebpackPlugin([
                          //         {
                          //           from: `${SRC_PATH}/client/public/`,
                          //           to: `${OUTPUT_PATH}/client/public/`,
                          //           ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
                          //         }
                          //       ])
                          //     )
                          // }
                          // if (!await fileExists(`${OUTPUT_PATH}/client/main/assets`)
                          //   && await fileExists(`${SRC_PATH}/client/main/assets`)) {
                          //     CLIENT_CONFIG.plugins.push(
                          //       new CopyWebpackPlugin([
                          //         {
                          //           from: `${SRC_PATH}/client/main/assets`,
                          //           to: `${OUTPUT_PATH}/client/main/assets`,
                          //           ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
                          //         }
                          //       ])
                          //     )
                          // }
                          //     CLIENT_CONFIG.plugins.push(
                          //       new CopyWebpackPlugin([
                          //         {
                          //           from: `${SRC_PATH}/client/public/`,
                          //           to: `${OUTPUT_PATH}/client/`,
                          //           ignore: ['**/**/.DS_Store']
                          //         },
                          //         {
                          //           from: `${SRC_PATH}/client/main/assets`,
                          //           to: `${OUTPUT_PATH}/client/main/assets`,
                          //           ignore: ['**/**/.DS_Store']
                          //         },
                          //         {
                          //           from: `${SRC_PATH}/client/components/**/assets`,
                          //           to: `${OUTPUT_PATH}/client/components/assets`,
                          //           ignore: ['**/**/.DS_Store']
                          //         }
                          //       ])
                          //     )
                          //     // CLIENT_CONFIG.plugins.push(new UglifyJSPlugin())

                          //     // treating HTML and templates
                          //     CLIENT_CONFIG.plugins.push(new webpack.IgnorePlugin(/\.DS_Store$/, /node_modules/, /\.log/))
                          //     CLIENT_CONFIG.plugins.push(new HtmlWebpackPlugin({
                          //       title: opts.name || 'index',
                          //       filename: 'main/index.html',
                          //       template: './src/client/main/templates/index.html',
                          //       templates: [
                          //           // './src/client/main/templates/index.html',
                          //           './src/client/components/**/*.html',
                          //       ],
                          //       inject: true,
                          //       excludeAssets: [/style([\.\-].*)?\.js/, /\.DS_Store/],
                          //       minify: IS_DEV ? false : {
                          //         caseSensitive: true,
                          //         collapseBooleanAttributes: true,
                          //         collapseWhitespace: true,
                          //         conservativeCollapse: true,
                          //         minifyCSS: true,
                          //         minifyJS: true,
                          //         removeAttributeQuotes: true,
                          //         removeComments: true,
                          //         removeScriptTypeAttributes: true,
                          //         removeStyleLinkTypeAttributes: true,
                          //         sortAttributes: true,
                          //         sortClassName: true,
                          //         useShortDoctype: true
                          //       },
                          //       chunksSortMode: function (chunk1, chunk2) {
                          //         /**
                          //          * We will sort the dependencies following these rules:
                          //          * 
                          //          * - Vendors come first (for rests and libs for exampe)
                          //          * - Main styles come first
                          //          * - Component styles come second (taking care of precedences)
                          //          * - Main scripts come first
                          //          * - Component scripts come later
                          //          */
                          //         const chunkPart1 = chunk1.names[0]
                          //         const chunkPart2 = chunk2.names[0]
                          //         if (chunkPart1.startsWith('vendor')) {
                          //           return -9
                          //         }
                          //         if (chunkPart2.startsWith('vendor')) {
                          //           return 9
                          //         }
                          //         if (chunkPart1.startsWith('main')) {
                          //           if (chunkPart1.endsWith('.js')) {
                          //             return -2
                          //           }
                          //           return -5
                          //         }
                          //         if (chunkPart2.startsWith('main')) {
                          //           if (chunkPart2.endsWith('.js')) {
                          //             return 2
                          //           }
                          //           return 5
                          //         }
                          //         return -1
                          //         // let order2 = orders.indexOf(chunk2.names[0]);

                          //         // return order1 - order2;
                          //       },
                          //       prefetch: ['**/*.woff'],
                          //       preload: ['/vendors/**/*.js', '/main/**/*.js', '/main/**/*.css'],
                          //       alwaysWriteToDisk: true,
                          //       chunks: {
                          //         head: {},
                          //         main: {

                          //         }
                          //       }
                          //     }))
                          //     CLIENT_CONFIG.plugins.push(new ResourceHintWebpackPlugin())

                          //     // CLIENT_CONFIG.plugins.push(new HtmlWebpackHarddiskPlugin())

                          //     // external modules should not be embeded in bundles
                          //     // CLIENT_CONFIG.externals = ['preact', 'preact-compat', 'react', 'react-dom']
                          //     // CLIENT_CONFIG.externals = {
                          //     //   React: /react/i,
                          //     //   render: /react-drom/i,
                          //     //   lodash : {
                          //     //     commonjs: "lodash",
                          //     //     amd: "lodash",
                          //     //     root: "_" // indicates global variable
                          //     //   }
                          //     // }

                          //     // treating sprites
                          // let shouldAddSprites = false
                          //     CLIENT_CONFIG.plugins.push(new ExtractTextPlugin("[name].css"))

                          // }


                          //     if (IS_DEV) {
                          //       // CLIENT_CONFIG.plugins.push(new HtmlReloadPlugin())
                          //     }


                          //     // extra optimizations for production environment
                          //     // (or if enabled for optimization in development mode)

                          //     // Critical paths
                          //     CLIENT_CONFIG.plugins.push(new WebpackOnBuildPlugin(function(stats) {
                          //       critical.generate({
                          //         inline: true,
                          //         minify: true,
                          //         extract: true,
                          //         timeout: 30000,
                          //         base: PROJECT_PATH + '/dist/client/',
                          //         src: 'main/index.html',
                          //         dest: 'main/index-critical.html',
                          //         width: 1300,
                          //         height: 900
                          //       })
                          //     }))
                          //     // treating images
                          //     CLIENT_CONFIG.plugins.push(new ImageminPlugin({
                          //       disable: !opts.development.optmizeImages && IS_DEV, // Disabled by default during development
                          //       optipng: { optimizationLevel: 9 },
                          //       gifsicle: { optimizationLevel: 3, interlaced: true },
                          //       jpegtran: { optimizationLevel: 5 },
                          //       svgo: { optimizationLevel: 5 },
                          //       webp: { quality: 75 },
                          //       pngquant: {
                          //         quality: '65-90',
                          //         speed: 4
                          //       },
                          //       plugins: [
                          //         imageminMozjpeg({
                          //           quality: 90
                          //         }),
                          //         imageminPngcrush(),
                          //         // imageminWebp() // for some reason, this is corrupting jpg files :o
                          //       ]  
                          //     }))
                          // if (FILES_TO_APPEND.length) {
                          //   _INCLUDE_ASSETS({ FILES_TO_APPEND }, CLIENT_CONFIG)
                          //   // FILES_TO_APPEND.forEach(file => {
                          //   //   if (typeof file === 'string' || file.assets && file.assets.length) {
                          //   //     CLIENT_CONFIG.plugins.push(new HtmlWebpackIncludeAssetsPlugin({
                          //   //       assets: file,
                          //   //       append: false
                          //   //     }))
                          //   //   }
                          //   // })
                          // }
                          //     if (opts.client) {
                          //       if (opts.client.prependFiles) {
                          //         opts.client.prependFiles.forEach(file => {
                          //           CLIENT_CONFIG.plugins.push(new HtmlWebpackIncludeAssetsPlugin({
                          //             assets: file,
                          //             append: false,
                          //             silent: true,
                          //             publicPath: false
                          //           }))
                          //         })
                          //       }
                          //       if (opts.client.appendFiles) {
                          //         opts.client.appendFiles.forEach(file => {
                          //           CLIENT_CONFIG.plugins.push(new HtmlWebpackIncludeAssetsPlugin({
                          //             assets: file,
                          //             append: true,
                          //             publicPath: false
                          //           }))
                          //         })
                          //       }
                          //     }
                          //     CLIENT_CONFIG.plugins.push(new StyleLintPlugin({
                          //       files: ['src/**/*.s?(a|c)ss', 'src/**/*.less'],
                          //       quiet: true,
                          //       failOnError: false,
                          //       emitErrors: false,
                          //       configFile: path.resolve(PROJECT_PATH, './.further/.stylelintrc.json')
                          //     }))


                          //     // Extra optmizations
                          //     if (!IS_DEV || opts.development.optimize) {
                          //       CLIENT_CONFIG.plugins.push(new webpack.LoaderOptionsPlugin({
                          //         minimize: true
                          //       }))
                          //       // CLIENT_CONFIG.plugins.push(new webpack.optimize.CommonsChunkPlugin({
                          //       //   name: 'polifills',
                          //       //   filename: 'babel-polyfills',
                          //       //   // chunks: []
                          //       // }))
                          //       // CLIENT_CONFIG.plugins.push(new webpack.optimize.DedupePlugin())
                          //       CLIENT_CONFIG.plugins.push(new webpack.optimize.AggressiveMergingPlugin())
                          //       CLIENT_CONFIG.plugins.push(new webpack.optimize.UglifyJsPlugin({
                          //         minimize: true,
                          //         test: /\.(js|css)($|\?)/i,
                          //         include: 'dist',
                          //         ecma: 8,
                          //         // include: path.resolve(PROJECT_PATH, 'dist')
                          //       }))
                          //       CLIENT_CONFIG.plugins.push(new CompressionPlugin({
                          //         asset: "[path].gz[query]",
                          //         algorithm: "gzip",
                          //         test: /\.(js|css|html|htm)$/,
                          //         threshold: 10240,
                          //         minRatio: 0.8
                          //       }))
                          //       // CLIENT_CONFIG.plugins.push(new webpack.optimize.minimize())
                          //       // CLIENT_CONFIG.plugins.push(new webpack.optimize.UglifyJsPlugin({
                          //       //   minimize: true,
                          //       //   test: /\.(js|css)($|\?)/i,
                          //       //   include: 'dist',
                          //       //   ecma: 8,
                          //       //   // include: path.resolve(PROJECT_PATH, 'dist')
                          //       // }))
                          //     }

                          //     // and let's return the config for the client, merged with the default config

                        case 77:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _callee4, _this);
                }));

                return function (_x5, _x6) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 13:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function configureClient(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return configureClient;
  }();
});

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_172__;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod);
    global.entries = mod.exports;
  }
})(this, function (module) {
  'use strict';

  module.exports = function (state) {
    return {
      // 'vendors/reset-css': state.FURTHER_REF + 'reset-css/reset.css',
      'vendors/babel-polifills': [state.FURTHER_REF + 'core-js/es6/function', state.FURTHER_REF + 'core-js/es6/map', state.FURTHER_REF + 'core-js/es6/math', state.FURTHER_REF + 'core-js/es6/number', state.FURTHER_REF + 'core-js/es6/object', state.FURTHER_REF + 'core-js/es6/regexp', state.FURTHER_REF + 'core-js/es6/string', state.FURTHER_REF + 'core-js/fn/array/includes'],
      // 'react': ['preact-compat'],

      //       // // 'babel-polyfill': 'babel-polyfill',
      //       // // 'core-js': 'core-js',
      //       // // 'core-js/es6/array': 'core-js/es6/array',

      //       // 'vendors/core-js/es6/function': 'core-js/es6/function',
      //       // 'vendors/core-js/es6/map': 'core-js/es6/map',
      //       // 'vendors/core-js/es6/math': 'core-js/es6/math',
      //       // 'vendors/core-js/es6/number': 'core-js/es6/number',
      //       // 'vendors/core-js/es6/object': 'core-js/es6/object',
      //       // // 'core-js/es6/promise': 'core-js/es6/promise',
      //       // 'vendors/core-js/es6/regexp': 'core-js/es6/regexp',
      //       // 'vendors/core-js/es6/string': 'core-js/es6/string',
      //       // 'vendors/core-js/fn/array/includes': 'core-js/fn/array/includes',
      //    'vendors/webpack-hot-middleware/client': 'webpack-hot-middleware/client',
      'main/index': state.SRC_PATH + '/client/main/'
    };
  };
});

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('path'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.path);
        global.resolvers = mod.exports;
    }
})(this, function (module, path) {
    "use strict";

    module.exports = function (state) {
        return {
            extensions: [".webpack.js", ".web.js", ".js", ".mjs", ".ts", ".tsx", ".jsx", ".vue", "coffee", "jpg", "png", "gif", "webp", "jpeg", "jpg", "svg", ".html", ".tpl", ".htm", ".css", ".less", ".styl", ".sass"],
            alias: {
                react: 'preact-compat',
                'react-dom': 'preact-compat',
                'react-addons-css-transition-group': 'react-addons-css-transition-group',
                vue: 'vue',
                Components: path.resolve(state.PROJECT_PATH, 'src/client/components/'),
                Comps: path.resolve(state.PROJECT_PATH, 'src/client/components/'),
                // Sprites: path.resolve(PROJECT_PATH, 'dist/sprites/sprite.css'),
                Main: path.resolve(state.PROJECT_PATH, 'src/client/main/'),
                Utils: path.resolve(state.PROJECT_PATH, 'src/isomorphic/'),
                Templates: path.resolve(state.PROJECT_PATH, 'src/templates/')
            },
            modules: ['furtherjs/node_modules', 'node_modules/furtherjs/node_modules', 'node_modules', 'spritesmith-generated']
        };
    };
});

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('path'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.path);
        global.output = mod.exports;
    }
})(this, function (module, path) {
    'use strict';

    module.exports = function (state) {
        return {
            path: path.resolve(state.OUTPUT_PATH, 'client'),
            filename: '[name].js',
            chunkFilename: '[name]-[id].js',
            publicPath: '/',
            // libraryTarget: 'commonjs-module',
            libraryExport: 'default'
        };
    };
});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(12), __webpack_require__(58)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('try-require'), require('webpack'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.tryRequire, global.webpack);
        global.optimizations = mod.exports;
    }
})(this, function (module, tryRequire, webpack) {
    'use strict';

    module.exports = function (state, opts, config) {
        var CompressionPlugin = tryRequire('compression-webpack-plugin');
        if (!CompressionPlugin) {
            return {}; // waiting for an installation
        }

        config.plugins.push(new webpack.LoaderOptionsPlugin({
            minimize: true
        }));
        // config.plugins.push(new webpack.optimize.CommonsChunkPlugin({
        //   name: 'polifills',
        //   filename: 'babel-polyfills',
        //   // chunks: []
        // }))
        // config.plugins.push(new webpack.optimize.DedupePlugin())
        config.plugins.push(new webpack.optimize.AggressiveMergingPlugin());
        config.plugins.push(new webpack.optimize.UglifyJsPlugin({
            minimize: true,
            test: /\.(js|css)($|\?)/i,
            include: 'dist',
            ecma: 8
            // include: path.resolve(PROJECT_PATH, 'dist')
        }));
        config.plugins.push(new CompressionPlugin({
            asset: "[path].gz[query]",
            algorithm: "gzip",
            test: /\.(js|css|html|htm)$/,
            threshold: 10240,
            minRatio: 0.8
        }));
        // config.plugins.push(new webpack.optimize.minimize())
        // config.plugins.push(new webpack.optimize.UglifyJsPlugin({
        //   minimize: true,
        //   test: /\.(js|css)($|\?)/i,
        //   include: 'dist',
        //   ecma: 8,
        //   // include: path.resolve(PROJECT_PATH, 'dist')
        // }))
    };
});

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod);
        global.react = mod.exports;
    }
})(this, function (module) {
    "use strict";

    module.exports = function (paths) {
        var FURTHER_REF = paths.FURTHER_REF;

        return {
            test: /\.jsx$/,
            // loaders: ['react-hot', 'babel-loader'],
            loader: FURTHER_REF + 'babel-loader',
            // FURTHER_REF + 'babel-loader',
            // loader: `${ FURTHER_REF }react-loader?presets[]=${ FURTHER_REF }react!${ FURTHER_REF }babel-preset-es2015?` + JSON.stringify({),
            exclude: /node_modules/,
            options: {
                plugins: [[FURTHER_REF + "babel-plugin-transform-decorators-legacy"], [FURTHER_REF + "babel-plugin-transform-react-jsx", { "pragma": "require('preact').h" }]],
                presets: [[FURTHER_REF + "babel-preset-preact"],
                // [ FURTHER_REF + "babel-reset-preact/lib" ],
                [FURTHER_REF + 'babel-preset-es2015', { loose: true, modules: false }]]
            }
        };
    };
});

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod);
        global.vue = mod.exports;
    }
})(this, function (module) {
    'use strict';

    module.exports = function (paths) {
        var FURTHER_REF = paths.FURTHER_REF;

        return {
            test: /\.vue$/,
            // use: [
            //   // { loader: FURTHER_REF + 'vue-style-loader' },
            //   // { loader: FURTHER_REF + 'style-loader' },
            //   // { loader: FURTHER_REF + 'css-loader' },
            //   // { loader: FURTHER_REF + 'less-loader' },
            //   // { loader: FURTHER_REF + 'styl-loader' },
            //   // { loader: FURTHER_REF + 'sass-loader' },
            //   // { loader: FURTHER_REF + 'babel-loader' },
            //   { loader: FURTHER_REF + 'vue-html-loader' },
            // ],

            loader: FURTHER_REF + 'vue-loader',
            options: {
                // presets: [
                //   [ FURTHER_REF + 'babel-preset-es2015', { loose: true, modules: false } ],
                //   FURTHER_REF + 'vue-loader'
                // ],
                loaders: {
                    js: FURTHER_REF + 'babel-loader',
                    css: FURTHER_REF + 'vue-style-loader!' + FURTHER_REF + 'css-loader'
                    // css: FURTHER_REF + 'vue-style-loader'
                }
                // extractCSS: true,
                // postcss: [postCSSNext()]
            }
        };
    };
});

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('path'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.path);
        global.markups = mod.exports;
    }
})(this, function (module, path) {
    'use strict';

    module.exports = function (paths) {
        var FURTHER_REF = paths.FURTHER_REF;
        return {
            test: /\.(htm|html|xhtml|hbs|handlebars|ejs|mustache|nunjucks|tpl)$/,
            loader: FURTHER_REF + 'htmllint-loader',
            query: {
                config: path.resolve(FURTHER_REF, '../', '.htmllintrc'),
                failOnError: true,
                failOnWarning: true
            },
            exclude: /node_modules/
        };
    };
});

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod);
        global.markdown = mod.exports;
    }
})(this, function (module) {
    'use strict';

    module.exports = function (paths) {
        var FURTHER_REF = paths.FURTHER_REF;
        return {
            test: /\.(txt|md)$/,
            loaders: [FURTHER_REF + 'raw-loader'],
            exclude: /node_modules/
        };
    };
});

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('try-require'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.tryRequire);
        global.icons = mod.exports;
    }
})(this, function (module, tryRequire) {
    'use strict';

    module.exports = function create(state, opts, config) {
        try {
            var FaviconsWebpackPlugin = tryRequire('favicons-webpack-plugin');
            var HtmlWebpackExcludeAssetsPlugin = tryRequire('html-webpack-exclude-assets-plugin');

            if (!FaviconsWebpackPlugin || !HtmlWebpackExcludeAssetsPlugin) {
                return {}; // waiting for an installation
            }

            config.plugins.push(new FaviconsWebpackPlugin({
                logo: opts.icon,
                prefix: 'icons/',
                statsFilename: 'iconstats-[hash].json',
                persistentCache: true,
                inject: true,
                emitStats: false,
                icons: state.IS_DEV ? {
                    android: false,
                    appleIcon: false,
                    appleStartup: false,
                    coast: false,
                    favicons: true,
                    firefox: false,
                    opengraph: false,
                    twitter: false,
                    yandex: false,
                    windows: false
                } : {
                    android: true,
                    appleIcon: true,
                    appleStartup: true,
                    coast: false,
                    favicons: true,
                    firefox: true,
                    opengraph: false,
                    twitter: false,
                    yandex: false,
                    windows: false
                }
            }));
            // removing unused assets
            return new HtmlWebpackExcludeAssetsPlugin();
        } catch (error) {
            // is probably still needing some dependency installation
        }
    };
});

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, require('try-require'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, global.tryRequire);
    global.html = mod.exports;
  }
})(this, function (module, tryRequire) {
  'use strict';

  module.exports = function (state, opts, config) {
    var HtmlWebpackPlugin = tryRequire('html-webpack-plugin');
    var ResourceHintWebpackPlugin = tryRequire('resource-hints-webpack-plugin');
    var FURTHER_REF = state.FURTHER_REF;

    if (!HtmlWebpackPlugin || !ResourceHintWebpackPlugin) {
      return {}; // waiting for an installation
    }

    // HTML plugin
    config.plugins.push(new HtmlWebpackPlugin({
      title: opts.name || 'index',
      filename: 'main/index.html',
      template: './src/client/main/templates/index.html',
      templates: ['./src/client/components/**/*.html'],
      inject: true,
      excludeAssets: [/style([\.\-].*)?\.js/, /\.DS_Store/],
      minify: state.IS_DEV ? false : {
        caseSensitive: true,
        collapseBooleanAttributes: true,
        collapseWhitespace: true,
        conservativeCollapse: true,
        minifyCSS: true,
        minifyJS: true,
        removeAttributeQuotes: true,
        removeComments: true,
        removeScriptTypeAttributes: true,
        // removeStyleLinkTypeAttributes: true,
        sortAttributes: true,
        sortClassName: true,
        useShortDoctype: true
      },
      chunksSortMode: function chunksSortMode(chunk1, chunk2) {
        /**
         * We will sort the dependencies following these rules:
         * 
         * - Vendors come first (for rests and libs for exampe)
         * - Main styles come first
         * - Component styles come second (taking care of precedences)
         * - Main scripts come first
         * - Component scripts come later
         */
        var chunkPart1 = chunk1.names[0];
        var chunkPart2 = chunk2.names[0];
        if (chunkPart1.startsWith('vendor')) {
          return -9;
        }
        if (chunkPart2.startsWith('vendor')) {
          return 9;
        }
        if (chunkPart1.startsWith('main')) {
          if (chunkPart1.endsWith('.js')) {
            return -2;
          }
          return -5;
        }
        if (chunkPart2.startsWith('main')) {
          if (chunkPart2.endsWith('.js')) {
            return 2;
          }
          return 5;
        }
        return -1;
        // let order2 = orders.indexOf(chunk2.names[0]);

        // return order1 - order2;
      },
      prefetch: ['**/*.woff', '**/*.otf', '**/*.ttf', '**/*.'],
      preload: ['/vendors/**/*.js', '/main/**/*.js', '/main/**/*.css'],
      alwaysWriteToDisk: true,
      chunks: {
        head: {},
        main: {}
      }
    }));
    config.plugins.push(new ResourceHintWebpackPlugin());

    return {
      test: /\.(html|htm)$/,
      use: {
        loader: FURTHER_REF + 'html-loader?interpolate',
        options: {
          attrs: [':data-src']
        }
      }
    };
  };
});

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(61), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('copy-webpack-plugin'), require('path'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.copyWebpackPlugin, global.path);
        global.http = mod.exports;
    }
})(this, function (module, _copyWebpackPlugin, path) {
    'use strict';

    var _copyWebpackPlugin2 = _interopRequireDefault(_copyWebpackPlugin);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    module.exports = function (state, opts, config) {
        var FURTHER_REF = state.FURTHER_REF;
        var OUTPUT_PATH = state.OUTPUT_PATH;
        return new _copyWebpackPlugin2.default([{
            // copying the SERVER STARTER file
            from: path.join(FURTHER_REF, '../dist/tpls/server/', 'further-http-server.js'),
            to: path.join(OUTPUT_PATH, 'server/index.js'),
            ignore: ['**/**/.DS_Store', '**/**/.gitkeep'],
            transform: function transform(content) {
                // replacing some marks/tokens
                content = content.toString();
                content = content.replace("${DEV_SERVER_PORT}", opts.server ? opts.server.port || 'null' : 'null');
                return Buffer.from(content, 'utf8');
            }
        }, {
            // copying the SERVER STARTER file
            from: path.join(FURTHER_REF, '../dist/tpls/server/', 'redirect.html'),
            to: path.join(OUTPUT_PATH, 'client/index.html'),
            ignore: ['**/**/.DS_Store', '**/**/.gitkeep']
            // transform: (content) => {
            //     // replacing some marks/tokens
            //     content = content.toString()
            //     content = content.replace("${DEV_SERVER_PORT}", opts.server ? opts.server.port || 'null' : 'null')
            //     return Buffer.from(content, 'utf8')
            // }
        }]);
    };
});

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod);
    global.images = mod.exports;
  }
})(this, function (module) {
  'use strict';

  module.exports = function (paths, config) {
    var FURTHER_REF = paths.FURTHER_REF;
    return {
      test: /\.(png|jp(e)?g|gif|webp|svg|ttf|woff|woff2)$/,
      use: [{
        loader: FURTHER_REF + 'file-loader',
        options: {
          name: 'assets/[name]-[hash].[ext]' //,
          // publicPath: 'public'
        }
      }, {
        loader: FURTHER_REF + 'url-loader',
        options: {
          name: 'assets/[name]-[hash].[ext]',
          limit: 10000
        }
      }]
    };
  };
});

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(12), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module, require('try-require'), require('path'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, global.tryRequire, global.path);
    global.sprites = mod.exports;
  }
})(this, function (module, tryRequire, path) {
  'use strict';

  module.exports = function (state, opts, config) {
    var SpritesmithPlugin = tryRequire('webpack-spritesmith');

    if (!SpritesmithPlugin) {
      return {}; // waiting for an installation
    }

    return new SpritesmithPlugin({
      src: {
        cwd: path.resolve(state.PROJECT_PATH, 'src/client/'),
        glob: '**/sprites/**/*.png'
      },
      target: {
        image: 'dist/client/sprites/sprite.png',
        css: 'dist/client/sprites/sprite.css'
      },
      apiOptions: {
        cssImageRef: "sprite.png",
        generateSpriteName: function generateSpriteName(fullPath) {
          // shouldAddSprites = true
          fullPath = path.basename(fullPath);
          return fullPath.replace(/\.[^\.]+$/, '');
        }
      }
    });
  };
});

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(4), __webpack_require__(187), __webpack_require__(12), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('babel-runtime/core-js/promise'), require('./move-main'), require('try-require'), require('fs-extra'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.promise, global.moveMain, global.tryRequire, global.fsExtra);
        global.critical = mod.exports;
    }
})(this, function (module, _promise, _moveMain, tryRequire, fs) {
    'use strict';

    var _promise2 = _interopRequireDefault(_promise);

    var _moveMain2 = _interopRequireDefault(_moveMain);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    module.exports = function (state, opts, config) {
        var critical = tryRequire('critical');
        var WebpackOnBuildPlugin = tryRequire('on-build-webpack');

        if (!WebpackOnBuildPlugin || !critical) {
            return {}; // waiting for an installation
        }

        return new WebpackOnBuildPlugin(function (_) {
            return new _promise2.default(function (resolve, reject) {
                var res = function res(_) {
                    (0, _moveMain2.default)(state, opts, config).then(resolve).catch(reject);
                };
                if (fs.existsSync(state.PROJECT_PATH + '/dist/client/main/index.html')) {
                    critical.generate({
                        inline: true,
                        minify: true,
                        extract: true,
                        timeout: 30000,
                        base: state.PROJECT_PATH + '/dist/client/',
                        src: 'main/index.html',
                        dest: 'main/index-critical.html',
                        width: 1300,
                        height: 900
                    }).then(res).catch(reject);
                } else {
                    res();
                }
            });
        });
    };
});

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(4), __webpack_require__(12), __webpack_require__(8), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('babel-runtime/core-js/promise'), require('try-require'), require('fs-extra'), require('path'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.promise, global.tryRequire, global.fsExtra, global.path);
        global.moveMain = mod.exports;
    }
})(this, function (module, _promise, tryRequire, fs, path) {
    'use strict';

    var _promise2 = _interopRequireDefault(_promise);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    module.exports = function (state, opts, config) {
        return new _promise2.default(function (resolve, reject) {
            resolve();
            // fs.move(
            //     path.resolve(state.OUTPUT_PATH, 'client/main/'),
            //     path.resolve(state.OUTPUT_PATH, 'client/'),
            //     err => {
            //         if (err) {
            //             reject(err)
            //         } else {
            //             resolve()
            //         }
            //     }
            // )
        });
    };
});

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('try-require'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.tryRequire);
        global.optimizeImages = mod.exports;
    }
})(this, function (module, tryRequire) {
    'use strict';

    module.exports = function (state, opts, config) {

        var ImageminPlugin = tryRequire('imagemin-webpack-plugin');
        var imageminMozjpeg = tryRequire('imagemin-mozjpeg');
        var imageminPngcrush = tryRequire('imagemin-pngcrush');

        if (!ImageminPlugin || !imageminMozjpeg || !imageminPngcrush) {
            return {}; // waiting for an installation
        }

        // const FURTHER_REF = paths.FURTHER_REF
        return new ImageminPlugin({
            disable: !opts.development.optmizeImages && state.IS_DEV, // Disabled by default during development
            optipng: { optimizationLevel: 9 },
            gifsicle: { optimizationLevel: 3, interlaced: true },
            jpegtran: { optimizationLevel: 5 },
            svgo: { optimizationLevel: 5 },
            webp: { quality: 75 },
            pngquant: {
                quality: '65-90',
                speed: 4
            },
            plugins: [imageminMozjpeg({
                quality: 90
            }), imageminPngcrush()]
        });
    };
});

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('try-require'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.tryRequire);
        global.includeAssets = mod.exports;
    }
})(this, function (module, tryRequire) {
    'use strict';

    module.exports = function (state, opts, config) {
        var HtmlWebpackIncludeAssetsPlugin = tryRequire('html-webpack-include-assets-plugin');

        if (!HtmlWebpackIncludeAssetsPlugin) {
            return {}; // waiting for an installation
        }

        // const FURTHER_REF = paths.FURTHER_REF
        var FILES_TO_APPEND = state.FILES_TO_APPEND;
        if (FILES_TO_APPEND.length) {
            FILES_TO_APPEND.forEach(function (file) {
                if (typeof file === 'string' || file.assets && file.assets.length) {
                    config.plugins.push(new HtmlWebpackIncludeAssetsPlugin({
                        assets: file,
                        append: false
                    }));
                }
            });
        }

        if (opts.client) {
            if (opts.client.prependFiles) {
                opts.client.prependFiles.forEach(function (file) {
                    config.plugins.push(new HtmlWebpackIncludeAssetsPlugin({
                        assets: file,
                        append: false,
                        silent: true,
                        publicPath: false
                    }));
                });
            }
            if (opts.client.appendFiles) {
                opts.client.appendFiles.forEach(function (file) {
                    config.plugins.push(new HtmlWebpackIncludeAssetsPlugin({
                        assets: file,
                        append: true,
                        publicPath: false
                    }));
                });
            }
        }
    };
});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('path'), require('try-require'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.path, global.tryRequire);
        global.styles = mod.exports;
    }
})(this, function (exports, _path, tryRequire) {
    'use strict';

    exports.__esModule = true;
    exports.CSS = CSS;
    exports.SASS = SASS;
    exports.LESS = LESS;
    exports.STYLUS = STYLUS;

    var _path2 = _interopRequireDefault(_path);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    function CSS_LOADER(paths) {
        return {
            loader: paths.FURTHER_REF + 'css-loader',
            options: {
                sourceMap: true,
                // modules: true,
                // imports: false,
                url: false,
                minimize: !paths.IS_DEV,
                importLoaders: 1
            }
        };
    }

    function POST_CSS(paths) {
        return {
            loader: paths.FURTHER_REF + 'postcss-loader',
            options: {
                sourceMap: true,
                cssnext: true,
                autoprefixer: true,
                cssnano: true,
                config: {
                    path: _path2.default.resolve(paths.FURTHER_REF, '../', '.meta/postcss.config.js')
                }
            }
        };
    }

    function RESOLVE_URL(paths) {
        // return {
        //     loader: paths.FURTHER_REF + 'url-loader',
        //     options: {
        //         limit: 10240
        //     }
        // }
        return {
            loader: paths.FURTHER_REF + 'resolve-url-loader',
            options: {
                limit: 10240
            }
        };
    }

    function STYLE_LOADER(paths) {
        return {
            loader: paths.FURTHER_REF + 'style-loader',
            options: {
                sourceMap: true,
                minimize: !paths.IS_DEV,
                importLoaders: 1,
                discardComments: paths.IS_DEV ? false : { removeAll: true }
            }
        };
    }

    function CSS(paths, config) {
        var ExtractTextPlugin = tryRequire('extract-text-webpack-plugin');
        if (!ExtractTextPlugin) {
            return {};
        } // waiting for an installation

        config.plugins = config.plugins || [];
        config.plugins.push(new ExtractTextPlugin("[name].css"));

        return {
            test: /\.css$/,
            exclude: [/node_modules/],
            use: ExtractTextPlugin.extract({
                fallback: STYLE_LOADER(paths),
                use: [CSS_LOADER(paths), POST_CSS(paths), RESOLVE_URL(paths)]
            })
        };
    }

    function SASS(paths) {
        var ExtractTextPlugin = tryRequire('extract-text-webpack-plugin');
        if (!ExtractTextPlugin) {
            return {};
        } // waiting for an installation

        // rules for sass
        return {
            test: /\.(sass|scss)$/,
            exclude: [/node_modules/],
            use: ExtractTextPlugin.extract({
                fallback: STYLE_LOADER(paths),
                use: [CSS_LOADER(paths), RESOLVE_URL(paths), {
                    loader: paths.FURTHER_REF + 'sass-loader',
                    options: {
                        sourceMap: true
                    }
                }, POST_CSS(paths)]
            })
        };
    }

    function LESS(paths) {
        var ExtractTextPlugin = tryRequire('extract-text-webpack-plugin');
        if (!ExtractTextPlugin) {
            return {};
        } // waiting for an installation

        // rules for less
        return {
            test: /\.less$/,
            exclude: [/node_modules/],
            use: ExtractTextPlugin.extract({
                fallback: STYLE_LOADER(paths),
                use: [CSS_LOADER(paths), RESOLVE_URL(paths), {
                    loader: paths.FURTHER_REF + "less-loader",
                    options: {
                        sourceMap: true
                    }
                }, POST_CSS(paths)]
            })
        };
    }

    function STYLUS(paths) {
        var ExtractTextPlugin = tryRequire('extract-text-webpack-plugin');
        if (!ExtractTextPlugin) {
            return {};
        } // waiting for an installation

        // rules for less
        return {
            test: /\.(styl)$/,
            // exclude: [/node_modules/],
            use: ExtractTextPlugin.extract({
                fallback: STYLE_LOADER(paths),
                use: [
                // STYLE_LOADER,
                CSS_LOADER(paths),
                // RESOLVE_URL,
                {
                    loader: paths.FURTHER_REF + 'stylus-loader',
                    options: {
                        // paths: `${FURTHER_REF}bootstrap-stylus/stylus/`
                        paths: paths.FURTHER_REF + 'bootstrap-styl'
                    } //,
                    // POST_CSS
                }]
            })
        };
    }
});

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(12), __webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('try-require'), require('path'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.tryRequire, global.path);
        global.styleLint = mod.exports;
    }
})(this, function (module, tryRequire, path) {
    'use strict';

    module.exports = function (state) {
        var StyleLintPlugin = tryRequire('stylelint-webpack-plugin');
        if (!StyleLintPlugin) {
            return {}; // waiting for an installation
        }

        return new StyleLintPlugin({
            files: ['src/**/*.s?(a|c)ss', 'src/**/*.less'],
            quiet: true,
            failOnError: false,
            emitErrors: false,
            configFile: path.resolve(state.PROJECT_PATH, './.further/.stylelintrc.json')
        });
    };
});

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(193), __webpack_require__(203), __webpack_require__(57)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(exports, require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('babel-runtime/helpers/classCallCheck'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.possibleConstructorReturn, global.inherits, global.classCallCheck);
        global.partialClass = mod.exports;
    }
})(this, function (exports, _possibleConstructorReturn2, _inherits2, _classCallCheck2) {
    'use strict';

    exports.__esModule = true;

    var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

    var _inherits3 = _interopRequireDefault(_inherits2);

    var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var Partial = function () {
        function Partial() {
            (0, _classCallCheck3.default)(this, Partial);

            // Getting constructor name.
            // This is the custom component name created.
            var componentName = this.constructor.name;

            // Creating a valid custom element name.
            // In the future we'll probably need to use some validator.
            // Sindre Sorhus' validate-element-name is a good option:
            // https://github.com/sindresorhus/validate-element-name
            var elementName = componentName.split(/(?=[A-Z])/).map(function (s) {
                return s.toLowerCase();
            }).join('-');

            // Definig the custom elemement.
            // This is a very basic implementation.
            // In the future we need to include a polyfill and validade
            // if it's the best approach.
            window.customElements.define(elementName, function (_HTMLElement) {
                (0, _inherits3.default)(PartialBase, _HTMLElement);

                function PartialBase() {
                    (0, _classCallCheck3.default)(this, PartialBase);
                    return (0, _possibleConstructorReturn3.default)(this, _HTMLElement.call(this));
                }

                // TODO: Implement shadow DOM
                // Below is an example on how to use it.

                //   var shadow = this.attachShadow({mode: 'open'});
                // Create a standard img element and set it's attributes.
                //   var div = document.createElement('div');
                //   div.innerHTML = 'DIV';

                // Add the image to the shadow root.
                //   shadow.appendChild(div);

                // Add an event listener to the image.
                //   div.addEventListener('click', () => {
                //     console.log('DIV CLICK')
                //   });


                // TODO: Implement observer
                // Perhaps this is a good approach, but I'm not sure yet.
                // Example below:
                /* static get observedAttributes() {return ['name']; }
                connectedCallback() {
                    console.log('connected')
                }
                 attributeChangedCallback(attr, oldValue, newValue) {
                    console.log(newValue)
                }*/


                return PartialBase;
            }(HTMLElement));
        }

        // Exposing the render method statically.
        // E.g: You can use `Partial.render`.
        // The bad thing about it is we don't have instances control.
        // Let's try this way first, but need more investigation.
        // @params
        // - partialElement: The class extending Partial
        // - component: The component string. E.g: <my-component>
        // - node: The target DOM node where the component will be appended


        Partial.render = function render(partialElement, component) {
            var node = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document.body;
            var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { mode: 'closed' };

            // Mapped props from the component attributes
            // E.g: <my-component foo='bar'> should map the prop `foo` with `baz` as value.
            partialElement.props = {};

            // Target element reference
            var targetElement = null;

            // The @node param could be a String or a DOMNode.
            // This is the simplest way of doing it, I'm sure we can evolve
            // this for something better.
            // First, check if it is an instance of HTMLElement
            if (node instanceof HTMLElement) {
                targetElement = node;
                // Check if it's a String
            } else if (typeof node === 'string') {
                targetElement = document.querySelector('#' + node);
                // Simple check to validate if the node target element exists
                if (targetElement === null) {
                    throw new Error('Invalid HTML selector');
                }
            }

            // Creating a DOMFragment element (just in memory)
            var fragment = document.createDocumentFragment();

            // this is the customElement root node
            var rootElement = document.createElement('div');
            rootElement = rootElement.attachShadow({ mode: options.mode });

            // Let the browser do the work of parsing the custom element.
            // Here we're appending the custom element inside the rootElement.
            // Again, not sure if it's the best approach. Need investigation.
            rootElement.innerHTML = component;

            // Now, let's get the custom element reference.
            // Need investigation as well.
            var webComponent = rootElement.firstChild;

            // Parse all custom element attributes and tranform into instance props.
            for (var i = 0, atts = webComponent.attributes, n = atts.length, arr = []; i < n; i++) {
                partialElement.props[atts[i].nodeName] = atts[i].nodeValue;
            }

            // the result of rendering the component
            var componentContent = partialElement.render();

            // let's apply a shadow dom to it
            var shad = webComponent.attachShadow({ mode: 'open' });

            // and use the component itself as the shadow's content
            shad.innerHTML = componentContent;

            // and finaly we append the element to the fragment
            fragment.appendChild(webComponent);
            // and the fragment to the target element
            targetElement.appendChild(fragment);
        };

        return Partial;
    }();

    exports.default = Partial;
});

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(195), __esModule: true };

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28);
__webpack_require__(38);
module.exports = __webpack_require__(62).f('iterator');


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(197), __esModule: true };

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(198);
__webpack_require__(49);
__webpack_require__(201);
__webpack_require__(202);
module.exports = __webpack_require__(1).Symbol;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(3);
var has = __webpack_require__(20);
var DESCRIPTORS = __webpack_require__(14);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(66);
var META = __webpack_require__(56).KEY;
var $fails = __webpack_require__(19);
var shared = __webpack_require__(46);
var setToStringTag = __webpack_require__(30);
var uid = __webpack_require__(34);
var wks = __webpack_require__(5);
var wksExt = __webpack_require__(62);
var wksDefine = __webpack_require__(63);
var enumKeys = __webpack_require__(199);
var isArray = __webpack_require__(78);
var anObject = __webpack_require__(11);
var isObject = __webpack_require__(9);
var toIObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(41);
var createDesc = __webpack_require__(24);
var _create = __webpack_require__(37);
var gOPNExt = __webpack_require__(200);
var $GOPD = __webpack_require__(97);
var $DP = __webpack_require__(10);
var $keys = __webpack_require__(25);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(96).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(35).f = $propertyIsEnumerable;
  __webpack_require__(48).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(36)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(16)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(25);
var gOPS = __webpack_require__(48);
var pIE = __webpack_require__(35);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(22);
var gOPN = __webpack_require__(96).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(63)('asyncIterator');


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(63)('observable');


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(204);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(208);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(95);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(205), __esModule: true };

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(206);
module.exports = __webpack_require__(1).Object.setPrototypeOf;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(207).set });


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(9);
var anObject = __webpack_require__(11);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(13)(Function.call, __webpack_require__(97).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(209), __esModule: true };

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(210);
var $Object = __webpack_require__(1).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(37) });


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// index.js